import { Object } from 'graphql/customScalars';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  Object: { input: Object; output: Object; }
};

export type AddBankAccountInput = {
  accountName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  sortCode: Scalars['String']['input'];
};

export type AddBidComparisonAnalyticInput = {
  bidId: Scalars['Int']['input'];
  tenderId: Scalars['Int']['input'];
};

export type AddBidInput = {
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  averageWholesalePrice: Scalars['Float']['input'];
  brandId: Scalars['Int']['input'];
  files: Array<FileInput>;
  freeStockNotes?: InputMaybe<Scalars['String']['input']>;
  freeStockUnitsAmount?: InputMaybe<Scalars['Int']['input']>;
  isAnonymous: Scalars['Boolean']['input'];
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  listingFeeNotes?: InputMaybe<Scalars['String']['input']>;
  listingFeeTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  otherSupport?: InputMaybe<Scalars['String']['input']>;
  packagingType: Scalars['String']['input'];
  posBudgetNotes?: InputMaybe<Scalars['String']['input']>;
  posBudgetTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  productCategoryId: Scalars['Int']['input'];
  productName: Scalars['String']['input'];
  productUrl?: InputMaybe<Scalars['String']['input']>;
  retroDiscountAmountPerUnit?: InputMaybe<Scalars['Float']['input']>;
  retroDiscountNotes?: InputMaybe<Scalars['String']['input']>;
  subscriptionTier?: InputMaybe<SubscriptionTier>;
  successFee?: InputMaybe<Scalars['Float']['input']>;
  supportsFreeStock?: InputMaybe<Scalars['Boolean']['input']>;
  supportsListingFee?: InputMaybe<Scalars['Boolean']['input']>;
  supportsPosBudget?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRetroDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  tenderId: Scalars['Int']['input'];
  unitType: Scalars['String']['input'];
  volumeUnits: Scalars['Int']['input'];
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type AddBidsToMultipleTendersInput = {
  bidData: AddMultipleBidInput;
  tenderIds: Array<Scalars['Int']['input']>;
};

export type AddMessageInput = {
  bidId: Scalars['Int']['input'];
  brandId?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  venueId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddMultipleBidInput = {
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  averageWholesalePrice: Scalars['Float']['input'];
  brandId: Scalars['Int']['input'];
  files: Array<FileInput>;
  freeStockNotes?: InputMaybe<Scalars['String']['input']>;
  freeStockUnitsAmount?: InputMaybe<Scalars['Int']['input']>;
  isAnonymous: Scalars['Boolean']['input'];
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  listingFeeNotes?: InputMaybe<Scalars['String']['input']>;
  listingFeeTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  otherSupport?: InputMaybe<Scalars['String']['input']>;
  packagingType: Scalars['String']['input'];
  posBudgetNotes?: InputMaybe<Scalars['String']['input']>;
  posBudgetTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  productCategoryId: Scalars['Int']['input'];
  productName: Scalars['String']['input'];
  productUrl?: InputMaybe<Scalars['String']['input']>;
  retroDiscountAmountPerUnit?: InputMaybe<Scalars['Float']['input']>;
  retroDiscountNotes?: InputMaybe<Scalars['String']['input']>;
  subscriptionTier?: InputMaybe<SubscriptionTier>;
  successFee?: InputMaybe<Scalars['Float']['input']>;
  supportsFreeStock?: InputMaybe<Scalars['Boolean']['input']>;
  supportsListingFee?: InputMaybe<Scalars['Boolean']['input']>;
  supportsPosBudget?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRetroDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  unitType: Scalars['String']['input'];
  volumeUnits: Scalars['Int']['input'];
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type AddProductCategorySubscriptionInput = {
  brandId: Scalars['Int']['input'];
  stripeProductId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type AddProductTemplateInput = {
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  averageWholesalePrice: Scalars['Float']['input'];
  brandId: Scalars['Int']['input'];
  files?: InputMaybe<Array<FileInput>>;
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  packagingType: Scalars['String']['input'];
  productCategoryId: Scalars['Int']['input'];
  productName: Scalars['String']['input'];
  productUrl?: InputMaybe<Scalars['String']['input']>;
  unitType: Scalars['String']['input'];
  volumeUnits: Scalars['Int']['input'];
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type AddPromoDealInput = {
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  averageWholesalePrice: Scalars['Float']['input'];
  brandId: Scalars['Int']['input'];
  files?: InputMaybe<Array<FileInput>>;
  freeStockNotes?: InputMaybe<Scalars['String']['input']>;
  freeStockUnitsAmount?: InputMaybe<Scalars['Int']['input']>;
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible: Scalars['Boolean']['input'];
  listingFeeNotes?: InputMaybe<Scalars['String']['input']>;
  listingFeeTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  otherSupport?: InputMaybe<Scalars['String']['input']>;
  packagingType: Scalars['String']['input'];
  posBudgetNotes?: InputMaybe<Scalars['String']['input']>;
  posBudgetTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  productCategoryId: Scalars['Int']['input'];
  productName: Scalars['String']['input'];
  productUrl?: InputMaybe<Scalars['String']['input']>;
  region: Region;
  retroDiscountAmountPerUnit?: InputMaybe<Scalars['Float']['input']>;
  retroDiscountNotes?: InputMaybe<Scalars['String']['input']>;
  status: PromoDealStatus;
  supportsFreeStock?: InputMaybe<Scalars['Boolean']['input']>;
  supportsListingFee?: InputMaybe<Scalars['Boolean']['input']>;
  supportsPosBudget?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRetroDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  unitType: Scalars['String']['input'];
  volumeUnits: Scalars['Int']['input'];
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type AddTenderDraftInput = {
  estimatedVolume?: InputMaybe<Scalars['Int']['input']>;
  files: Array<FileInput>;
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  listingEndsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  listingStartsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  listingTypeId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  packagingType?: InputMaybe<Scalars['String']['input']>;
  productCategoryId: Scalars['Int']['input'];
  supportDetails?: InputMaybe<Scalars['String']['input']>;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  tenderDetails?: InputMaybe<Scalars['String']['input']>;
  tenderEndsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  tenderStartsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
  venueId: Scalars['Int']['input'];
  volumeDetails?: InputMaybe<Scalars['String']['input']>;
  volumeUnits?: InputMaybe<Scalars['Int']['input']>;
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type AddTenderInput = {
  estimatedVolume: Scalars['Int']['input'];
  files: Array<FileInput>;
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  listingEndsAtUtc: Scalars['Date']['input'];
  listingStartsAtUtc: Scalars['Date']['input'];
  listingTypeId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  packagingType: Scalars['String']['input'];
  productCategoryId: Scalars['Int']['input'];
  supportDetails?: InputMaybe<Scalars['String']['input']>;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  tenderDetails?: InputMaybe<Scalars['String']['input']>;
  tenderEndsAtUtc: Scalars['Date']['input'];
  tenderStartsAtUtc: Scalars['Date']['input'];
  unitType: Scalars['String']['input'];
  venueId: Scalars['Int']['input'];
  volumeDetails?: InputMaybe<Scalars['String']['input']>;
  volumeUnits: Scalars['Int']['input'];
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type Address = {
  __typename?: 'Address';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  coordinates: Point;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
};

export type AddressByPlaceIdInput = {
  googlePlacesSessionToken: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  region: Region;
};

export type AvatarUrlInput = {
  bucketKey: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type AwrsDetails = {
  __typename?: 'AwrsDetails';
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
};

export type BankAccount = {
  __typename?: 'BankAccount';
  accountName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  sortCode: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type BespokeCheckData = {
  __typename?: 'BespokeCheckData';
  pricePerMonth: Scalars['Float']['output'];
  successFee: Scalars['Float']['output'];
};

export type Bid = {
  __typename?: 'Bid';
  areWholesalersCompatible?: Maybe<Scalars['Boolean']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice?: Maybe<Scalars['Float']['output']>;
  brand?: Maybe<Brand>;
  brandId: Scalars['Int']['output'];
  createdAtUtc?: Maybe<Scalars['Date']['output']>;
  files?: Maybe<Array<File>>;
  freeStockNotes?: Maybe<Scalars['String']['output']>;
  freeStockUnitsAmount?: Maybe<Scalars['Int']['output']>;
  hasOtherBidsForThisVenue?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  isFreeStockProvided?: Maybe<Scalars['Boolean']['output']>;
  isFreeStockReceived?: Maybe<Scalars['Boolean']['output']>;
  isListingFeeProvided?: Maybe<Scalars['Boolean']['output']>;
  isListingFeeReceived?: Maybe<Scalars['Boolean']['output']>;
  isPosBudgetProvided?: Maybe<Scalars['Boolean']['output']>;
  isPosBudgetReceived?: Maybe<Scalars['Boolean']['output']>;
  isRatingOutdated?: Maybe<Scalars['Boolean']['output']>;
  isRetroDiscountProvided?: Maybe<Scalars['Boolean']['output']>;
  isRetroDiscountReceived?: Maybe<Scalars['Boolean']['output']>;
  listingFeeNotes?: Maybe<Scalars['String']['output']>;
  listingFeeTotalAmount?: Maybe<Scalars['Float']['output']>;
  messagesCount?: Maybe<Scalars['Int']['output']>;
  netPrice?: Maybe<Scalars['Float']['output']>;
  otherSupport?: Maybe<Scalars['String']['output']>;
  packagingType?: Maybe<Scalars['String']['output']>;
  posBudgetNotes?: Maybe<Scalars['String']['output']>;
  posBudgetTotalAmount?: Maybe<Scalars['Float']['output']>;
  productCategory?: Maybe<ProductCategory>;
  productCategoryId?: Maybe<Scalars['Int']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productUrl?: Maybe<Scalars['String']['output']>;
  ratedAtUtc?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  ratingComment?: Maybe<Scalars['String']['output']>;
  ratingFeedbackValues?: Maybe<Array<RatingFeedbackValue>>;
  region: Region;
  retroDiscountAmountPerUnit?: Maybe<Scalars['Float']['output']>;
  retroDiscountNotes?: Maybe<Scalars['String']['output']>;
  status: BidStatus;
  subscriptionTier: SubscriptionTier;
  successFee?: Maybe<Scalars['Float']['output']>;
  successFeeInvoiceId?: Maybe<Scalars['String']['output']>;
  supportsFreeStock?: Maybe<Scalars['Boolean']['output']>;
  supportsListingFee?: Maybe<Scalars['Boolean']['output']>;
  supportsPosBudget?: Maybe<Scalars['Boolean']['output']>;
  supportsRetroDiscount?: Maybe<Scalars['Boolean']['output']>;
  tender: Tender;
  tenderId: Scalars['Int']['output'];
  totalSupportValue?: Maybe<Scalars['Float']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  volumeUnits?: Maybe<Scalars['Int']['output']>;
  wholesalers?: Maybe<Array<Wholesaler>>;
};

export enum BidStatus {
  Deleted = 'DELETED',
  Lost = 'LOST',
  New = 'NEW',
  Won = 'WON'
}

export enum BidSupportType {
  FreeStock = 'FREE_STOCK',
  ListingFee = 'LISTING_FEE',
  PosBudget = 'POS_BUDGET',
  RetroDiscount = 'RETRO_DISCOUNT'
}

export type Bids = {
  __typename?: 'Bids';
  data: Array<Bid>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BidsFilterOptionsInput = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  tenderId?: InputMaybe<Scalars['Int']['input']>;
  venueId?: InputMaybe<Scalars['Int']['input']>;
};

export type BidsFiltersInput = {
  bidStatus?: InputMaybe<BidStatus>;
  brandIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  excludeBrandId?: InputMaybe<Scalars['Int']['input']>;
  excludeWinningBids?: InputMaybe<Scalars['Boolean']['input']>;
  tenderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type BidsInput = {
  filter?: InputMaybe<BidsFiltersInput>;
  pagination: OffsetPaginationInput;
  sort?: InputMaybe<BidsSortInput>;
};

export enum BidsOrderByEnum {
  BidIds = 'BID_IDS',
  EstimatedVolume = 'ESTIMATED_VOLUME',
  NetPrice = 'NET_PRICE',
  Price = 'PRICE',
  Rating = 'RATING',
  RecentlyAdded = 'RECENTLY_ADDED',
  Status = 'STATUS',
  SupportProvided = 'SUPPORT_PROVIDED',
  SupportReceived = 'SUPPORT_RECEIVED',
  TimeLeft = 'TIME_LEFT',
  TotalSupport = 'TOTAL_SUPPORT',
  WholesalerCompatibility = 'WHOLESALER_COMPATIBILITY'
}

export type BidsSortInput = {
  bidIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  isSupportProvidedFirst?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<BidsOrderByEnum>;
  orderDirection?: InputMaybe<SortDirectionEnum>;
  supportType?: InputMaybe<BidSupportType>;
};

export type Brand = {
  __typename?: 'Brand';
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  awrsCompanyName?: Maybe<Scalars['String']['output']>;
  awrsDeregistrationDate?: Maybe<Scalars['String']['output']>;
  awrsNumber?: Maybe<Scalars['String']['output']>;
  awrsPlaceBusiness?: Maybe<Scalars['String']['output']>;
  awrsRegistrationDate?: Maybe<Scalars['String']['output']>;
  awrsStatus?: Maybe<Scalars['String']['output']>;
  canCreateBid: Scalars['Boolean']['output'];
  canSeeOtherBids: Scalars['Boolean']['output'];
  complianceCheckDate?: Maybe<Scalars['String']['output']>;
  complianceConfirmation?: Maybe<Scalars['String']['output']>;
  complianceNextDate?: Maybe<Scalars['String']['output']>;
  complianceRiskLevel?: Maybe<Scalars['String']['output']>;
  failedPaymentIntentCounter: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  hasActiveSubscription: Scalars['Boolean']['output'];
  hasBids: Scalars['Boolean']['output'];
  hasProductTemplates: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  isAnonymousBidAllowed?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseSubscriptionRequestSent: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  productCategories: Array<ProductCategory>;
  region: Region;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePaymentLink?: Maybe<Scalars['String']['output']>;
  stripeProductPriceId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionTier: SubscriptionTier;
  successFee: Scalars['Float']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  vatCompanyName?: Maybe<Scalars['String']['output']>;
  vatConsultationNumber?: Maybe<Scalars['String']['output']>;
  vatCountryCode?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatProcessingDate?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export enum BrandDashboardBidStatus {
  ActiveBids = 'ACTIVE_BIDS',
  LostBids = 'LOST_BIDS',
  WonBids = 'WON_BIDS'
}

export type BrandDashboardFilterOptionsInput = {
  status?: InputMaybe<BrandDashboardBidStatus>;
};

export type BrandDashboardMetric = {
  __typename?: 'BrandDashboardMetric';
  label: BrandDashboardMetricLabel;
  type: DashboardMetricType;
  value: Scalars['String']['output'];
};

export enum BrandDashboardMetricLabel {
  CurrentOfferedSupport = 'CURRENT_OFFERED_SUPPORT',
  NewTendersPublished = 'NEW_TENDERS_PUBLISHED',
  PossibleTotalMerchandiseValue = 'POSSIBLE_TOTAL_MERCHANDISE_VALUE',
  TotalEstimatedVolume = 'TOTAL_ESTIMATED_VOLUME',
  TotalMerchandiseValue = 'TOTAL_MERCHANDISE_VALUE',
  TotalSupport = 'TOTAL_SUPPORT'
}

export type BrandDashboardWonBidsSortInput = {
  isProvidedFirst: Scalars['Boolean']['input'];
  sortBySupport: BidSupportType;
};

export type BrandSettings = {
  __typename?: 'BrandSettings';
  brandId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isNewTenderInAppNotificationEnabled: Scalars['Boolean']['output'];
  isNewTenderMailNotificationEnabled: Scalars['Boolean']['output'];
  isRatingProvidedInAppNotificationEnabled: Scalars['Boolean']['output'];
  isRatingProvidedMailNotificationEnabled: Scalars['Boolean']['output'];
  isTenderUpdatedInAppNotificationEnabled: Scalars['Boolean']['output'];
  isTenderUpdatedMailNotificationEnabled: Scalars['Boolean']['output'];
};

export type Brands = {
  __typename?: 'Brands';
  data: Array<Brand>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CancelSubscriptionInput = {
  brandId: Scalars['Int']['input'];
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type CancelSubscriptionNewInAppInput = {
  brandId: Scalars['Int']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type CancelSubscriptionNewRetoolInput = {
  brandId: Scalars['Int']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type ChangeEmailInput = {
  email: Scalars['String']['input'];
};

export type ChooseWinnerInput = {
  bidIds: Array<Scalars['Int']['input']>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  tenderId: Scalars['Int']['input'];
};

export type CompanyVatDetails = {
  __typename?: 'CompanyVatDetails';
  vatCompanyName: Scalars['String']['output'];
  vatConsultationNumber: Scalars['String']['output'];
  vatCountryCode: Scalars['String']['output'];
  vatNumber: Scalars['String']['output'];
  vatProcessingDate: Scalars['String']['output'];
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat: Scalars['String']['output'];
  lng: Scalars['String']['output'];
};

export type CoordinatesInput = {
  lat: Scalars['String']['input'];
  lng: Scalars['String']['input'];
};

export type CreateBankTransferSubscriptionInput = {
  brandId: Scalars['Int']['input'];
  pricePerMonth: Scalars['Int']['input'];
  successFee: Scalars['Float']['input'];
};

export type CreateBespokePaymentLinkInput = {
  brandId: Scalars['Int']['input'];
  pricePerMonth: Scalars['Int']['input'];
  successFee: Scalars['Float']['input'];
};

export type CreateStripeCheckoutInput = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  firebaseId: Scalars['String']['input'];
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  subscriptionTier: SubscriptionTier;
};

export type CreateStripeCheckoutNewInput = {
  brandId: Scalars['Int']['input'];
  firebaseId: Scalars['String']['input'];
  returnUrl?: InputMaybe<Scalars['String']['input']>;
  stripeProductId: Scalars['String']['input'];
};

export type CursorNotifications = CursorPagination & {
  __typename?: 'CursorNotifications';
  edges: Array<NotificationEdge>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
  unreadTotalCount: Scalars['Int']['output'];
};

export type CursorNotificationsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  category: NotificationCategory;
  first: Scalars['Int']['input'];
  toId: Scalars['Int']['input'];
  toType: NotificationTargetType;
};

export type CursorPageInfo = {
  __typename?: 'CursorPageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type CursorPagination = {
  edges: Array<Edge>;
  pageInfo: CursorPageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CursorPaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export enum DashboardMetricType {
  Global = 'GLOBAL',
  Personalised = 'PERSONALISED'
}

export type DeleteBidInput = {
  bidId: Scalars['Int']['input'];
};

export type DeleteProductTemplateInput = {
  brandId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type Edge = {
  cursor: Scalars['String']['output'];
  node: Node;
};

export type EditBankAccountInput = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  sortCode?: InputMaybe<Scalars['String']['input']>;
};

export type EditBidInput = {
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  files: Array<FileInput>;
  freeStockNotes?: InputMaybe<Scalars['String']['input']>;
  freeStockUnitsAmount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  listingFeeNotes?: InputMaybe<Scalars['String']['input']>;
  listingFeeTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  otherSupport?: InputMaybe<Scalars['String']['input']>;
  posBudgetNotes?: InputMaybe<Scalars['String']['input']>;
  posBudgetTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  retroDiscountAmountPerUnit?: InputMaybe<Scalars['Float']['input']>;
  retroDiscountNotes?: InputMaybe<Scalars['String']['input']>;
  supportsFreeStock?: InputMaybe<Scalars['Boolean']['input']>;
  supportsListingFee?: InputMaybe<Scalars['Boolean']['input']>;
  supportsPosBudget?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRetroDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type EditBidSupportStatusInput = {
  bidId: Scalars['Int']['input'];
  brandId?: InputMaybe<Scalars['Int']['input']>;
  supportToChange: BidSupportType;
  tenderId: Scalars['Int']['input'];
  venueId?: InputMaybe<Scalars['Int']['input']>;
};

export type EditBrandInput = {
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  awrsCompanyName?: InputMaybe<Scalars['String']['input']>;
  awrsDeregistrationDate?: InputMaybe<Scalars['String']['input']>;
  awrsNumber?: InputMaybe<Scalars['String']['input']>;
  awrsPlaceBusiness?: InputMaybe<Scalars['String']['input']>;
  awrsRegistrationDate?: InputMaybe<Scalars['String']['input']>;
  awrsStatus?: InputMaybe<Scalars['String']['input']>;
  canSeeOtherBids?: InputMaybe<Scalars['Boolean']['input']>;
  complianceCheckDate?: InputMaybe<Scalars['String']['input']>;
  complianceConfirmation?: InputMaybe<Scalars['String']['input']>;
  complianceNextDate?: InputMaybe<Scalars['String']['input']>;
  complianceRiskLevel?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  isAnonymousBidAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  productCategoriesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  vatCompanyName?: InputMaybe<Scalars['String']['input']>;
  vatConsultationNumber?: InputMaybe<Scalars['String']['input']>;
  vatCountryCode?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  vatProcessingDate?: InputMaybe<Scalars['String']['input']>;
  webPageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EditBrandSettingsInput = {
  brandId: Scalars['Int']['input'];
  isNewTenderInAppNotificationEnabled: Scalars['Boolean']['input'];
  isNewTenderMailNotificationEnabled: Scalars['Boolean']['input'];
  isRatingProvidedInAppNotificationEnabled: Scalars['Boolean']['input'];
  isRatingProvidedMailNotificationEnabled: Scalars['Boolean']['input'];
  isTenderUpdatedInAppNotificationEnabled: Scalars['Boolean']['input'];
  isTenderUpdatedMailNotificationEnabled: Scalars['Boolean']['input'];
};

export type EditProductTemplateInput = {
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  averageWholesalePrice: Scalars['Float']['input'];
  brandId: Scalars['Int']['input'];
  files: Array<FileInput>;
  id: Scalars['Int']['input'];
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  packagingType: Scalars['String']['input'];
  productCategoryId: Scalars['Int']['input'];
  productName: Scalars['String']['input'];
  productUrl?: InputMaybe<Scalars['String']['input']>;
  unitType: Scalars['String']['input'];
  volumeUnits: Scalars['Int']['input'];
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type EditPromoDealInput = {
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  averageWholesalePrice?: InputMaybe<Scalars['Float']['input']>;
  brandId?: InputMaybe<Scalars['Int']['input']>;
  files: Array<FileInput>;
  freeStockNotes?: InputMaybe<Scalars['String']['input']>;
  freeStockUnitsAmount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible: Scalars['Boolean']['input'];
  listingFeeNotes?: InputMaybe<Scalars['String']['input']>;
  listingFeeTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  otherSupport?: InputMaybe<Scalars['String']['input']>;
  packagingType?: InputMaybe<Scalars['String']['input']>;
  posBudgetNotes?: InputMaybe<Scalars['String']['input']>;
  posBudgetTotalAmount?: InputMaybe<Scalars['Float']['input']>;
  productCategoryId?: InputMaybe<Scalars['Int']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productUrl?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region>;
  retroDiscountAmountPerUnit?: InputMaybe<Scalars['Float']['input']>;
  retroDiscountNotes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PromoDealStatus>;
  supportsFreeStock?: InputMaybe<Scalars['Boolean']['input']>;
  supportsListingFee?: InputMaybe<Scalars['Boolean']['input']>;
  supportsPosBudget?: InputMaybe<Scalars['Boolean']['input']>;
  supportsRetroDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
  volumeUnits?: InputMaybe<Scalars['Int']['input']>;
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type EditTenderDraftInput = {
  estimatedVolume?: InputMaybe<Scalars['Int']['input']>;
  files: Array<FileInput>;
  id: Scalars['Int']['input'];
  isAnyWholesalerCompatible: Scalars['Boolean']['input'];
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  listingEndsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  listingStartsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  listingTypeId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  packagingType?: InputMaybe<Scalars['String']['input']>;
  productCategoryId: Scalars['Int']['input'];
  supportDetails?: InputMaybe<Scalars['String']['input']>;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  tenderDetails?: InputMaybe<Scalars['String']['input']>;
  tenderEndsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  tenderStartsAtUtc?: InputMaybe<Scalars['Date']['input']>;
  unitType?: InputMaybe<Scalars['String']['input']>;
  volumeDetails?: InputMaybe<Scalars['String']['input']>;
  volumeUnits?: InputMaybe<Scalars['Int']['input']>;
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type EditTenderInput = {
  estimatedVolume: Scalars['Int']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  files: Array<FileInput>;
  id: Scalars['Int']['input'];
  isAnyWholesalerCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate: Scalars['Boolean']['input'];
  listingEndsAtUtc: Scalars['Date']['input'];
  listingStartsAtUtc: Scalars['Date']['input'];
  listingTypeId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  packagingType: Scalars['String']['input'];
  productCategoryId: Scalars['Int']['input'];
  status: TenderStatus;
  supportDetails?: InputMaybe<Scalars['String']['input']>;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  tenderDetails?: InputMaybe<Scalars['String']['input']>;
  tenderEndsAtUtc: Scalars['Date']['input'];
  tenderStartsAtUtc: Scalars['Date']['input'];
  unitType: Scalars['String']['input'];
  volumeDetails?: InputMaybe<Scalars['String']['input']>;
  volumeUnits: Scalars['Int']['input'];
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type EditTenderPreferenceInput = {
  id: Scalars['Int']['input'];
  isAnyWholesalerCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectSupplyCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  supportDetails?: InputMaybe<Scalars['String']['input']>;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  venueId: Scalars['Int']['input'];
  wholesalersIds: Array<Scalars['Int']['input']>;
};

export type EditVenueInput = {
  address: GoogleAddressInput;
  avatarBucketKey?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  googlePlacesSessionToken: Scalars['String']['input'];
  groupName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  venueCategoryName: Scalars['String']['input'];
  webPageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EditVenueSettingsInput = {
  isBidUpdatedInAppNotificationEnabled: Scalars['Boolean']['input'];
  isBidUpdatedMailNotificationEnabled: Scalars['Boolean']['input'];
  isMyTenderEndedInAppNotificationEnabled: Scalars['Boolean']['input'];
  isMyTenderEndedMailNotificationEnabled: Scalars['Boolean']['input'];
  isNewBidsInAppNotificationEnabled: Scalars['Boolean']['input'];
  isNewBidsMailNotificationEnabled: Scalars['Boolean']['input'];
  isNewTenderInAppNotificationEnabled: Scalars['Boolean']['input'];
  isNewTenderMailNotificationEnabled: Scalars['Boolean']['input'];
  isReTenderInAppNotificationEnabled: Scalars['Boolean']['input'];
  isReTenderMailNotificationEnabled: Scalars['Boolean']['input'];
  venueId: Scalars['Int']['input'];
};

export enum EmailType {
  GetInTouch = 'GetInTouch',
  RequestDemo = 'RequestDemo',
  RequestEnterpriseSubscription = 'RequestEnterpriseSubscription',
  RequestPromoDeal = 'RequestPromoDeal'
}

export enum Feature {
  SalesDemo = 'SALES_DEMO'
}

export type File = {
  __typename?: 'File';
  bucketKey: Scalars['String']['output'];
  context: FileContext;
  downloadUrl: Scalars['String']['output'];
  fileSizeInKib: Scalars['Float']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export enum FileContext {
  BidDocument = 'BID_DOCUMENT',
  BidPosDocument = 'BID_POS_DOCUMENT',
  ProductAvatar = 'PRODUCT_AVATAR',
  ProductDocument = 'PRODUCT_DOCUMENT',
  TenderDocument = 'TENDER_DOCUMENT',
  TenderSalesVolumeData = 'TENDER_SALES_VOLUME_DATA',
  UserAvatar = 'USER_AVATAR'
}

export type FileInput = {
  bucketKey: Scalars['String']['input'];
  context: FileContext;
  fileSizeInKib: Scalars['Float']['input'];
  filename: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type Filter = {
  __typename?: 'Filter';
  label: Scalars['String']['output'];
  options: Array<FilterOption>;
};

export type FilterOption = {
  __typename?: 'FilterOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GetAwrsDetailsInput = {
  awrsNumber: Scalars['String']['input'];
};

export type GetCompanyVatDetailsInput = {
  vatNumber: Scalars['String']['input'];
};

export type GetDataFromCompanyNumberInput = {
  companyNumber: Scalars['String']['input'];
};

export type GoogleAddress = {
  __typename?: 'GoogleAddress';
  administrativeAreLevel2ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel1ShortName?: Maybe<Scalars['String']['output']>;
  administrativeAreaLevel2?: Maybe<Scalars['String']['output']>;
  coordinates: Coordinates;
  country?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  placeId: Scalars['String']['output'];
  placeName: Scalars['String']['output'];
  postCode?: Maybe<Scalars['String']['output']>;
};

export type GoogleAddressInput = {
  administrativeAreLevel2ShortName?: InputMaybe<Scalars['String']['input']>;
  administrativeAreaLevel1?: InputMaybe<Scalars['String']['input']>;
  administrativeAreaLevel1ShortName?: InputMaybe<Scalars['String']['input']>;
  administrativeAreaLevel2?: InputMaybe<Scalars['String']['input']>;
  coordinates: CoordinatesInput;
  country?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  placeName: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
};

export type GoogleLocationByCoordinates = {
  __typename?: 'GoogleLocationByCoordinates';
  country?: Maybe<Scalars['String']['output']>;
};

export type HelloInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  createdAt: Scalars['Int']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type ListingType = {
  __typename?: 'ListingType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  region: Region;
  suggestedListingLengthInMonths: Scalars['Int']['output'];
  suggestedTenderLengthInMonths: Scalars['Int']['output'];
};

export type LiveStats = {
  __typename?: 'LiveStats';
  activeBidGrossMerchandiseValue: Scalars['Float']['output'];
  activeTenders: Scalars['Int']['output'];
};

export type LocationByCoordinatesInput = {
  latitude: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
};

export type MarkAllNotificationsAsReadInput = {
  category: NotificationCategory;
  toId: Scalars['Int']['input'];
  toType: NotificationTargetType;
};

export type Message = {
  __typename?: 'Message';
  bidId: Scalars['Int']['output'];
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['Int']['output']>;
  createdAtUtc: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  venue?: Maybe<Venue>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addBankAccount: BankAccount;
  addBid: Bid;
  addBidComparisonAnalytic: Scalars['Boolean']['output'];
  addBidsToMultipleTenders: Array<Bid>;
  addMessage: Message;
  addProductCategorySubscription: Scalars['Boolean']['output'];
  addProductTemplate: ProductTemplate;
  addPromoDeal: PromoDeal;
  addTender: Tender;
  addTenderDraft: TenderDraft;
  addUserActionLog: UserActionLog;
  cancelSubscription: Scalars['Boolean']['output'];
  cancelSubscriptionNewInApp: Scalars['Boolean']['output'];
  cancelSubscriptionNewRetool: Scalars['Boolean']['output'];
  changeEmail: User;
  chooseWinner: Tender;
  cleanupSalesDemoData: Scalars['Boolean']['output'];
  confirmChangeEmail: Scalars['Boolean']['output'];
  createBankTransferSubscription: Scalars['Boolean']['output'];
  createBespokePaymentLink: Scalars['String']['output'];
  createStripeCheckout: Scalars['String']['output'];
  createStripeCheckoutNew: Scalars['String']['output'];
  deleteBidById: Scalars['Boolean']['output'];
  deleteProductTemplateById: Scalars['Boolean']['output'];
  deletePromoDealById: Scalars['Boolean']['output'];
  deleteTenderById: Scalars['Boolean']['output'];
  deleteTenderDraftById: Scalars['Boolean']['output'];
  editBankAccount: BankAccount;
  editBid: Bid;
  editBidSupportStatus: Bid;
  editBrand: Brand;
  editBrandSettings: BrandSettings;
  editProductTemplate: ProductTemplate;
  editPromoDeal: PromoDeal;
  editTender: Tender;
  editTenderDraft: TenderDraft;
  editTenderPreference: TenderPreference;
  editVenue: Venue;
  editVenueSettings: VenueSettings;
  generateUploadUrls: Array<UploadUrlItem>;
  markAllNotificationsAsRead: Array<Notification>;
  markNotificationAsRead: Notification;
  rateBid: Bid;
  removeProductCategorySubscription: Scalars['Boolean']['output'];
  requestChangeEmail: Scalars['Boolean']['output'];
  requestEmail: Scalars['Boolean']['output'];
  requestSalesDemoBids: Array<Bid>;
  retoolChangeBidStatus: Bid;
  retoolChangeTenderAllBidsStatus: Array<Bid>;
  retoolChangeTenderStatus: Tender;
  retoolEditBrand: Brand;
  salesDemoSignUp: Scalars['Boolean']['output'];
  sampleRequest: Scalars['Boolean']['output'];
  sendBankTransferInvoiceNotPaidEmail: Scalars['Boolean']['output'];
  sendDailyNewBidsReport: Scalars['Boolean']['output'];
  sendDailyNewTenderBrandReport: Scalars['Boolean']['output'];
  sendDailyRatingReport: Scalars['Boolean']['output'];
  sendReTenderEmail: Scalars['Boolean']['output'];
  sendSelectWinnerEmail: Scalars['Boolean']['output'];
  sendTenderEndsInTwoDaysEmail: Scalars['Boolean']['output'];
  signInAsUser: Scalars['String']['output'];
  signUp: Scalars['String']['output'];
  supportCalculator: Scalars['Boolean']['output'];
  syncTenderStatuses: Scalars['Boolean']['output'];
  updateCompanyBillingData: User;
  updateSubscription: Scalars['Boolean']['output'];
  upgradeProductCategorySubscription: Scalars['Boolean']['output'];
  upgradeToBespoke: UpgradeToBespokeData;
};


export type MutationAddBankAccountArgs = {
  input: AddBankAccountInput;
};


export type MutationAddBidArgs = {
  input: AddBidInput;
};


export type MutationAddBidComparisonAnalyticArgs = {
  input: AddBidComparisonAnalyticInput;
};


export type MutationAddBidsToMultipleTendersArgs = {
  input: AddBidsToMultipleTendersInput;
};


export type MutationAddMessageArgs = {
  input: AddMessageInput;
};


export type MutationAddProductCategorySubscriptionArgs = {
  input: AddProductCategorySubscriptionInput;
};


export type MutationAddProductTemplateArgs = {
  input: AddProductTemplateInput;
};


export type MutationAddPromoDealArgs = {
  input: AddPromoDealInput;
};


export type MutationAddTenderArgs = {
  input: AddTenderInput;
};


export type MutationAddTenderDraftArgs = {
  input: AddTenderDraftInput;
};


export type MutationAddUserActionLogArgs = {
  input: UserActionLogInput;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationCancelSubscriptionNewInAppArgs = {
  input: CancelSubscriptionNewInAppInput;
};


export type MutationCancelSubscriptionNewRetoolArgs = {
  input: CancelSubscriptionNewRetoolInput;
};


export type MutationChangeEmailArgs = {
  input: ChangeEmailInput;
};


export type MutationChooseWinnerArgs = {
  input: ChooseWinnerInput;
};


export type MutationCleanupSalesDemoDataArgs = {
  token: Scalars['String']['input'];
};


export type MutationConfirmChangeEmailArgs = {
  changeEmailToken: Scalars['String']['input'];
};


export type MutationCreateBankTransferSubscriptionArgs = {
  input: CreateBankTransferSubscriptionInput;
};


export type MutationCreateBespokePaymentLinkArgs = {
  input: CreateBespokePaymentLinkInput;
};


export type MutationCreateStripeCheckoutArgs = {
  input: CreateStripeCheckoutInput;
};


export type MutationCreateStripeCheckoutNewArgs = {
  input: CreateStripeCheckoutNewInput;
};


export type MutationDeleteBidByIdArgs = {
  bidId: Scalars['Int']['input'];
};


export type MutationDeleteProductTemplateByIdArgs = {
  input: DeleteProductTemplateInput;
};


export type MutationDeletePromoDealByIdArgs = {
  promoDealId: Scalars['Int']['input'];
};


export type MutationDeleteTenderByIdArgs = {
  tenderId: Scalars['Int']['input'];
};


export type MutationDeleteTenderDraftByIdArgs = {
  tenderDraftId: Scalars['Int']['input'];
};


export type MutationEditBankAccountArgs = {
  input: EditBankAccountInput;
};


export type MutationEditBidArgs = {
  input: EditBidInput;
};


export type MutationEditBidSupportStatusArgs = {
  input: EditBidSupportStatusInput;
};


export type MutationEditBrandArgs = {
  input: EditBrandInput;
};


export type MutationEditBrandSettingsArgs = {
  input: EditBrandSettingsInput;
};


export type MutationEditProductTemplateArgs = {
  input: EditProductTemplateInput;
};


export type MutationEditPromoDealArgs = {
  input: EditPromoDealInput;
};


export type MutationEditTenderArgs = {
  input: EditTenderInput;
};


export type MutationEditTenderDraftArgs = {
  input: EditTenderDraftInput;
};


export type MutationEditTenderPreferenceArgs = {
  input: EditTenderPreferenceInput;
};


export type MutationEditVenueArgs = {
  input: EditVenueInput;
};


export type MutationEditVenueSettingsArgs = {
  input: EditVenueSettingsInput;
};


export type MutationGenerateUploadUrlsArgs = {
  fileNames: Array<Scalars['String']['input']>;
};


export type MutationMarkAllNotificationsAsReadArgs = {
  input: MarkAllNotificationsAsReadInput;
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRateBidArgs = {
  input: RateBidInput;
};


export type MutationRemoveProductCategorySubscriptionArgs = {
  input: RemoveProductCategorySubscriptionInput;
};


export type MutationRequestChangeEmailArgs = {
  emailToChange: Scalars['String']['input'];
};


export type MutationRequestEmailArgs = {
  input: RequestEmailInput;
};


export type MutationRequestSalesDemoBidsArgs = {
  tenderId: Scalars['Int']['input'];
};


export type MutationRetoolChangeBidStatusArgs = {
  input: RetoolChangeBidStatusInput;
};


export type MutationRetoolChangeTenderAllBidsStatusArgs = {
  input: RetoolChangeTenderAllBidsStatusInput;
};


export type MutationRetoolChangeTenderStatusArgs = {
  input: RetoolChangeTenderStatusInput;
};


export type MutationRetoolEditBrandArgs = {
  input: EditBrandInput;
};


export type MutationSalesDemoSignUpArgs = {
  input: SignUpInput;
};


export type MutationSampleRequestArgs = {
  input: SampleRequestInput;
};


export type MutationSendBankTransferInvoiceNotPaidEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendDailyNewBidsReportArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendDailyNewTenderBrandReportArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendDailyRatingReportArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendReTenderEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendSelectWinnerEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationSendTenderEndsInTwoDaysEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationSignInAsUserArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationSupportCalculatorArgs = {
  input: SupportCalculatorInput;
};


export type MutationSyncTenderStatusesArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateCompanyBillingDataArgs = {
  input: UpdateCompanyBillingDataInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpgradeProductCategorySubscriptionArgs = {
  input: UpgradeProductCategorySubscriptionInput;
};


export type MutationUpgradeToBespokeArgs = {
  token: Scalars['String']['input'];
};

export enum MyBidsFilterValues {
  OnlyTendersWithoutMyBids = 'ONLY_TENDERS_WITHOUT_MY_BIDS',
  OnlyTendersWithMyBids = 'ONLY_TENDERS_WITH_MY_BIDS'
}

export type MyBidsOption = {
  brandId: Scalars['Int']['input'];
  value: MyBidsFilterValues;
};

export enum MyTendersFilterValues {
  OnlyMyTenders = 'ONLY_MY_TENDERS',
  OnlyWithoutMyTenders = 'ONLY_WITHOUT_MY_TENDERS'
}

export type MyTendersOption = {
  value: MyTendersFilterValues;
  venueId: Scalars['Int']['input'];
};

export type Node = {
  id: Scalars['Int']['output'];
};

export type NonSubscribedProductCategory = {
  __typename?: 'NonSubscribedProductCategory';
  categoryName: Scalars['String']['output'];
  numberOfProductsInCategory: Scalars['Int']['output'];
  productCategoryId: Scalars['Int']['output'];
  stripeProductId: Scalars['String']['output'];
};

export type Notification = Node & {
  __typename?: 'Notification';
  bid?: Maybe<Bid>;
  bidId?: Maybe<Scalars['Int']['output']>;
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['Int']['output']>;
  category: NotificationCategory;
  createdAtUtc: Scalars['Date']['output'];
  fromId?: Maybe<Scalars['Int']['output']>;
  fromType?: Maybe<NotificationTargetType>;
  id: Scalars['Int']['output'];
  isRead: Scalars['Boolean']['output'];
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['Int']['output']>;
  tender?: Maybe<Tender>;
  tenderId?: Maybe<Scalars['Int']['output']>;
  toId: Scalars['Int']['output'];
  toType: NotificationTargetType;
  type: NotificationType;
  updatedAtUtc?: Maybe<Scalars['Date']['output']>;
  venue?: Maybe<Venue>;
  venueId?: Maybe<Scalars['Int']['output']>;
};

export enum NotificationCategory {
  Message = 'MESSAGE',
  System = 'SYSTEM'
}

export type NotificationEdge = Edge & {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String']['output'];
  node: Notification;
};

export enum NotificationTargetType {
  Brand = 'BRAND',
  Venue = 'VENUE'
}

export enum NotificationType {
  BidRated = 'BID_RATED',
  BidUpdated = 'BID_UPDATED',
  GeneralMessage = 'GENERAL_MESSAGE',
  NewBid = 'NEW_BID',
  NewTender = 'NEW_TENDER',
  PaymentIntentFailed = 'PAYMENT_INTENT_FAILED',
  PaymentIntentFailedStandardTier = 'PAYMENT_INTENT_FAILED_STANDARD_TIER',
  ReTenderReminder = 'RE_TENDER_REMINDER',
  SubscriptionDeleted = 'SUBSCRIPTION_DELETED',
  SubscriptionDeletedStandardTier = 'SUBSCRIPTION_DELETED_STANDARD_TIER',
  TenderCloseWithoutWinner = 'TENDER_CLOSE_WITHOUT_WINNER',
  TenderClosing = 'TENDER_CLOSING',
  TenderEnded = 'TENDER_ENDED',
  TenderEndedReminder = 'TENDER_ENDED_REMINDER',
  TenderUpdated = 'TENDER_UPDATED',
  WinnerAnnouncement = 'WINNER_ANNOUNCEMENT'
}

export type OffsetNotifications = {
  __typename?: 'OffsetNotifications';
  data: Array<Notification>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
  unreadTotalCount: Scalars['Int']['output'];
};

export type OffsetNotificationsInput = {
  category: NotificationCategory;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  toId: Scalars['Int']['input'];
  toType: NotificationTargetType;
};

export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  totalPages: Scalars['Int']['output'];
};

export type OffsetPaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PlaceAutocomplete = {
  __typename?: 'PlaceAutocomplete';
  placeId: Scalars['String']['output'];
  placeName: Scalars['String']['output'];
};

export type PlacesInput = {
  region: Region;
  searchQuery: Scalars['String']['input'];
  sessionToken: Scalars['String']['input'];
};

export type Point = {
  __typename?: 'Point';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type PointInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  productCategorySubscriptions?: Maybe<Array<ProductCategorySubscription>>;
  region: Region;
  unitType?: Maybe<Scalars['String']['output']>;
};

export type ProductCategorySubscription = {
  __typename?: 'ProductCategorySubscription';
  id: Scalars['Int']['output'];
  packageType: ProductCategorySubscriptionType;
  price: Scalars['Int']['output'];
  productCategoryId: Scalars['Int']['output'];
  stripeProductId: Scalars['String']['output'];
};

export enum ProductCategorySubscriptionType {
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

export type ProductTemplate = {
  __typename?: 'ProductTemplate';
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  brand: Brand;
  brandId: Scalars['Int']['output'];
  files?: Maybe<Array<File>>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  packagingType: Scalars['String']['output'];
  productCategory: ProductCategory;
  productCategoryId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productUrl?: Maybe<Scalars['String']['output']>;
  unitType: Scalars['String']['output'];
  volumeUnits: Scalars['Int']['output'];
  wholesalers: Array<Wholesaler>;
};

export type ProductTemplateByIdInput = {
  brandId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type ProductTemplatesByBrandIdInput = {
  brandId: Scalars['Int']['input'];
  productCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type PromoDeal = {
  __typename?: 'PromoDeal';
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  averageWholesalePrice: Scalars['Float']['output'];
  brand?: Maybe<Brand>;
  brandId: Scalars['Int']['output'];
  createdAtUtc: Scalars['Date']['output'];
  files?: Maybe<Array<File>>;
  freeStockNotes?: Maybe<Scalars['String']['output']>;
  freeStockUnitsAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible: Scalars['Boolean']['output'];
  listingFeeNotes?: Maybe<Scalars['String']['output']>;
  listingFeeTotalAmount?: Maybe<Scalars['Float']['output']>;
  otherSupport?: Maybe<Scalars['String']['output']>;
  packagingType: Scalars['String']['output'];
  posBudgetNotes?: Maybe<Scalars['String']['output']>;
  posBudgetTotalAmount?: Maybe<Scalars['Float']['output']>;
  productCategory?: Maybe<ProductCategory>;
  productCategoryId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
  productUrl?: Maybe<Scalars['String']['output']>;
  region: Region;
  retroDiscountAmountPerUnit?: Maybe<Scalars['Float']['output']>;
  retroDiscountNotes?: Maybe<Scalars['String']['output']>;
  status: PromoDealStatus;
  supportsFreeStock?: Maybe<Scalars['Boolean']['output']>;
  supportsListingFee?: Maybe<Scalars['Boolean']['output']>;
  supportsPosBudget?: Maybe<Scalars['Boolean']['output']>;
  supportsRetroDiscount?: Maybe<Scalars['Boolean']['output']>;
  unitType: Scalars['String']['output'];
  updatedAtUtc?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  volumeUnits: Scalars['Int']['output'];
  wholesalers: Array<Wholesaler>;
};

export type PromoDealProductOptions = {
  __typename?: 'PromoDealProductOptions';
  productCategories: Array<ProductCategory>;
  productPackaging: Array<Scalars['String']['output']>;
  productUnits: Array<Scalars['String']['output']>;
  wholesalers: Array<Wholesaler>;
};

export enum PromoDealStatus {
  Disabled = 'DISABLED',
  Published = 'PUBLISHED'
}

export type PromoDeals = {
  __typename?: 'PromoDeals';
  data: Array<PromoDeal>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PromoDealsFilterOptionsInput = {
  region?: InputMaybe<Region>;
  status?: InputMaybe<PromoDealStatus>;
};

export type PromoDealsInput = {
  filter?: InputMaybe<PromoDealsFilterOptionsInput>;
  pagination: OffsetPaginationInput;
};

export type Query = {
  __typename?: 'Query';
  addressByPlaceId: GoogleAddress;
  avatarUrl: Scalars['String']['output'];
  bankAccount?: Maybe<BankAccount>;
  bespokeTokenCheck: BespokeCheckData;
  bidById: Bid;
  bids: Bids;
  bidsFilterOptions: Array<Filter>;
  brandById: Brand;
  brandDashboardMetricsByBrandId: Array<BrandDashboardMetric>;
  brandSettingsByBrandId: BrandSettings;
  cursorNotifications: CursorNotifications;
  getAwrsDetails: AwrsDetails;
  getCompanyVatDetails: CompanyVatDetails;
  getDataFromCompanyNumber: RegisteredCompanyWithoutId;
  getLiveStats: LiveStats;
  hello: Scalars['String']['output'];
  invoices: Array<Invoice>;
  listingTypes: Array<ListingType>;
  locationByCoordinates: GoogleLocationByCoordinates;
  messagesByBidId: Array<Message>;
  nonSubscribedProductCategories: Array<NonSubscribedProductCategory>;
  offsetNotifications: OffsetNotifications;
  places: Array<PlaceAutocomplete>;
  previousBid?: Maybe<Bid>;
  productCategories: Array<ProductCategory>;
  productCategorySubscriptions: Array<ProductCategorySubscription>;
  productPackaging: Array<Scalars['String']['output']>;
  productTemplateById: ProductTemplate;
  productTemplatesByBrandId: Array<ProductTemplate>;
  productUnits: Array<Scalars['String']['output']>;
  promoDealProductOptions: PromoDealProductOptions;
  promoDeals: PromoDeals;
  ratingFeedbackValues: Array<RatingFeedbackValue>;
  ratingOptions: Array<RatingOption>;
  retoolBidsForTenderAndBidStatusChange: Array<RetoolBidsForStatusChange>;
  retoolBrandById: Brand;
  retoolBrandInList: Brands;
  retoolUsersInList: Users;
  retoolVenuesForTenderAndBidStatusChange: Array<RetoolVenuesForStatusChange>;
  searchVenueGroups: Venues;
  searchVenues: Array<Venue>;
  searchWholesalers: Wholesalers;
  subscription: Subscription;
  subscriptions: Array<StripeProductCategorySubscription>;
  successFeeInvoiceById: SuccessFeeInvoice;
  successFeeInvoiceList: Array<SuccessFeeInvoiceListItem>;
  tenderById: Tender;
  tenderDraftById: TenderDraft;
  tenderList: Tenders;
  tenderListFilterOptions: Array<Filter>;
  tenderPreferenceByVenueId: TenderPreference;
  topTendersBidsCountMinBoundary: Scalars['Int']['output'];
  totalSupportFromBrandPerActiveVenue: TotalSupportFromBrandPerVenue;
  userExists: Scalars['Boolean']['output'];
  userMe: User;
  userVenues: Venues;
  userVenuesByName: Array<Venue>;
  venueById: Venue;
  venueCategories: Array<Scalars['String']['output']>;
  venueDashboardMetricsByVenueId: Array<VenueDashboardMetric>;
  venueDashboardTenders: UnionTenders;
  venueSettingsByVenueId: VenueSettings;
  winningBidsByTenderId: Array<Bid>;
};


export type QueryAddressByPlaceIdArgs = {
  input: AddressByPlaceIdInput;
};


export type QueryAvatarUrlArgs = {
  input: AvatarUrlInput;
};


export type QueryBespokeTokenCheckArgs = {
  token: Scalars['String']['input'];
};


export type QueryBidByIdArgs = {
  bidId: Scalars['Int']['input'];
};


export type QueryBidsArgs = {
  input: BidsInput;
};


export type QueryBidsFilterOptionsArgs = {
  input: BidsFilterOptionsInput;
};


export type QueryBrandByIdArgs = {
  brandId: Scalars['Int']['input'];
};


export type QueryBrandDashboardMetricsByBrandIdArgs = {
  brandId: Scalars['Int']['input'];
};


export type QueryBrandSettingsByBrandIdArgs = {
  brandId: Scalars['Int']['input'];
};


export type QueryCursorNotificationsArgs = {
  input: CursorNotificationsInput;
};


export type QueryGetAwrsDetailsArgs = {
  input: GetAwrsDetailsInput;
};


export type QueryGetCompanyVatDetailsArgs = {
  input: GetCompanyVatDetailsInput;
};


export type QueryGetDataFromCompanyNumberArgs = {
  input: GetDataFromCompanyNumberInput;
};


export type QueryHelloArgs = {
  input: HelloInput;
};


export type QueryInvoicesArgs = {
  stripeCustomerId: Scalars['String']['input'];
};


export type QueryLocationByCoordinatesArgs = {
  input: LocationByCoordinatesInput;
};


export type QueryMessagesByBidIdArgs = {
  bidId: Scalars['Int']['input'];
};


export type QueryNonSubscribedProductCategoriesArgs = {
  stripeSubscriptionId: Scalars['String']['input'];
};


export type QueryOffsetNotificationsArgs = {
  input: OffsetNotificationsInput;
};


export type QueryPlacesArgs = {
  input: PlacesInput;
};


export type QueryPreviousBidArgs = {
  brandId: Scalars['Int']['input'];
};


export type QueryProductTemplateByIdArgs = {
  input: ProductTemplateByIdInput;
};


export type QueryProductTemplatesByBrandIdArgs = {
  input: ProductTemplatesByBrandIdInput;
};


export type QueryPromoDealProductOptionsArgs = {
  region: Region;
};


export type QueryPromoDealsArgs = {
  input: PromoDealsInput;
};


export type QueryRetoolBidsForTenderAndBidStatusChangeArgs = {
  tenderId: Scalars['Int']['input'];
};


export type QueryRetoolBrandByIdArgs = {
  brandId: Scalars['Int']['input'];
};


export type QueryRetoolBrandInListArgs = {
  input: RetoolBrandListInput;
};


export type QueryRetoolUsersInListArgs = {
  input: RetoolUsersInListInput;
};


export type QuerySearchVenueGroupsArgs = {
  input: SearchVenueGroupsInput;
};


export type QuerySearchVenuesArgs = {
  input: SearchVenuesInput;
};


export type QuerySearchWholesalersArgs = {
  input: WholesalerSearchInput;
};


export type QuerySubscriptionArgs = {
  stripeSubscriptionId: Scalars['String']['input'];
};


export type QuerySubscriptionsArgs = {
  stripeSubscriptionId: Scalars['String']['input'];
};


export type QuerySuccessFeeInvoiceByIdArgs = {
  invoiceId: Scalars['String']['input'];
};


export type QuerySuccessFeeInvoiceListArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryTenderByIdArgs = {
  tenderId: Scalars['Int']['input'];
};


export type QueryTenderDraftByIdArgs = {
  tenderDraftId: Scalars['Int']['input'];
};


export type QueryTenderListArgs = {
  input: TendersInput;
};


export type QueryTenderPreferenceByVenueIdArgs = {
  venueId: Scalars['Int']['input'];
};


export type QueryTotalSupportFromBrandPerActiveVenueArgs = {
  brandId: Scalars['Int']['input'];
  venueId: Scalars['Int']['input'];
};


export type QueryUserExistsArgs = {
  input: UserExistsInput;
};


export type QueryUserMeArgs = {
  input?: InputMaybe<UserMeInput>;
};


export type QueryUserVenuesArgs = {
  input: UserVenuesInput;
};


export type QueryUserVenuesByNameArgs = {
  venueName: Scalars['String']['input'];
};


export type QueryVenueByIdArgs = {
  venueId: Scalars['Int']['input'];
};


export type QueryVenueCategoriesArgs = {
  region?: InputMaybe<Region>;
};


export type QueryVenueDashboardMetricsByVenueIdArgs = {
  venueId: Scalars['Int']['input'];
};


export type QueryVenueDashboardTendersArgs = {
  input: VenueDashboardTendersInput;
};


export type QueryVenueSettingsByVenueIdArgs = {
  venueId: Scalars['Int']['input'];
};


export type QueryWinningBidsByTenderIdArgs = {
  tenderId: Scalars['Int']['input'];
};

export type RangeOption = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type RateBidInput = {
  bidId: Scalars['Int']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
  ratingComment?: InputMaybe<Scalars['String']['input']>;
  ratingOptions: Array<Scalars['Int']['input']>;
};

export type RatingFeedbackValue = {
  __typename?: 'RatingFeedbackValue';
  id: Scalars['Int']['output'];
  ratingOptionId: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type RatingOption = {
  __typename?: 'RatingOption';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ratingFeedbackValues: Array<RatingFeedbackValue>;
  type: RatingOptionType;
};

export enum RatingOptionType {
  All = 'ALL',
  Or = 'OR'
}

export enum Region {
  Australia = 'Australia',
  Spain = 'Spain',
  UnitedKingdom = 'UnitedKingdom'
}

export type RegisteredCompany = {
  __typename?: 'RegisteredCompany';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dateOfCreation?: Maybe<Scalars['String']['output']>;
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RegisteredCompanyInput = {
  address?: InputMaybe<GoogleAddressInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  dateOfCreation?: InputMaybe<Scalars['String']['input']>;
  firstAddressLine?: InputMaybe<Scalars['String']['input']>;
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  secondAddressLine?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredCompanyWithoutId = {
  __typename?: 'RegisteredCompanyWithoutId';
  country?: Maybe<Scalars['String']['output']>;
  dateOfCreation: Scalars['String']['output'];
  firstAddressLine?: Maybe<Scalars['String']['output']>;
  formattedAddress: Scalars['String']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  secondAddressLine?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type RemoveProductCategorySubscriptionInput = {
  brandId: Scalars['Int']['input'];
  packageType: ProductCategorySubscriptionType;
  productCategoryId: Scalars['Int']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type RequestEmailArgument = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type RequestEmailInput = {
  emailType: EmailType;
  region: Region;
  requestEmailArguments: Array<RequestEmailArgument>;
  requesterEmail: Scalars['String']['input'];
};

export type RetoolBrandListFilter = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region>;
};

export type RetoolBrandListInput = {
  filter?: InputMaybe<RetoolBrandListFilter>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderDirection?: InputMaybe<SortDirectionEnum>;
};

export type RetoolChangeBidStatusInput = {
  bidId: Scalars['Int']['input'];
  bidStatus: BidStatus;
};

export type RetoolChangeTenderAllBidsStatusInput = {
  bidStatus: BidStatus;
  tenderId: Scalars['Int']['input'];
};

export type RetoolChangeTenderStatusInput = {
  tenderId: Scalars['Int']['input'];
  tenderStatus: TenderStatus;
};

export type RetoolUsersFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Region>;
};

export type RetoolUsersInListInput = {
  filter?: InputMaybe<RetoolUsersFilterInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderDirection?: InputMaybe<SortDirectionEnum>;
};

export type SampleRequestInput = {
  bidId: Scalars['Int']['input'];
  googlePlacesSessionToken: Scalars['String']['input'];
  sampleDeliveryPlaceId: Scalars['String']['input'];
  sampleMessage: Scalars['String']['input'];
  venueId: Scalars['Int']['input'];
};

export type SearchVenueGroupsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  publicTendersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery: Scalars['String']['input'];
  sortDirection?: InputMaybe<SortDirectionEnum>;
};

export type SearchVenuesInput = {
  venueName: Scalars['String']['input'];
  withPublicTendersOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignUpInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  region: Region;
  registeredCompany?: InputMaybe<RegisteredCompanyInput>;
  userType: UserType;
};

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StripeProductCategorySubscription = {
  __typename?: 'StripeProductCategorySubscription';
  categoryName: Scalars['String']['output'];
  numberOfProductsInCategory: Scalars['Int']['output'];
  packageType: ProductCategorySubscriptionType;
  pricePerMonth: Scalars['Int']['output'];
  productCategoryId: Scalars['Int']['output'];
  productCategorySubscriptionId: Scalars['Int']['output'];
  stripeProductId: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  amount?: Maybe<Scalars['Int']['output']>;
  createdAtUtc: Scalars['Int']['output'];
  currentPeriodEnd: Scalars['Int']['output'];
  currentPeriodStart: Scalars['Int']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
  subscriptionTier?: Maybe<SubscriptionTier>;
  successFee?: Maybe<Scalars['Float']['output']>;
};

export enum SubscriptionTier {
  Enterprise = 'ENTERPRISE',
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

export type SuccessFeeInvoice = {
  __typename?: 'SuccessFeeInvoice';
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  paymentUrl: Scalars['String']['output'];
  pdfUrl: Scalars['String']['output'];
  status: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type SuccessFeeInvoiceListItem = {
  __typename?: 'SuccessFeeInvoiceListItem';
  averageWholesaleBidPrice: Scalars['Float']['output'];
  bidUnitType: Scalars['String']['output'];
  bidVolumeUnits: Scalars['Float']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['String']['output'];
  estimatedVolume: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  packagingType: Scalars['String']['output'];
  paymentUrl: Scalars['String']['output'];
  pdfUrl: Scalars['String']['output'];
  status: Scalars['String']['output'];
  successFee: Scalars['Float']['output'];
  tenderName: Scalars['String']['output'];
  tenderUnitType: Scalars['String']['output'];
  tenderVolumeUnits: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  venueName: Scalars['String']['output'];
};

export type SupportCalculatorInput = {
  email: Scalars['String']['input'];
  numberOfVenues: Scalars['Int']['input'];
  region: Region;
  totalBeveragePurchases: Scalars['Int']['input'];
  venueType: Scalars['String']['input'];
};

export type Tender = {
  __typename?: 'Tender';
  createdAtUtc?: Maybe<Scalars['String']['output']>;
  estimatedVolume?: Maybe<Scalars['Int']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<File>>;
  hasBrandsBid?: Maybe<Scalars['Boolean']['output']>;
  hostingChargeInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible?: Maybe<Scalars['Boolean']['output']>;
  isPrivate: Scalars['Boolean']['output'];
  listingEndsAtUtc?: Maybe<Scalars['Date']['output']>;
  listingStartsAtUtc?: Maybe<Scalars['Date']['output']>;
  listingType: ListingType;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packagingType?: Maybe<Scalars['String']['output']>;
  productCategory: ProductCategory;
  productCategoryId: Scalars['Int']['output'];
  receivedSupportStatus?: Maybe<TenderSupportStatus>;
  region: Region;
  status: TenderStatus;
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsFreeStock?: Maybe<TenderSupportOption>;
  supportsListingFee?: Maybe<TenderSupportOption>;
  supportsPosBudget?: Maybe<TenderSupportOption>;
  supportsRetroDiscount?: Maybe<TenderSupportOption>;
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['Date']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['Date']['output']>;
  totalReceivedBids: Scalars['Int']['output'];
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  venue: Venue;
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits?: Maybe<Scalars['Int']['output']>;
  wholesalers?: Maybe<Array<Wholesaler>>;
};

export type TenderDraft = {
  __typename?: 'TenderDraft';
  createdAtUtc: Scalars['String']['output'];
  estimatedVolume?: Maybe<Scalars['Int']['output']>;
  files: Array<File>;
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible: Scalars['Boolean']['output'];
  isDirectSupplyCompatible?: Maybe<Scalars['Boolean']['output']>;
  isPrivate: Scalars['Boolean']['output'];
  listingEndsAtUtc?: Maybe<Scalars['Date']['output']>;
  listingStartsAtUtc?: Maybe<Scalars['Date']['output']>;
  listingType: ListingType;
  listingTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  packagingType?: Maybe<Scalars['String']['output']>;
  productCategory: ProductCategory;
  productCategoryId: Scalars['Int']['output'];
  region: Region;
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  tenderDetails?: Maybe<Scalars['String']['output']>;
  tenderEndsAtUtc?: Maybe<Scalars['Date']['output']>;
  tenderStartsAtUtc?: Maybe<Scalars['Date']['output']>;
  unitType?: Maybe<Scalars['String']['output']>;
  updatedAtUtc?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['Int']['output'];
  venue: Venue;
  venueId: Scalars['Int']['output'];
  volumeDetails?: Maybe<Scalars['String']['output']>;
  volumeUnits?: Maybe<Scalars['Int']['output']>;
  wholesalers: Array<Wholesaler>;
};

export type TenderFilterOptionsInput = {
  administrativeAreaLevel2?: InputMaybe<Array<Scalars['String']['input']>>;
  listingTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  myBids?: InputMaybe<MyBidsOption>;
  myTenders?: InputMaybe<MyTendersOption>;
  postCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  productCategoryId?: InputMaybe<Scalars['Int']['input']>;
  venueGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  venueTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  volume?: InputMaybe<RangeOption>;
  wholesalerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TenderListFilterOption = {
  __typename?: 'TenderListFilterOption';
  label: Scalars['String']['output'];
  options: Array<FilterOption>;
};

export enum TenderListOrderByEnum {
  Duration = 'DURATION',
  RecentlyAdded = 'RECENTLY_ADDED',
  TimeLeft = 'TIME_LEFT',
  Volume = 'VOLUME'
}

export type TenderListPaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<TenderListOrderByEnum>;
  orderDirection?: InputMaybe<SortDirectionEnum>;
};

export type TenderPreference = {
  __typename?: 'TenderPreference';
  id: Scalars['Int']['output'];
  isAnyWholesalerCompatible?: Maybe<Scalars['Boolean']['output']>;
  isDirectSupplyCompatible?: Maybe<Scalars['Boolean']['output']>;
  supportDetails?: Maybe<Scalars['String']['output']>;
  supportsFreeStock: TenderSupportOption;
  supportsListingFee: TenderSupportOption;
  supportsPosBudget: TenderSupportOption;
  supportsRetroDiscount: TenderSupportOption;
  venueId: Scalars['Int']['output'];
  wholesalers: Array<Wholesaler>;
};

export type TenderSortInput = {
  orderBy?: InputMaybe<VenueDashboardOrderByEnum>;
  orderDirection?: InputMaybe<SortDirectionEnum>;
};

export enum TenderStatus {
  Awarded = 'AWARDED',
  Closed = 'CLOSED',
  ClosedWithoutWinner = 'CLOSED_WITHOUT_WINNER',
  Deleted = 'DELETED',
  Published = 'PUBLISHED'
}

export enum TenderSupportOption {
  NotInterested = 'NOT_INTERESTED',
  Optional = 'OPTIONAL',
  Preferred = 'PREFERRED'
}

export enum TenderSupportStatus {
  InProgress = 'IN_PROGRESS',
  NotProvided = 'NOT_PROVIDED',
  Received = 'RECEIVED'
}

export type Tenders = {
  __typename?: 'Tenders';
  data: Array<Tender>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TendersInput = {
  excludedTenderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  filter?: InputMaybe<TenderFilterOptionsInput>;
  pagination?: InputMaybe<TenderListPaginationInput>;
};

export type TotalSupportFromBrandPerVenue = {
  __typename?: 'TotalSupportFromBrandPerVenue';
  totalSupport: Scalars['Float']['output'];
  totalTenders: Scalars['Int']['output'];
};

export type UnionTenderInList = Tender | TenderDraft;

export type UnionTenders = {
  __typename?: 'UnionTenders';
  data: Array<UnionTenderInList>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UpdateCompanyBillingDataInput = {
  activeVenueId?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<GoogleAddressInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  googlePlacesSessionToken: Scalars['String']['input'];
  registeredCompany?: InputMaybe<RegisteredCompanyInput>;
  tradingAddress?: InputMaybe<GoogleAddressInput>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionInput = {
  stripeCustomerId: Scalars['String']['input'];
  stripeSubscriptionId: Scalars['String']['input'];
  subscriptionTier: SubscriptionTier;
  successFee: Scalars['Float']['input'];
};

export type UpgradeProductCategorySubscriptionInput = {
  brandId: Scalars['Int']['input'];
  productCategoryId: Scalars['Int']['input'];
  subscriptionId: Scalars['String']['input'];
};

export type UpgradeToBespokeData = {
  __typename?: 'UpgradeToBespokeData';
  needsRedirect: Scalars['Boolean']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
  wasSuccessfullyUpdated: Scalars['Boolean']['output'];
};

export type UploadUrlItem = {
  __typename?: 'UploadUrlItem';
  bucketKey: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  activeVenue?: Maybe<Venue>;
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['Int']['output']>;
  brands: Array<Brand>;
  companyName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firebaseId: Scalars['String']['output'];
  firstFourVenues: Array<Venue>;
  id: Scalars['Int']['output'];
  isSalesDemo?: Maybe<Scalars['Boolean']['output']>;
  region: Region;
  registeredCompany?: Maybe<RegisteredCompany>;
  tradingAddress?: Maybe<Address>;
  tradingName?: Maybe<Scalars['String']['output']>;
  userType: UserType;
  venues: Array<Venue>;
};

export type UserActionLog = {
  __typename?: 'UserActionLog';
  additionalData?: Maybe<Scalars['Object']['output']>;
  eventName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserActionLogInput = {
  additionalData?: InputMaybe<Scalars['Object']['input']>;
  eventName: Scalars['String']['input'];
};

export type UserExistsInput = {
  email: Scalars['String']['input'];
};

export type UserMeInput = {
  activeVenueId?: InputMaybe<Scalars['Int']['input']>;
};

export enum UserType {
  Brand = 'BRAND',
  Venue = 'VENUE'
}

export type UserVenuesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserVenuesInputFilter>;
  first: Scalars['Int']['input'];
  sortColumn?: InputMaybe<UserVenuesSortColumnEnum>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
};

export type UserVenuesInputFilter = {
  venueName?: InputMaybe<Scalars['String']['input']>;
};

export enum UserVenuesSortColumnEnum {
  Name = 'name'
}

export type Users = {
  __typename?: 'Users';
  data: Array<User>;
  pageInfo: OffsetPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Venue = Node & {
  __typename?: 'Venue';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['Int']['output']>;
  avatarBucketKey?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  canCreateTender: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  hasTenders: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  region: Region;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  tenderPreference: TenderPreference;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
  venueCategoryName?: Maybe<Scalars['String']['output']>;
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export type VenueCategory = {
  __typename?: 'VenueCategory';
  name: Scalars['String']['output'];
  venues: Array<Venue>;
};

export type VenueDashboardFilterOptionsInput = {
  status: VenueDashboardTenderStatus;
};

export type VenueDashboardMetric = {
  __typename?: 'VenueDashboardMetric';
  label: VenueDashboardMetricLabel;
  type: DashboardMetricType;
  value: Scalars['String']['output'];
};

export enum VenueDashboardMetricLabel {
  ActualTenderVolume = 'ACTUAL_TENDER_VOLUME',
  AverageBidsCount = 'AVERAGE_BIDS_COUNT',
  SupportPerBottle = 'SUPPORT_PER_BOTTLE',
  TotalSupportValue = 'TOTAL_SUPPORT_VALUE'
}

export enum VenueDashboardOrderByEnum {
  RecentlyAdded = 'RECENTLY_ADDED',
  SupportReceived = 'SUPPORT_RECEIVED',
  TimeLeft = 'TIME_LEFT',
  Volume = 'VOLUME'
}

export enum VenueDashboardTenderStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Past = 'PAST'
}

export type VenueDashboardTendersInput = {
  filter: VenueDashboardFilterOptionsInput;
  pagination: OffsetPaginationInput;
  sort?: InputMaybe<TenderSortInput>;
  venueId: Scalars['Int']['input'];
};

export enum VenueDashboardViews {
  BidView = 'BID_VIEW',
  TenderView = 'TENDER_VIEW'
}

export type VenueEdge = Edge & {
  __typename?: 'VenueEdge';
  cursor: Scalars['String']['output'];
  node: Venue;
};

export type VenueSettings = {
  __typename?: 'VenueSettings';
  id: Scalars['Int']['output'];
  isBidUpdatedInAppNotificationEnabled: Scalars['Boolean']['output'];
  isBidUpdatedMailNotificationEnabled: Scalars['Boolean']['output'];
  isMyTenderEndedInAppNotificationEnabled: Scalars['Boolean']['output'];
  isMyTenderEndedMailNotificationEnabled: Scalars['Boolean']['output'];
  isNewBidsInAppNotificationEnabled: Scalars['Boolean']['output'];
  isNewBidsMailNotificationEnabled: Scalars['Boolean']['output'];
  isNewTenderInAppNotificationEnabled: Scalars['Boolean']['output'];
  isNewTenderMailNotificationEnabled: Scalars['Boolean']['output'];
  isReTenderInAppNotificationEnabled: Scalars['Boolean']['output'];
  isReTenderMailNotificationEnabled: Scalars['Boolean']['output'];
  venueId: Scalars['Int']['output'];
};

export type Venues = CursorPagination & {
  __typename?: 'Venues';
  edges: Array<VenueEdge>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Wholesaler = Node & {
  __typename?: 'Wholesaler';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: Region;
};

export type WholesalerEdge = Edge & {
  __typename?: 'WholesalerEdge';
  cursor: Scalars['String']['output'];
  node: Wholesaler;
};

export type WholesalerSearchInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  searchQuery: Scalars['String']['input'];
  sortDirection?: InputMaybe<SortDirectionEnum>;
};

export type Wholesalers = CursorPagination & {
  __typename?: 'Wholesalers';
  edges: Array<WholesalerEdge>;
  pageInfo: CursorPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RetoolBidsForStatusChange = {
  __typename?: 'retoolBidsForStatusChange';
  bidId: Scalars['Int']['output'];
  bidStatus: BidStatus;
  brandName: Scalars['String']['output'];
  brandUserId: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  tenderId: Scalars['Int']['output'];
  tenderName: Scalars['String']['output'];
  tenderStatus: TenderStatus;
  venueName: Scalars['String']['output'];
  venueUserId: Scalars['Int']['output'];
};

export type RetoolVenuesForStatusChange = {
  __typename?: 'retoolVenuesForStatusChange';
  tenderId: Scalars['Int']['output'];
  tenderName: Scalars['String']['output'];
  tenderStatus: TenderStatus;
  venueName: Scalars['String']['output'];
  venueUserId: Scalars['Int']['output'];
};

export type CursorPageInfoFragment = { __typename?: 'CursorPageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean };

export type OffsetPageInfoFragment = { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean };

export type AddressInfoFragment = { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } };

export type PlacesQueryVariables = Exact<{
  input: PlacesInput;
}>;


export type PlacesQuery = { __typename?: 'Query', places: Array<{ __typename?: 'PlaceAutocomplete', placeName: string, placeId: string }> };

export type AddressWithPostcodeByPlaceIdQueryVariables = Exact<{
  input: AddressByPlaceIdInput;
}>;


export type AddressWithPostcodeByPlaceIdQuery = { __typename?: 'Query', addressByPlaceId: { __typename?: 'GoogleAddress', placeId: string, placeName: string, postCode?: string | null, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Coordinates', lat: string, lng: string } } };

export type LocationByCoordinatesQueryVariables = Exact<{
  input: LocationByCoordinatesInput;
}>;


export type LocationByCoordinatesQuery = { __typename?: 'Query', locationByCoordinates: { __typename?: 'GoogleLocationByCoordinates', country?: string | null } };

export type BankAccountInfoFragment = { __typename?: 'BankAccount', id: number, userId: number, accountName: string, accountNumber: string, sortCode: string };

export type AddBankAccountMutationVariables = Exact<{
  input: AddBankAccountInput;
}>;


export type AddBankAccountMutation = { __typename?: 'Mutation', addBankAccount: { __typename?: 'BankAccount', id: number, userId: number, accountName: string, accountNumber: string, sortCode: string } };

export type EditBankAccountMutationVariables = Exact<{
  input: EditBankAccountInput;
}>;


export type EditBankAccountMutation = { __typename?: 'Mutation', editBankAccount: { __typename?: 'BankAccount', id: number, userId: number, accountName: string, accountNumber: string, sortCode: string } };

export type BankAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type BankAccountQuery = { __typename?: 'Query', bankAccount?: { __typename?: 'BankAccount', id: number, userId: number, accountName: string, accountNumber: string, sortCode: string } | null };

export type BidInfoFragment = { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null };

export type BidByIdQueryVariables = Exact<{
  bidId: Scalars['Int']['input'];
}>;


export type BidByIdQuery = { __typename?: 'Query', bidById: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, brand?: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } | null, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, ratingFeedbackValues?: Array<{ __typename?: 'RatingFeedbackValue', id: number, value: string, ratingOptionId: number }> | null, tender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, venue: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } }, listingType: { __typename?: 'ListingType', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number, region: Region }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } }, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null } };

export type PreviousBidQueryVariables = Exact<{
  brandId: Scalars['Int']['input'];
}>;


export type PreviousBidQuery = { __typename?: 'Query', previousBid?: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null } | null };

export type BidsQueryVariables = Exact<{
  input: BidsInput;
}>;


export type BidsQuery = { __typename?: 'Query', bids: { __typename?: 'Bids', totalCount: number, data: Array<{ __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, brand?: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } | null, ratingFeedbackValues?: Array<{ __typename?: 'RatingFeedbackValue', id: number, value: string, ratingOptionId: number }> | null, tender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean }, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type BrandDashboardBidsQueryVariables = Exact<{
  input: BidsInput;
}>;


export type BrandDashboardBidsQuery = { __typename?: 'Query', bids: { __typename?: 'Bids', totalCount: number, data: Array<{ __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, brand?: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } | null, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, tender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, venue: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } }, listingType: { __typename?: 'ListingType', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number, region: Region }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } }, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type WinningBidsByTenderIdQueryVariables = Exact<{
  tenderId: Scalars['Int']['input'];
}>;


export type WinningBidsByTenderIdQuery = { __typename?: 'Query', winningBidsByTenderId: Array<{ __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, brand?: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } | null, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, ratingFeedbackValues?: Array<{ __typename?: 'RatingFeedbackValue', id: number, value: string, ratingOptionId: number }> | null, tender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, venue: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } }, listingType: { __typename?: 'ListingType', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number, region: Region }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } }, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null }> };

export type RatingOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RatingOptionsQuery = { __typename?: 'Query', ratingOptions: Array<{ __typename?: 'RatingOption', id: number, name: string, type: RatingOptionType, ratingFeedbackValues: Array<{ __typename?: 'RatingFeedbackValue', id: number, value: string, ratingOptionId: number }> }> };

export type TotalSupportFromOneBrandToVenueQueryVariables = Exact<{
  brandId: Scalars['Int']['input'];
  venueId: Scalars['Int']['input'];
}>;


export type TotalSupportFromOneBrandToVenueQuery = { __typename?: 'Query', totalSupportFromBrandPerActiveVenue: { __typename?: 'TotalSupportFromBrandPerVenue', totalSupport: number, totalTenders: number } };

export type BidsFilterOptionsQueryVariables = Exact<{
  input: BidsFilterOptionsInput;
}>;


export type BidsFilterOptionsQuery = { __typename?: 'Query', bidsFilterOptions: Array<{ __typename?: 'Filter', label: string, options: Array<{ __typename?: 'FilterOption', label: string, value: string }> }> };

export type AvatarUrlQueryVariables = Exact<{
  input: AvatarUrlInput;
}>;


export type AvatarUrlQuery = { __typename?: 'Query', avatarUrl: string };

export type RateBidMutationVariables = Exact<{
  input: RateBidInput;
}>;


export type RateBidMutation = { __typename?: 'Mutation', rateBid: { __typename?: 'Bid', id: number, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratingFeedbackValues?: Array<{ __typename?: 'RatingFeedbackValue', id: number }> | null } };

export type DeleteBidByIdMutationVariables = Exact<{
  bidId: Scalars['Int']['input'];
}>;


export type DeleteBidByIdMutation = { __typename?: 'Mutation', deleteBidById: boolean };

export type AddBidMutationVariables = Exact<{
  input: AddBidInput;
}>;


export type AddBidMutation = { __typename?: 'Mutation', addBid: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null } };

export type EditBidMutationVariables = Exact<{
  input: EditBidInput;
}>;


export type EditBidMutation = { __typename?: 'Mutation', editBid: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null } };

export type RequestSalesDemoBidsMutationVariables = Exact<{
  tenderId: Scalars['Int']['input'];
}>;


export type RequestSalesDemoBidsMutation = { __typename?: 'Mutation', requestSalesDemoBids: Array<{ __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null }> };

export type SampleRequestMutationVariables = Exact<{
  input: SampleRequestInput;
}>;


export type SampleRequestMutation = { __typename?: 'Mutation', sampleRequest: boolean };

export type AddBidsToMultipleTendersMutationVariables = Exact<{
  input: AddBidsToMultipleTendersInput;
}>;


export type AddBidsToMultipleTendersMutation = { __typename?: 'Mutation', addBidsToMultipleTenders: Array<{ __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null }> };

export type EditBidSupportStatusMutationVariables = Exact<{
  input: EditBidSupportStatusInput;
}>;


export type EditBidSupportStatusMutation = { __typename?: 'Mutation', editBidSupportStatus: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null } };

export type AddBidComparisonAnalyticMutationVariables = Exact<{
  input: AddBidComparisonAnalyticInput;
}>;


export type AddBidComparisonAnalyticMutation = { __typename?: 'Mutation', addBidComparisonAnalytic: boolean };

export type BrandInfoFragment = { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> };

export type BrandInfoWithHasActiveSubscriptionFieldFragment = { __typename?: 'Brand', hasActiveSubscription: boolean, id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> };

export type EditBrandMutationVariables = Exact<{
  input: EditBrandInput;
}>;


export type EditBrandMutation = { __typename?: 'Mutation', editBrand: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } };

export type SupportCalculationMutationVariables = Exact<{
  input: SupportCalculatorInput;
}>;


export type SupportCalculationMutation = { __typename?: 'Mutation', supportCalculator: boolean };

export type GetDataFromCompanyVatQueryVariables = Exact<{
  input: GetCompanyVatDetailsInput;
}>;


export type GetDataFromCompanyVatQuery = { __typename?: 'Query', getCompanyVatDetails: { __typename?: 'CompanyVatDetails', vatNumber: string, vatCompanyName: string, vatCountryCode: string, vatConsultationNumber: string, vatProcessingDate: string } };

export type GetDataFromAwrsDetailsQueryVariables = Exact<{
  input: GetAwrsDetailsInput;
}>;


export type GetDataFromAwrsDetailsQuery = { __typename?: 'Query', getAwrsDetails: { __typename?: 'AwrsDetails', awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null } };

export type BrandDashboardMetricsByBrandIdQueryVariables = Exact<{
  brandId: Scalars['Int']['input'];
}>;


export type BrandDashboardMetricsByBrandIdQuery = { __typename?: 'Query', brandDashboardMetricsByBrandId: Array<{ __typename?: 'BrandDashboardMetric', type: DashboardMetricType, label: BrandDashboardMetricLabel, value: string }> };

export type BrandSettingsInfoFragment = { __typename?: 'BrandSettings', id: number, brandId: number, isRatingProvidedMailNotificationEnabled: boolean, isTenderUpdatedMailNotificationEnabled: boolean, isNewTenderMailNotificationEnabled: boolean, isRatingProvidedInAppNotificationEnabled: boolean, isTenderUpdatedInAppNotificationEnabled: boolean, isNewTenderInAppNotificationEnabled: boolean };

export type BrandSettingsByBrandIdQueryVariables = Exact<{
  brandId: Scalars['Int']['input'];
}>;


export type BrandSettingsByBrandIdQuery = { __typename?: 'Query', brandSettingsByBrandId: { __typename?: 'BrandSettings', id: number, brandId: number, isRatingProvidedMailNotificationEnabled: boolean, isTenderUpdatedMailNotificationEnabled: boolean, isNewTenderMailNotificationEnabled: boolean, isRatingProvidedInAppNotificationEnabled: boolean, isTenderUpdatedInAppNotificationEnabled: boolean, isNewTenderInAppNotificationEnabled: boolean } };

export type EditBrandSettingsMutationVariables = Exact<{
  input: EditBrandSettingsInput;
}>;


export type EditBrandSettingsMutation = { __typename?: 'Mutation', editBrandSettings: { __typename?: 'BrandSettings', id: number, brandId: number, isRatingProvidedMailNotificationEnabled: boolean, isTenderUpdatedMailNotificationEnabled: boolean, isNewTenderMailNotificationEnabled: boolean, isRatingProvidedInAppNotificationEnabled: boolean, isTenderUpdatedInAppNotificationEnabled: boolean, isNewTenderInAppNotificationEnabled: boolean } };

export type RequestEmailMutationVariables = Exact<{
  input: RequestEmailInput;
}>;


export type RequestEmailMutation = { __typename?: 'Mutation', requestEmail: boolean };

export type FileInfoFragment = { __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number };

export type GenerateUploadUrlsMutationVariables = Exact<{
  input: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GenerateUploadUrlsMutation = { __typename?: 'Mutation', generateUploadUrls: Array<{ __typename?: 'UploadUrlItem', filename: string, bucketKey: string, uploadUrl: string }> };

export type ListingTypeInfoFragment = { __typename?: 'ListingType', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number, region: Region };

export type ListingTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListingTypesQuery = { __typename?: 'Query', listingTypes: Array<{ __typename?: 'ListingType', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number, region: Region }> };

export type GetLiveStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLiveStatsQuery = { __typename?: 'Query', getLiveStats: { __typename?: 'LiveStats', activeTenders: number, activeBidGrossMerchandiseValue: number } };

export type MessageInfoFragment = { __typename?: 'Message', id: number, bidId: number, venueId?: number | null, brandId?: number | null, text: string, createdAtUtc: string, updatedAtUtc?: string | null };

export type MessagesByBidIdQueryVariables = Exact<{
  bidId: Scalars['Int']['input'];
}>;


export type MessagesByBidIdQuery = { __typename?: 'Query', messagesByBidId: Array<{ __typename?: 'Message', id: number, bidId: number, venueId?: number | null, brandId?: number | null, text: string, createdAtUtc: string, updatedAtUtc?: string | null, venue?: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } } | null, brand?: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } | null }> };

export type AddMessageMutationVariables = Exact<{
  input: AddMessageInput;
}>;


export type AddMessageMutation = { __typename?: 'Mutation', addMessage: { __typename?: 'Message', id: number, bidId: number, venueId?: number | null, brandId?: number | null, text: string, createdAtUtc: string, updatedAtUtc?: string | null } };

export type NotificationInfoFragment = { __typename?: 'Notification', id: number, toId: number, isRead: boolean, type: NotificationType, category: NotificationCategory, toType: NotificationTargetType, fromId?: number | null, venueId?: number | null, brandId?: number | null, bidId?: number | null, tenderId?: number | null, createdAtUtc: string, messageId?: number | null, bid?: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null } | null, tender?: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean } | null, venue?: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } } | null, brand?: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } | null, message?: { __typename?: 'Message', id: number, bidId: number, venueId?: number | null, brandId?: number | null, text: string, createdAtUtc: string, updatedAtUtc?: string | null } | null };

export type MarkNotificationAsReadMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: { __typename?: 'Notification', id: number, toId: number, isRead: boolean, type: NotificationType, category: NotificationCategory, toType: NotificationTargetType, fromId?: number | null, venueId?: number | null, brandId?: number | null, bidId?: number | null, tenderId?: number | null, createdAtUtc: string, messageId?: number | null, bid?: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null } | null, tender?: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean } | null, venue?: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } } | null, brand?: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } | null, message?: { __typename?: 'Message', id: number, bidId: number, venueId?: number | null, brandId?: number | null, text: string, createdAtUtc: string, updatedAtUtc?: string | null } | null } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{
  input: MarkAllNotificationsAsReadInput;
}>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead: Array<{ __typename?: 'Notification', id: number, toId: number, isRead: boolean, type: NotificationType, category: NotificationCategory, toType: NotificationTargetType, fromId?: number | null, venueId?: number | null, brandId?: number | null, bidId?: number | null, tenderId?: number | null, createdAtUtc: string, messageId?: number | null, bid?: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null } | null, tender?: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean } | null, venue?: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } } | null, brand?: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } | null, message?: { __typename?: 'Message', id: number, bidId: number, venueId?: number | null, brandId?: number | null, text: string, createdAtUtc: string, updatedAtUtc?: string | null } | null }> };

export type CursorNotificationsQueryVariables = Exact<{
  input: CursorNotificationsInput;
}>;


export type CursorNotificationsQuery = { __typename?: 'Query', cursorNotifications: { __typename?: 'CursorNotifications', totalCount: number, unreadTotalCount: number, edges: Array<{ __typename?: 'NotificationEdge', cursor: string, node: { __typename?: 'Notification', id: number, toId: number, isRead: boolean, type: NotificationType, category: NotificationCategory, toType: NotificationTargetType, fromId?: number | null, venueId?: number | null, brandId?: number | null, bidId?: number | null, tenderId?: number | null, createdAtUtc: string, messageId?: number | null, bid?: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null } | null, tender?: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean } | null, venue?: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } } | null, brand?: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } | null, message?: { __typename?: 'Message', id: number, bidId: number, venueId?: number | null, brandId?: number | null, text: string, createdAtUtc: string, updatedAtUtc?: string | null } | null } }>, pageInfo: { __typename?: 'CursorPageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type OffsetNotificationsQueryVariables = Exact<{
  input: OffsetNotificationsInput;
}>;


export type OffsetNotificationsQuery = { __typename?: 'Query', offsetNotifications: { __typename?: 'OffsetNotifications', totalCount: number, unreadTotalCount: number, data: Array<{ __typename?: 'Notification', id: number, toId: number, isRead: boolean, type: NotificationType, category: NotificationCategory, toType: NotificationTargetType, fromId?: number | null, venueId?: number | null, brandId?: number | null, bidId?: number | null, tenderId?: number | null, createdAtUtc: string, messageId?: number | null, bid?: { __typename?: 'Bid', id: number, tenderId: number, brandId: number, userId: number, isAnonymous: boolean, productName?: string | null, volumeUnits?: number | null, productCategoryId?: number | null, averageWholesalePrice?: number | null, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, totalSupportValue?: number | null, rating?: number | null, ratingComment?: string | null, isRatingOutdated?: boolean | null, ratedAtUtc?: string | null, updatedAtUtc?: string | null, createdAtUtc?: string | null, status: BidStatus, avatarUrl?: string | null, avatarBucketKey?: string | null, isListingFeeProvided?: boolean | null, isFreeStockProvided?: boolean | null, isRetroDiscountProvided?: boolean | null, isPosBudgetProvided?: boolean | null, areWholesalersCompatible?: boolean | null, messagesCount?: number | null, isListingFeeReceived?: boolean | null, isFreeStockReceived?: boolean | null, isRetroDiscountReceived?: boolean | null, isPosBudgetReceived?: boolean | null, netPrice?: number | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, hasOtherBidsForThisVenue?: boolean | null, subscriptionTier: SubscriptionTier, successFee?: number | null, successFeeInvoiceId?: string | null, region: Region, productCategory?: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } | null, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null } | null, tender?: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean } | null, venue?: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } } | null, brand?: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } | null, message?: { __typename?: 'Message', id: number, bidId: number, venueId?: number | null, brandId?: number | null, text: string, createdAtUtc: string, updatedAtUtc?: string | null } | null }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type ProductCategoryInfoFragment = { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region };

export type ProductCategorySubscriptionItemFragment = { __typename?: 'ProductCategorySubscription', id: number, productCategoryId: number, packageType: ProductCategorySubscriptionType, stripeProductId: string, price: number };

export type ProductCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductCategoriesQuery = { __typename?: 'Query', productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> };

export type ProductCategorySubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductCategorySubscriptionsQuery = { __typename?: 'Query', productCategorySubscriptions: Array<{ __typename?: 'ProductCategorySubscription', id: number, productCategoryId: number, packageType: ProductCategorySubscriptionType, stripeProductId: string, price: number }> };

export type ProductTemplateInfoFragment = { __typename?: 'ProductTemplate', id: number, brandId: number, productCategoryId: number, productName: string, volumeUnits: number, averageWholesalePrice: number, productUrl?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, packagingType: string, unitType: string, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }>, brand: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } };

export type ProductTemplatesByBrandIdQueryVariables = Exact<{
  input: ProductTemplatesByBrandIdInput;
}>;


export type ProductTemplatesByBrandIdQuery = { __typename?: 'Query', productTemplatesByBrandId: Array<{ __typename?: 'ProductTemplate', id: number, brandId: number, productCategoryId: number, productName: string, volumeUnits: number, averageWholesalePrice: number, productUrl?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, packagingType: string, unitType: string, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }>, brand: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } }> };

export type DeleteProductTemplateByIdMutationVariables = Exact<{
  input: DeleteProductTemplateInput;
}>;


export type DeleteProductTemplateByIdMutation = { __typename?: 'Mutation', deleteProductTemplateById: boolean };

export type AddProductTemplateMutationVariables = Exact<{
  input: AddProductTemplateInput;
}>;


export type AddProductTemplateMutation = { __typename?: 'Mutation', addProductTemplate: { __typename?: 'ProductTemplate', id: number, brandId: number, productCategoryId: number, productName: string, volumeUnits: number, averageWholesalePrice: number, productUrl?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, packagingType: string, unitType: string, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }>, brand: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } } };

export type EditProductTemplateMutationVariables = Exact<{
  input: EditProductTemplateInput;
}>;


export type EditProductTemplateMutation = { __typename?: 'Mutation', editProductTemplate: { __typename?: 'ProductTemplate', id: number, brandId: number, productCategoryId: number, productName: string, volumeUnits: number, averageWholesalePrice: number, productUrl?: string | null, avatarUrl?: string | null, avatarBucketKey?: string | null, packagingType: string, unitType: string, isDirectSupplyCompatible: boolean, isAnyWholesalerCompatible: boolean, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }>, brand: { __typename?: 'Brand', id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } } };

export type ProductUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductUnitQuery = { __typename?: 'Query', productUnits: Array<string> };

export type ProductPackagingQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductPackagingQuery = { __typename?: 'Query', productPackaging: Array<string> };

export type PromoDealInfoFragment = { __typename?: 'PromoDeal', id: number, brandId: number, userId: number, status: PromoDealStatus, productName: string, volumeUnits: number, productCategoryId: number, averageWholesalePrice: number, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, updatedAtUtc?: string | null, createdAtUtc: string, avatarUrl?: string | null, avatarBucketKey?: string | null, packagingType: string, unitType: string, isAnyWholesalerCompatible: boolean, isDirectSupplyCompatible: boolean, region: Region, brand?: { __typename?: 'Brand', hasActiveSubscription: boolean, id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } | null, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, productCategory?: { __typename?: 'ProductCategory', id: number, name: string } | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string }> };

export type PromoDealsQueryVariables = Exact<{
  input: PromoDealsInput;
}>;


export type PromoDealsQuery = { __typename?: 'Query', promoDeals: { __typename?: 'PromoDeals', totalCount: number, data: Array<{ __typename?: 'PromoDeal', id: number, brandId: number, userId: number, status: PromoDealStatus, productName: string, volumeUnits: number, productCategoryId: number, averageWholesalePrice: number, productUrl?: string | null, supportsListingFee?: boolean | null, listingFeeTotalAmount?: number | null, listingFeeNotes?: string | null, supportsFreeStock?: boolean | null, freeStockUnitsAmount?: number | null, freeStockNotes?: string | null, supportsRetroDiscount?: boolean | null, retroDiscountAmountPerUnit?: number | null, retroDiscountNotes?: string | null, supportsPosBudget?: boolean | null, posBudgetTotalAmount?: number | null, posBudgetNotes?: string | null, otherSupport?: string | null, updatedAtUtc?: string | null, createdAtUtc: string, avatarUrl?: string | null, avatarBucketKey?: string | null, packagingType: string, unitType: string, isAnyWholesalerCompatible: boolean, isDirectSupplyCompatible: boolean, region: Region, brand?: { __typename?: 'Brand', hasActiveSubscription: boolean, id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> } | null, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, productCategory?: { __typename?: 'ProductCategory', id: number, name: string } | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string }> }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type RegisteredCompanyWithoutIdInfoFragment = { __typename?: 'RegisteredCompanyWithoutId', name: string, number: string, status: string, dateOfCreation: string, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress: string };

export type RegisteredCompanyInfoFragment = { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null };

export type GetDataFromCompanyNumberQueryVariables = Exact<{
  input: GetDataFromCompanyNumberInput;
}>;


export type GetDataFromCompanyNumberQuery = { __typename?: 'Query', getDataFromCompanyNumber: { __typename?: 'RegisteredCompanyWithoutId', name: string, number: string, status: string, dateOfCreation: string, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress: string } };

export type SubscriptionInfoFragment = { __typename?: 'Subscription', id: string, customerId: string, createdAtUtc: number, currentPeriodEnd: number, currentPeriodStart: number, isCanceled: boolean, isExpired: boolean, amount?: number | null, subscriptionTier?: SubscriptionTier | null, successFee?: number | null };

export type NonSubscribedProductCategoryInfoFragment = { __typename?: 'NonSubscribedProductCategory', categoryName: string, numberOfProductsInCategory: number, productCategoryId: number, stripeProductId: string };

export type StripeProductCategorySubscriptionItemFragment = { __typename?: 'StripeProductCategorySubscription', categoryName: string, numberOfProductsInCategory: number, pricePerMonth: number, packageType: ProductCategorySubscriptionType, productCategoryId: number, productCategorySubscriptionId: number, stripeProductId: string };

export type UpgradeToBespokeDataInfoFragment = { __typename?: 'UpgradeToBespokeData', wasSuccessfullyUpdated: boolean, needsRedirect: boolean, redirectUrl?: string | null };

export type InvoiceInfoFragment = { __typename?: 'Invoice', id: string, total: number, createdAt: number, customerId?: string | null, pdfUrl?: string | null, status?: string | null, hostedInvoiceUrl?: string | null };

export type SuccessFeeInvoiceInfoFragment = { __typename?: 'SuccessFeeInvoice', id: string, total: number, createdAt: number, customerId: string, paymentUrl: string, status: string, pdfUrl: string };

export type SuccessFeeInvoiceListItemInfoFragment = { __typename?: 'SuccessFeeInvoiceListItem', id: string, tenderName: string, venueName: string, total: number, createdAt: number, customerId: string, paymentUrl: string, status: string, pdfUrl: string, bidUnitType: string, packagingType: string, tenderUnitType: string, successFee: number, bidVolumeUnits: number, estimatedVolume: number, tenderVolumeUnits: number, averageWholesaleBidPrice: number };

export type BespokeCheckDataInfoFragment = { __typename?: 'BespokeCheckData', successFee: number, pricePerMonth: number };

export type CreateStripeCheckoutMutationVariables = Exact<{
  input: CreateStripeCheckoutInput;
}>;


export type CreateStripeCheckoutMutation = { __typename?: 'Mutation', createStripeCheckout: string };

export type UpdateSubscriptionMutationVariables = Exact<{
  input: UpdateSubscriptionInput;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription: boolean };

export type SubscriptionQueryVariables = Exact<{
  stripeSubscriptionId: Scalars['String']['input'];
}>;


export type SubscriptionQuery = { __typename?: 'Query', subscription: { __typename?: 'Subscription', id: string, customerId: string, createdAtUtc: number, currentPeriodEnd: number, currentPeriodStart: number, isCanceled: boolean, isExpired: boolean, amount?: number | null, subscriptionTier?: SubscriptionTier | null, successFee?: number | null } };

export type SubscriptionsQueryVariables = Exact<{
  stripeSubscriptionId: Scalars['String']['input'];
}>;


export type SubscriptionsQuery = { __typename?: 'Query', subscriptions: Array<{ __typename?: 'StripeProductCategorySubscription', categoryName: string, numberOfProductsInCategory: number, pricePerMonth: number, packageType: ProductCategorySubscriptionType, productCategoryId: number, productCategorySubscriptionId: number, stripeProductId: string }> };

export type NonSubscribedProductCategoriesQueryVariables = Exact<{
  stripeSubscriptionId: Scalars['String']['input'];
}>;


export type NonSubscribedProductCategoriesQuery = { __typename?: 'Query', nonSubscribedProductCategories: Array<{ __typename?: 'NonSubscribedProductCategory', categoryName: string, numberOfProductsInCategory: number, productCategoryId: number, stripeProductId: string }> };

export type InvoicesQueryVariables = Exact<{
  stripeCustomerId: Scalars['String']['input'];
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'Invoice', id: string, total: number, createdAt: number, customerId?: string | null, pdfUrl?: string | null, status?: string | null, hostedInvoiceUrl?: string | null }> };

export type SuccessFeeInvoiceListQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type SuccessFeeInvoiceListQuery = { __typename?: 'Query', successFeeInvoiceList: Array<{ __typename?: 'SuccessFeeInvoiceListItem', id: string, tenderName: string, venueName: string, total: number, createdAt: number, customerId: string, paymentUrl: string, status: string, pdfUrl: string, bidUnitType: string, packagingType: string, tenderUnitType: string, successFee: number, bidVolumeUnits: number, estimatedVolume: number, tenderVolumeUnits: number, averageWholesaleBidPrice: number }> };

export type SuccessFeeInvoiceByIdQueryVariables = Exact<{
  invoiceId: Scalars['String']['input'];
}>;


export type SuccessFeeInvoiceByIdQuery = { __typename?: 'Query', successFeeInvoiceById: { __typename?: 'SuccessFeeInvoice', id: string, total: number, createdAt: number, customerId: string, paymentUrl: string, status: string, pdfUrl: string } };

export type BespokeTokenCheckQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type BespokeTokenCheckQuery = { __typename?: 'Query', bespokeTokenCheck: { __typename?: 'BespokeCheckData', successFee: number, pricePerMonth: number } };

export type UpgradeToBespokeMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type UpgradeToBespokeMutation = { __typename?: 'Mutation', upgradeToBespoke: { __typename?: 'UpgradeToBespokeData', wasSuccessfullyUpdated: boolean, needsRedirect: boolean, redirectUrl?: string | null } };

export type CreateSubscriptionCheckoutMutationVariables = Exact<{
  input: CreateStripeCheckoutNewInput;
}>;


export type CreateSubscriptionCheckoutMutation = { __typename?: 'Mutation', createStripeCheckoutNew: string };

export type RemoveProductCategorySubscriptionMutationVariables = Exact<{
  input: RemoveProductCategorySubscriptionInput;
}>;


export type RemoveProductCategorySubscriptionMutation = { __typename?: 'Mutation', removeProductCategorySubscription: boolean };

export type UpgradeProductCategorySubscriptionMutationVariables = Exact<{
  input: UpgradeProductCategorySubscriptionInput;
}>;


export type UpgradeProductCategorySubscriptionMutation = { __typename?: 'Mutation', upgradeProductCategorySubscription: boolean };

export type AddProductCategorySubscriptionMutationVariables = Exact<{
  input: AddProductCategorySubscriptionInput;
}>;


export type AddProductCategorySubscriptionMutation = { __typename?: 'Mutation', addProductCategorySubscription: boolean };

export type TenderInfoFragment = { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean };

export type TenderByIdQueryVariables = Exact<{
  tenderId: Scalars['Int']['input'];
}>;


export type TenderByIdQuery = { __typename?: 'Query', tenderById: { __typename?: 'Tender', listingTypeId: number, productCategoryId: number, totalReceivedBids: number, id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, venue: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }, listingType: { __typename?: 'ListingType', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number, region: Region }, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, user?: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null } };

export type TenderTemplateByTenderIdQueryVariables = Exact<{
  tenderId: Scalars['Int']['input'];
}>;


export type TenderTemplateByTenderIdQuery = { __typename?: 'Query', tenderById: { __typename?: 'Tender', venueId: number, listingTypeId: number, productCategoryId: number, tenderDetails?: string | null, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, userId: number, packagingType?: string | null, unitType?: string | null, region: Region, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }, listingType: { __typename?: 'ListingType', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number, region: Region }, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null } };

export type VenueDashboardTendersQueryVariables = Exact<{
  input: VenueDashboardTendersInput;
}>;


export type VenueDashboardTendersQuery = { __typename?: 'Query', venueDashboardTenders: { __typename?: 'UnionTenders', totalCount: number, data: Array<{ __typename: 'Tender', id: number, status: TenderStatus, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, name: string, estimatedVolume?: number | null, volumeUnits?: number | null, totalReceivedBids: number, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, region: Region, venue: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } }, listingType: { __typename?: 'ListingType', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number, region: Region }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } } | { __typename: 'TenderDraft', id: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, name: string, estimatedVolume?: number | null, volumeUnits?: number | null, createdAtUtc: string, draftPackagingType?: string | null, draftUnitType?: string | null, listingType: { __typename?: 'ListingType', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number, region: Region }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region } }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type AddTenderMutationVariables = Exact<{
  input: AddTenderInput;
}>;


export type AddTenderMutation = { __typename?: 'Mutation', addTender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null } };

export type EditTenderMutationVariables = Exact<{
  input: EditTenderInput;
}>;


export type EditTenderMutation = { __typename?: 'Mutation', editTender: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null } };

export type TenderListQueryVariables = Exact<{
  input: TendersInput;
}>;


export type TenderListQuery = { __typename?: 'Query', tenderList: { __typename?: 'Tenders', totalCount: number, data: Array<{ __typename?: 'Tender', id: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, name: string, estimatedVolume?: number | null, volumeUnits?: number | null, totalReceivedBids: number, status: TenderStatus, userId: number, venueId: number, productCategoryId: number, listingTypeId: number, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, region: Region, isPrivate: boolean, venue: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } }, listingType: { __typename?: 'ListingType', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number, region: Region }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type TenderListFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TenderListFilterOptionsQuery = { __typename?: 'Query', tenderListFilterOptions: Array<{ __typename?: 'Filter', label: string, options: Array<{ __typename?: 'FilterOption', label: string, value: string }> }> };

export type DeleteTenderByIdMutationVariables = Exact<{
  tenderId: Scalars['Int']['input'];
}>;


export type DeleteTenderByIdMutation = { __typename?: 'Mutation', deleteTenderById: boolean };

export type ChooseWinnerMutationVariables = Exact<{
  input: ChooseWinnerInput;
}>;


export type ChooseWinnerMutation = { __typename?: 'Mutation', chooseWinner: { __typename?: 'Tender', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, status: TenderStatus, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, totalReceivedBids: number, createdAtUtc?: string | null, updatedAtUtc?: string | null, receivedSupportStatus?: TenderSupportStatus | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, feedback?: string | null, region: Region, isPrivate: boolean } };

export type MultipleBidsTendersQueryVariables = Exact<{
  input: TendersInput;
}>;


export type MultipleBidsTendersQuery = { __typename?: 'Query', tenderList: { __typename?: 'Tenders', totalCount: number, data: Array<{ __typename?: 'Tender', id: number, name: string, listingTypeId: number, productCategoryId: number, supportsFreeStock?: TenderSupportOption | null, supportsListingFee?: TenderSupportOption | null, supportsPosBudget?: TenderSupportOption | null, supportsRetroDiscount?: TenderSupportOption | null, supportDetails?: string | null, tenderDetails?: string | null, volumeDetails?: string | null, estimatedVolume?: number | null, volumeUnits?: number | null, listingEndsAtUtc?: string | null, listingStartsAtUtc?: string | null, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, hasBrandsBid?: boolean | null, status: TenderStatus, venueId: number, totalReceivedBids: number, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, region: Region, isPrivate: boolean, venue: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } }, files?: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> | null, listingType: { __typename?: 'ListingType', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number, region: Region }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }, wholesalers?: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> | null }>, pageInfo: { __typename?: 'OffsetPageInfo', currentPage: number, totalPages: number, hasNextPage: boolean, hasPrevPage: boolean } } };

export type TopTendersBidsCountMinBoundaryQueryVariables = Exact<{ [key: string]: never; }>;


export type TopTendersBidsCountMinBoundaryQuery = { __typename?: 'Query', topTendersBidsCountMinBoundary: number };

export type TenderDraftInfoFragment = { __typename?: 'TenderDraft', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock: TenderSupportOption, supportsListingFee: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportDetails?: string | null, createdAtUtc: string, updatedAtUtc?: string | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible: boolean, region: Region, isPrivate: boolean };

export type TenderDraftByIdQueryVariables = Exact<{
  tenderDraftId: Scalars['Int']['input'];
}>;


export type TenderDraftByIdQuery = { __typename?: 'Query', tenderDraftById: { __typename?: 'TenderDraft', listingTypeId: number, productCategoryId: number, id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock: TenderSupportOption, supportsListingFee: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportDetails?: string | null, createdAtUtc: string, updatedAtUtc?: string | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible: boolean, region: Region, isPrivate: boolean, venue: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } }, user: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null }, productCategory: { __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }, listingType: { __typename?: 'ListingType', id: number, name: string, suggestedTenderLengthInMonths: number, suggestedListingLengthInMonths: number, order: number, region: Region }, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }>, files: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> } };

export type EditTenderDraftMutationVariables = Exact<{
  input: EditTenderDraftInput;
}>;


export type EditTenderDraftMutation = { __typename?: 'Mutation', editTenderDraft: { __typename?: 'TenderDraft', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock: TenderSupportOption, supportsListingFee: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportDetails?: string | null, createdAtUtc: string, updatedAtUtc?: string | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible: boolean, region: Region, isPrivate: boolean, files: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> } };

export type AddTenderDraftMutationVariables = Exact<{
  input: AddTenderDraftInput;
}>;


export type AddTenderDraftMutation = { __typename?: 'Mutation', addTenderDraft: { __typename?: 'TenderDraft', id: number, userId: number, venueId: number, name: string, listingStartsAtUtc?: string | null, listingEndsAtUtc?: string | null, listingTypeId: number, productCategoryId: number, tenderStartsAtUtc?: string | null, tenderEndsAtUtc?: string | null, tenderDetails?: string | null, estimatedVolume?: number | null, volumeUnits?: number | null, volumeDetails?: string | null, supportsFreeStock: TenderSupportOption, supportsListingFee: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportDetails?: string | null, createdAtUtc: string, updatedAtUtc?: string | null, packagingType?: string | null, unitType?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible: boolean, region: Region, isPrivate: boolean, files: Array<{ __typename?: 'File', id: number, filename: string, bucketKey: string, context: FileContext, downloadUrl: string, fileSizeInKib: number }> } };

export type DeleteTenderDraftByIdMutationVariables = Exact<{
  tenderDraftId: Scalars['Int']['input'];
}>;


export type DeleteTenderDraftByIdMutation = { __typename?: 'Mutation', deleteTenderDraftById: boolean };

export type TenderPreferenceInfoFragment = { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> };

export type EditTenderPreferenceMutationVariables = Exact<{
  input: EditTenderPreferenceInput;
}>;


export type EditTenderPreferenceMutation = { __typename?: 'Mutation', editTenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } };

export type TenderPreferenceByVenueIdQueryVariables = Exact<{
  venueId: Scalars['Int']['input'];
}>;


export type TenderPreferenceByVenueIdQuery = { __typename?: 'Query', tenderPreferenceByVenueId: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } };

export type UserInfoFragment = { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null };

export type UserMeQueryVariables = Exact<{
  input?: InputMaybe<UserMeInput>;
}>;


export type UserMeQuery = { __typename?: 'Query', userMe: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, firstFourVenues: Array<{ __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } }>, brands: Array<{ __typename?: 'Brand', hasActiveSubscription: boolean, id: number, userId: number, name?: string | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasBids: boolean, canCreateBid: boolean, hasProductTemplates: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, isAnonymousBidAllowed?: boolean | null, vatNumber?: string | null, vatCompanyName?: string | null, vatCountryCode?: string | null, vatConsultationNumber?: string | null, vatProcessingDate?: string | null, awrsNumber?: string | null, awrsStatus?: string | null, awrsCompanyName?: string | null, awrsPlaceBusiness?: string | null, awrsRegistrationDate?: string | null, awrsDeregistrationDate?: string | null, complianceCheckDate?: string | null, complianceNextDate?: string | null, complianceRiskLevel?: string | null, complianceConfirmation?: string | null, isEnterpriseSubscriptionRequestSent: boolean, subscriptionTier: SubscriptionTier, successFee: number, stripeCustomerId?: string | null, stripeSubscriptionId?: string | null, failedPaymentIntentCounter: number, region: Region, canSeeOtherBids: boolean, productCategories: Array<{ __typename?: 'ProductCategory', id: number, name: string, parentId?: number | null, unitType?: string | null, region: Region }> }>, activeVenue?: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } } | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } };

export type UserExistsQueryVariables = Exact<{
  input: UserExistsInput;
}>;


export type UserExistsQuery = { __typename?: 'Query', userExists: boolean };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'Mutation', signUp: string };

export type SalesDemoSignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SalesDemoSignUpMutation = { __typename?: 'Mutation', salesDemoSignUp: boolean };

export type ChangeEmailMutationVariables = Exact<{
  input: ChangeEmailInput;
}>;


export type ChangeEmailMutation = { __typename?: 'Mutation', changeEmail: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } };

export type UpdateCompanyBillingDataMutationVariables = Exact<{
  input: UpdateCompanyBillingDataInput;
}>;


export type UpdateCompanyBillingDataMutation = { __typename?: 'Mutation', updateCompanyBillingData: { __typename?: 'User', id: number, firebaseId: string, userType: UserType, email: string, companyName?: string | null, addressId?: number | null, isSalesDemo?: boolean | null, tradingName?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, registeredCompany?: { __typename?: 'RegisteredCompany', id: number, name: string, number: string, status?: string | null, dateOfCreation?: string | null, postalCode?: string | null, region?: string | null, locality?: string | null, country?: string | null, firstAddressLine?: string | null, secondAddressLine?: string | null, formattedAddress?: string | null, addressId?: number | null, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } | null, tradingAddress?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null } };

export type RequestChangeEmailMutationVariables = Exact<{
  emailToChange: Scalars['String']['input'];
}>;


export type RequestChangeEmailMutation = { __typename?: 'Mutation', requestChangeEmail: boolean };

export type ConfirmChangeEmailMutationVariables = Exact<{
  changeEmailToken: Scalars['String']['input'];
}>;


export type ConfirmChangeEmailMutation = { __typename?: 'Mutation', confirmChangeEmail: boolean };

export type UserActionLogInfoFragment = { __typename?: 'UserActionLog', id: number, userId: number, eventName: string, additionalData?: Object | null };

export type AddUserActionLogMutationVariables = Exact<{
  input: UserActionLogInput;
}>;


export type AddUserActionLogMutation = { __typename?: 'Mutation', addUserActionLog: { __typename?: 'UserActionLog', id: number, userId: number, eventName: string, additionalData?: Object | null } };

export type VenueInfoFragment = { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } };

export type UserVenuesByNameQueryVariables = Exact<{
  venueName: Scalars['String']['input'];
}>;


export type UserVenuesByNameQuery = { __typename?: 'Query', userVenuesByName: Array<{ __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } }> };

export type EditVenueMutationVariables = Exact<{
  input: EditVenueInput;
}>;


export type EditVenueMutation = { __typename?: 'Mutation', editVenue: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } } };

export type UserVenuesQueryVariables = Exact<{
  input: UserVenuesInput;
}>;


export type UserVenuesQuery = { __typename?: 'Query', userVenues: { __typename?: 'Venues', totalCount: number, edges: Array<{ __typename?: 'VenueEdge', cursor: string, node: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } } }>, pageInfo: { __typename?: 'CursorPageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } };

export type SearchVenuesQueryVariables = Exact<{
  input: SearchVenuesInput;
}>;


export type SearchVenuesQuery = { __typename?: 'Query', searchVenues: Array<{ __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } }> };

export type VenueByIdQueryVariables = Exact<{
  venueId: Scalars['Int']['input'];
}>;


export type VenueByIdQuery = { __typename?: 'Query', venueById: { __typename?: 'Venue', id: number, userId: number, name?: string | null, venueCategoryName?: string | null, addressId?: number | null, webPageUrl?: string | null, instagramUrl?: string | null, groupName?: string | null, hasTenders: boolean, canCreateTender: boolean, avatarUrl?: string | null, avatarBucketKey?: string | null, phoneNumber?: string | null, description?: string | null, stripeCustomerId?: string | null, region: Region, address?: { __typename?: 'Address', id: number, name: string, postCode: string, placeId: string, country?: string | null, administrativeAreaLevel1?: string | null, administrativeAreaLevel1ShortName?: string | null, administrativeAreaLevel2?: string | null, administrativeAreLevel2ShortName?: string | null, locality?: string | null, coordinates: { __typename?: 'Point', x: number, y: number } } | null, tenderPreference: { __typename?: 'TenderPreference', id: number, venueId: number, supportsListingFee: TenderSupportOption, supportsFreeStock: TenderSupportOption, supportsRetroDiscount: TenderSupportOption, supportsPosBudget: TenderSupportOption, supportDetails?: string | null, isDirectSupplyCompatible?: boolean | null, isAnyWholesalerCompatible?: boolean | null, wholesalers: Array<{ __typename?: 'Wholesaler', id: number, name: string, region: Region }> } } };

export type VenueDashboardMetricsByVenueIdQueryVariables = Exact<{
  venueId: Scalars['Int']['input'];
}>;


export type VenueDashboardMetricsByVenueIdQuery = { __typename?: 'Query', venueDashboardMetricsByVenueId: Array<{ __typename?: 'VenueDashboardMetric', type: DashboardMetricType, label: VenueDashboardMetricLabel, value: string }> };

export type VenueCategoriesQueryVariables = Exact<{
  region: Region;
}>;


export type VenueCategoriesQuery = { __typename?: 'Query', venueCategories: Array<string> };

export type VenueSettingsInfoFragment = { __typename?: 'VenueSettings', id: number, venueId: number, isNewTenderMailNotificationEnabled: boolean, isNewBidsMailNotificationEnabled: boolean, isBidUpdatedMailNotificationEnabled: boolean, isMyTenderEndedMailNotificationEnabled: boolean, isReTenderMailNotificationEnabled: boolean, isNewTenderInAppNotificationEnabled: boolean, isNewBidsInAppNotificationEnabled: boolean, isBidUpdatedInAppNotificationEnabled: boolean, isMyTenderEndedInAppNotificationEnabled: boolean, isReTenderInAppNotificationEnabled: boolean };

export type VenueSettingsByIdQueryVariables = Exact<{
  venueId: Scalars['Int']['input'];
}>;


export type VenueSettingsByIdQuery = { __typename?: 'Query', venueSettingsByVenueId: { __typename?: 'VenueSettings', id: number, venueId: number, isNewTenderMailNotificationEnabled: boolean, isNewBidsMailNotificationEnabled: boolean, isBidUpdatedMailNotificationEnabled: boolean, isMyTenderEndedMailNotificationEnabled: boolean, isReTenderMailNotificationEnabled: boolean, isNewTenderInAppNotificationEnabled: boolean, isNewBidsInAppNotificationEnabled: boolean, isBidUpdatedInAppNotificationEnabled: boolean, isMyTenderEndedInAppNotificationEnabled: boolean, isReTenderInAppNotificationEnabled: boolean } };

export type EditVenueSettingsMutationVariables = Exact<{
  input: EditVenueSettingsInput;
}>;


export type EditVenueSettingsMutation = { __typename?: 'Mutation', editVenueSettings: { __typename?: 'VenueSettings', id: number, venueId: number, isNewTenderMailNotificationEnabled: boolean, isNewBidsMailNotificationEnabled: boolean, isBidUpdatedMailNotificationEnabled: boolean, isMyTenderEndedMailNotificationEnabled: boolean, isReTenderMailNotificationEnabled: boolean, isNewTenderInAppNotificationEnabled: boolean, isNewBidsInAppNotificationEnabled: boolean, isBidUpdatedInAppNotificationEnabled: boolean, isMyTenderEndedInAppNotificationEnabled: boolean, isReTenderInAppNotificationEnabled: boolean } };

export type WholesalerInfoFragment = { __typename?: 'Wholesaler', id: number, name: string, region: Region };

export type SearchWholesalersQueryVariables = Exact<{
  input: WholesalerSearchInput;
}>;


export type SearchWholesalersQuery = { __typename?: 'Query', searchWholesalers: { __typename?: 'Wholesalers', totalCount: number, edges: Array<{ __typename?: 'WholesalerEdge', cursor: string, node: { __typename?: 'Wholesaler', id: number, name: string, region: Region } }>, pageInfo: { __typename?: 'CursorPageInfo', startCursor: string, endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean } } };

export const CursorPageInfoFragmentDoc = gql`
    fragment CursorPageInfo on CursorPageInfo {
  startCursor
  endCursor
  hasNextPage
  hasPreviousPage
}
    `;
export const OffsetPageInfoFragmentDoc = gql`
    fragment OffsetPageInfo on OffsetPageInfo {
  currentPage
  totalPages
  hasNextPage
  hasPrevPage
}
    `;
export const BankAccountInfoFragmentDoc = gql`
    fragment BankAccountInfo on BankAccount {
  id
  userId
  accountName
  accountNumber
  sortCode
}
    `;
export const BrandSettingsInfoFragmentDoc = gql`
    fragment BrandSettingsInfo on BrandSettings {
  id
  brandId
  isRatingProvidedMailNotificationEnabled
  isTenderUpdatedMailNotificationEnabled
  isNewTenderMailNotificationEnabled
  isRatingProvidedInAppNotificationEnabled
  isTenderUpdatedInAppNotificationEnabled
  isNewTenderInAppNotificationEnabled
}
    `;
export const ListingTypeInfoFragmentDoc = gql`
    fragment ListingTypeInfo on ListingType {
  id
  name
  suggestedTenderLengthInMonths
  suggestedListingLengthInMonths
  order
  region
}
    `;
export const ProductCategoryInfoFragmentDoc = gql`
    fragment ProductCategoryInfo on ProductCategory {
  id
  name
  parentId
  unitType
  region
}
    `;
export const WholesalerInfoFragmentDoc = gql`
    fragment WholesalerInfo on Wholesaler {
  id
  name
  region
}
    `;
export const BidInfoFragmentDoc = gql`
    fragment BidInfo on Bid {
  id
  tenderId
  brandId
  userId
  isAnonymous
  productName
  volumeUnits
  productCategory {
    ...ProductCategoryInfo
  }
  productCategoryId
  wholesalers {
    ...WholesalerInfo
  }
  averageWholesalePrice
  productUrl
  supportsListingFee
  listingFeeTotalAmount
  listingFeeNotes
  supportsFreeStock
  freeStockUnitsAmount
  freeStockNotes
  supportsRetroDiscount
  retroDiscountAmountPerUnit
  retroDiscountNotes
  supportsPosBudget
  posBudgetTotalAmount
  posBudgetNotes
  otherSupport
  totalSupportValue
  rating
  ratingComment
  isRatingOutdated
  ratedAtUtc
  updatedAtUtc
  createdAtUtc
  status
  avatarUrl
  avatarBucketKey
  isListingFeeProvided
  isFreeStockProvided
  isRetroDiscountProvided
  isPosBudgetProvided
  areWholesalersCompatible
  messagesCount
  isListingFeeReceived
  isFreeStockReceived
  isRetroDiscountReceived
  isPosBudgetReceived
  netPrice
  packagingType
  unitType
  isDirectSupplyCompatible
  isAnyWholesalerCompatible
  hasOtherBidsForThisVenue
  subscriptionTier
  successFee
  successFeeInvoiceId
  region
}
    ${ProductCategoryInfoFragmentDoc}
${WholesalerInfoFragmentDoc}`;
export const TenderInfoFragmentDoc = gql`
    fragment TenderInfo on Tender {
  id
  userId
  venueId
  name
  listingStartsAtUtc
  listingEndsAtUtc
  listingTypeId
  productCategoryId
  tenderStartsAtUtc
  tenderEndsAtUtc
  tenderDetails
  status
  estimatedVolume
  volumeUnits
  volumeDetails
  supportsFreeStock
  supportsListingFee
  supportsPosBudget
  supportsRetroDiscount
  supportDetails
  totalReceivedBids
  createdAtUtc
  updatedAtUtc
  receivedSupportStatus
  packagingType
  unitType
  isDirectSupplyCompatible
  isAnyWholesalerCompatible
  feedback
  region
  isPrivate
}
    `;
export const AddressInfoFragmentDoc = gql`
    fragment AddressInfo on Address {
  id
  name
  coordinates {
    x
    y
  }
  postCode
  placeId
  country
  administrativeAreaLevel1
  administrativeAreaLevel1ShortName
  administrativeAreaLevel2
  administrativeAreLevel2ShortName
  locality
}
    `;
export const TenderPreferenceInfoFragmentDoc = gql`
    fragment TenderPreferenceInfo on TenderPreference {
  id
  venueId
  supportsListingFee
  supportsFreeStock
  supportsRetroDiscount
  supportsPosBudget
  wholesalers {
    ...WholesalerInfo
  }
  supportDetails
  isDirectSupplyCompatible
  isAnyWholesalerCompatible
}
    ${WholesalerInfoFragmentDoc}`;
export const VenueInfoFragmentDoc = gql`
    fragment VenueInfo on Venue {
  id
  userId
  name
  venueCategoryName
  addressId
  address {
    ...AddressInfo
  }
  webPageUrl
  instagramUrl
  groupName
  hasTenders
  canCreateTender
  tenderPreference {
    ...TenderPreferenceInfo
  }
  avatarUrl
  avatarBucketKey
  phoneNumber
  description
  stripeCustomerId
  region
}
    ${AddressInfoFragmentDoc}
${TenderPreferenceInfoFragmentDoc}`;
export const BrandInfoFragmentDoc = gql`
    fragment BrandInfo on Brand {
  id
  userId
  name
  webPageUrl
  instagramUrl
  groupName
  hasBids
  canCreateBid
  hasProductTemplates
  avatarUrl
  avatarBucketKey
  phoneNumber
  isAnonymousBidAllowed
  vatNumber
  vatCompanyName
  vatCountryCode
  vatConsultationNumber
  vatProcessingDate
  awrsNumber
  awrsStatus
  awrsCompanyName
  awrsPlaceBusiness
  awrsRegistrationDate
  awrsDeregistrationDate
  complianceCheckDate
  complianceNextDate
  complianceRiskLevel
  complianceConfirmation
  isEnterpriseSubscriptionRequestSent
  subscriptionTier
  successFee
  stripeCustomerId
  stripeSubscriptionId
  successFee
  failedPaymentIntentCounter
  region
  canSeeOtherBids
  productCategories {
    ...ProductCategoryInfo
  }
}
    ${ProductCategoryInfoFragmentDoc}`;
export const MessageInfoFragmentDoc = gql`
    fragment MessageInfo on Message {
  id
  bidId
  venueId
  brandId
  text
  createdAtUtc
  updatedAtUtc
}
    `;
export const NotificationInfoFragmentDoc = gql`
    fragment NotificationInfo on Notification {
  id
  toId
  isRead
  type
  category
  toType
  fromId
  venueId
  brandId
  bidId
  tenderId
  createdAtUtc
  messageId
  bid {
    ...BidInfo
  }
  tender {
    ...TenderInfo
  }
  venue {
    ...VenueInfo
  }
  brand {
    ...BrandInfo
  }
  message {
    ...MessageInfo
  }
}
    ${BidInfoFragmentDoc}
${TenderInfoFragmentDoc}
${VenueInfoFragmentDoc}
${BrandInfoFragmentDoc}
${MessageInfoFragmentDoc}`;
export const ProductCategorySubscriptionItemFragmentDoc = gql`
    fragment ProductCategorySubscriptionItem on ProductCategorySubscription {
  id
  productCategoryId
  packageType
  stripeProductId
  price
}
    `;
export const FileInfoFragmentDoc = gql`
    fragment FileInfo on File {
  id
  filename
  bucketKey
  context
  downloadUrl
  fileSizeInKib
}
    `;
export const ProductTemplateInfoFragmentDoc = gql`
    fragment ProductTemplateInfo on ProductTemplate {
  id
  brandId
  productCategoryId
  productName
  volumeUnits
  averageWholesalePrice
  productUrl
  files {
    ...FileInfo
  }
  wholesalers {
    ...WholesalerInfo
  }
  brand {
    ...BrandInfo
  }
  productCategory {
    ...ProductCategoryInfo
  }
  avatarUrl
  avatarBucketKey
  packagingType
  unitType
  isDirectSupplyCompatible
  isAnyWholesalerCompatible
}
    ${FileInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${BrandInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}`;
export const BrandInfoWithHasActiveSubscriptionFieldFragmentDoc = gql`
    fragment BrandInfoWithHasActiveSubscriptionField on Brand {
  ...BrandInfo
  hasActiveSubscription
}
    ${BrandInfoFragmentDoc}`;
export const RegisteredCompanyInfoFragmentDoc = gql`
    fragment RegisteredCompanyInfo on RegisteredCompany {
  id
  name
  number
  status
  dateOfCreation
  postalCode
  region
  locality
  country
  firstAddressLine
  secondAddressLine
  formattedAddress
  addressId
}
    `;
export const UserInfoFragmentDoc = gql`
    fragment UserInfo on User {
  id
  firebaseId
  userType
  email
  companyName
  addressId
  address {
    ...AddressInfo
  }
  registeredCompany {
    ...RegisteredCompanyInfo
  }
  isSalesDemo
  tradingName
  tradingAddress {
    ...AddressInfo
  }
  registeredCompany {
    ...RegisteredCompanyInfo
    address {
      ...AddressInfo
    }
  }
  region
}
    ${AddressInfoFragmentDoc}
${RegisteredCompanyInfoFragmentDoc}`;
export const PromoDealInfoFragmentDoc = gql`
    fragment PromoDealInfo on PromoDeal {
  id
  brandId
  userId
  status
  productName
  volumeUnits
  productCategoryId
  averageWholesalePrice
  productUrl
  supportsListingFee
  listingFeeTotalAmount
  listingFeeNotes
  supportsFreeStock
  freeStockUnitsAmount
  freeStockNotes
  supportsRetroDiscount
  retroDiscountAmountPerUnit
  retroDiscountNotes
  supportsPosBudget
  posBudgetTotalAmount
  posBudgetNotes
  otherSupport
  updatedAtUtc
  createdAtUtc
  avatarUrl
  avatarBucketKey
  packagingType
  unitType
  brand {
    ...BrandInfoWithHasActiveSubscriptionField
  }
  user {
    ...UserInfo
  }
  files {
    ...FileInfo
  }
  productCategory {
    id
    name
  }
  wholesalers {
    id
    name
  }
  isAnyWholesalerCompatible
  isDirectSupplyCompatible
  region
}
    ${BrandInfoWithHasActiveSubscriptionFieldFragmentDoc}
${UserInfoFragmentDoc}
${FileInfoFragmentDoc}`;
export const RegisteredCompanyWithoutIdInfoFragmentDoc = gql`
    fragment RegisteredCompanyWithoutIdInfo on RegisteredCompanyWithoutId {
  name
  number
  status
  dateOfCreation
  postalCode
  region
  locality
  country
  firstAddressLine
  secondAddressLine
  formattedAddress
}
    `;
export const SubscriptionInfoFragmentDoc = gql`
    fragment SubscriptionInfo on Subscription {
  id
  customerId
  createdAtUtc
  currentPeriodEnd
  currentPeriodStart
  isCanceled
  isExpired
  amount
  subscriptionTier
  successFee
}
    `;
export const NonSubscribedProductCategoryInfoFragmentDoc = gql`
    fragment NonSubscribedProductCategoryInfo on NonSubscribedProductCategory {
  categoryName
  numberOfProductsInCategory
  productCategoryId
  stripeProductId
}
    `;
export const StripeProductCategorySubscriptionItemFragmentDoc = gql`
    fragment StripeProductCategorySubscriptionItem on StripeProductCategorySubscription {
  categoryName
  numberOfProductsInCategory
  pricePerMonth
  packageType
  productCategoryId
  productCategorySubscriptionId
  stripeProductId
}
    `;
export const UpgradeToBespokeDataInfoFragmentDoc = gql`
    fragment UpgradeToBespokeDataInfo on UpgradeToBespokeData {
  wasSuccessfullyUpdated
  needsRedirect
  redirectUrl
}
    `;
export const InvoiceInfoFragmentDoc = gql`
    fragment InvoiceInfo on Invoice {
  id
  total
  createdAt
  customerId
  pdfUrl
  status
  hostedInvoiceUrl
}
    `;
export const SuccessFeeInvoiceInfoFragmentDoc = gql`
    fragment SuccessFeeInvoiceInfo on SuccessFeeInvoice {
  id
  total
  createdAt
  customerId
  paymentUrl
  status
  pdfUrl
}
    `;
export const SuccessFeeInvoiceListItemInfoFragmentDoc = gql`
    fragment SuccessFeeInvoiceListItemInfo on SuccessFeeInvoiceListItem {
  id
  tenderName
  venueName
  total
  createdAt
  customerId
  paymentUrl
  status
  pdfUrl
  bidUnitType
  packagingType
  tenderUnitType
  successFee
  bidVolumeUnits
  estimatedVolume
  tenderVolumeUnits
  averageWholesaleBidPrice
}
    `;
export const BespokeCheckDataInfoFragmentDoc = gql`
    fragment BespokeCheckDataInfo on BespokeCheckData {
  successFee
  pricePerMonth
}
    `;
export const TenderDraftInfoFragmentDoc = gql`
    fragment TenderDraftInfo on TenderDraft {
  id
  userId
  venueId
  name
  listingStartsAtUtc
  listingEndsAtUtc
  listingTypeId
  productCategoryId
  tenderStartsAtUtc
  tenderEndsAtUtc
  tenderDetails
  estimatedVolume
  volumeUnits
  volumeDetails
  supportsFreeStock
  supportsListingFee
  supportsPosBudget
  supportsRetroDiscount
  supportDetails
  createdAtUtc
  updatedAtUtc
  packagingType
  unitType
  isDirectSupplyCompatible
  isAnyWholesalerCompatible
  region
  isPrivate
}
    `;
export const UserActionLogInfoFragmentDoc = gql`
    fragment UserActionLogInfo on UserActionLog {
  id
  userId
  eventName
  additionalData
}
    `;
export const VenueSettingsInfoFragmentDoc = gql`
    fragment VenueSettingsInfo on VenueSettings {
  id
  venueId
  isNewTenderMailNotificationEnabled
  isNewBidsMailNotificationEnabled
  isBidUpdatedMailNotificationEnabled
  isMyTenderEndedMailNotificationEnabled
  isReTenderMailNotificationEnabled
  isNewTenderInAppNotificationEnabled
  isNewBidsInAppNotificationEnabled
  isBidUpdatedInAppNotificationEnabled
  isMyTenderEndedInAppNotificationEnabled
  isReTenderInAppNotificationEnabled
}
    `;
export const PlacesDocument = gql`
    query Places($input: PlacesInput!) {
  places(input: $input) {
    placeName
    placeId
  }
}
    `;

/**
 * __usePlacesQuery__
 *
 * To run a query within a React component, call `usePlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlacesQuery(baseOptions: Apollo.QueryHookOptions<PlacesQuery, PlacesQueryVariables> & ({ variables: PlacesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacesQuery, PlacesQueryVariables>(PlacesDocument, options);
      }
export function usePlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacesQuery, PlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacesQuery, PlacesQueryVariables>(PlacesDocument, options);
        }
export function usePlacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PlacesQuery, PlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlacesQuery, PlacesQueryVariables>(PlacesDocument, options);
        }
export type PlacesQueryHookResult = ReturnType<typeof usePlacesQuery>;
export type PlacesLazyQueryHookResult = ReturnType<typeof usePlacesLazyQuery>;
export type PlacesSuspenseQueryHookResult = ReturnType<typeof usePlacesSuspenseQuery>;
export type PlacesQueryResult = Apollo.QueryResult<PlacesQuery, PlacesQueryVariables>;
export const AddressWithPostcodeByPlaceIdDocument = gql`
    query AddressWithPostcodeByPlaceId($input: AddressByPlaceIdInput!) {
  addressByPlaceId(input: $input) {
    coordinates {
      lat
      lng
    }
    placeId
    placeName
    postCode
    country
    administrativeAreaLevel1
    administrativeAreaLevel1ShortName
    administrativeAreaLevel2
    administrativeAreLevel2ShortName
    locality
  }
}
    `;

/**
 * __useAddressWithPostcodeByPlaceIdQuery__
 *
 * To run a query within a React component, call `useAddressWithPostcodeByPlaceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressWithPostcodeByPlaceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressWithPostcodeByPlaceIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddressWithPostcodeByPlaceIdQuery(baseOptions: Apollo.QueryHookOptions<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables> & ({ variables: AddressWithPostcodeByPlaceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables>(AddressWithPostcodeByPlaceIdDocument, options);
      }
export function useAddressWithPostcodeByPlaceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables>(AddressWithPostcodeByPlaceIdDocument, options);
        }
export function useAddressWithPostcodeByPlaceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables>(AddressWithPostcodeByPlaceIdDocument, options);
        }
export type AddressWithPostcodeByPlaceIdQueryHookResult = ReturnType<typeof useAddressWithPostcodeByPlaceIdQuery>;
export type AddressWithPostcodeByPlaceIdLazyQueryHookResult = ReturnType<typeof useAddressWithPostcodeByPlaceIdLazyQuery>;
export type AddressWithPostcodeByPlaceIdSuspenseQueryHookResult = ReturnType<typeof useAddressWithPostcodeByPlaceIdSuspenseQuery>;
export type AddressWithPostcodeByPlaceIdQueryResult = Apollo.QueryResult<AddressWithPostcodeByPlaceIdQuery, AddressWithPostcodeByPlaceIdQueryVariables>;
export const LocationByCoordinatesDocument = gql`
    query LocationByCoordinates($input: LocationByCoordinatesInput!) {
  locationByCoordinates(input: $input) {
    country
  }
}
    `;

/**
 * __useLocationByCoordinatesQuery__
 *
 * To run a query within a React component, call `useLocationByCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationByCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationByCoordinatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocationByCoordinatesQuery(baseOptions: Apollo.QueryHookOptions<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables> & ({ variables: LocationByCoordinatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables>(LocationByCoordinatesDocument, options);
      }
export function useLocationByCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables>(LocationByCoordinatesDocument, options);
        }
export function useLocationByCoordinatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables>(LocationByCoordinatesDocument, options);
        }
export type LocationByCoordinatesQueryHookResult = ReturnType<typeof useLocationByCoordinatesQuery>;
export type LocationByCoordinatesLazyQueryHookResult = ReturnType<typeof useLocationByCoordinatesLazyQuery>;
export type LocationByCoordinatesSuspenseQueryHookResult = ReturnType<typeof useLocationByCoordinatesSuspenseQuery>;
export type LocationByCoordinatesQueryResult = Apollo.QueryResult<LocationByCoordinatesQuery, LocationByCoordinatesQueryVariables>;
export const AddBankAccountDocument = gql`
    mutation AddBankAccount($input: AddBankAccountInput!) {
  addBankAccount(input: $input) {
    ...BankAccountInfo
  }
}
    ${BankAccountInfoFragmentDoc}`;
export type AddBankAccountMutationFn = Apollo.MutationFunction<AddBankAccountMutation, AddBankAccountMutationVariables>;

/**
 * __useAddBankAccountMutation__
 *
 * To run a mutation, you first call `useAddBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBankAccountMutation, { data, loading, error }] = useAddBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddBankAccountMutation, AddBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBankAccountMutation, AddBankAccountMutationVariables>(AddBankAccountDocument, options);
      }
export type AddBankAccountMutationHookResult = ReturnType<typeof useAddBankAccountMutation>;
export type AddBankAccountMutationResult = Apollo.MutationResult<AddBankAccountMutation>;
export type AddBankAccountMutationOptions = Apollo.BaseMutationOptions<AddBankAccountMutation, AddBankAccountMutationVariables>;
export const EditBankAccountDocument = gql`
    mutation EditBankAccount($input: EditBankAccountInput!) {
  editBankAccount(input: $input) {
    ...BankAccountInfo
  }
}
    ${BankAccountInfoFragmentDoc}`;
export type EditBankAccountMutationFn = Apollo.MutationFunction<EditBankAccountMutation, EditBankAccountMutationVariables>;

/**
 * __useEditBankAccountMutation__
 *
 * To run a mutation, you first call `useEditBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBankAccountMutation, { data, loading, error }] = useEditBankAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<EditBankAccountMutation, EditBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBankAccountMutation, EditBankAccountMutationVariables>(EditBankAccountDocument, options);
      }
export type EditBankAccountMutationHookResult = ReturnType<typeof useEditBankAccountMutation>;
export type EditBankAccountMutationResult = Apollo.MutationResult<EditBankAccountMutation>;
export type EditBankAccountMutationOptions = Apollo.BaseMutationOptions<EditBankAccountMutation, EditBankAccountMutationVariables>;
export const BankAccountDocument = gql`
    query BankAccount {
  bankAccount {
    ...BankAccountInfo
  }
}
    ${BankAccountInfoFragmentDoc}`;

/**
 * __useBankAccountQuery__
 *
 * To run a query within a React component, call `useBankAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankAccountQuery(baseOptions?: Apollo.QueryHookOptions<BankAccountQuery, BankAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankAccountQuery, BankAccountQueryVariables>(BankAccountDocument, options);
      }
export function useBankAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankAccountQuery, BankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankAccountQuery, BankAccountQueryVariables>(BankAccountDocument, options);
        }
export function useBankAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BankAccountQuery, BankAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BankAccountQuery, BankAccountQueryVariables>(BankAccountDocument, options);
        }
export type BankAccountQueryHookResult = ReturnType<typeof useBankAccountQuery>;
export type BankAccountLazyQueryHookResult = ReturnType<typeof useBankAccountLazyQuery>;
export type BankAccountSuspenseQueryHookResult = ReturnType<typeof useBankAccountSuspenseQuery>;
export type BankAccountQueryResult = Apollo.QueryResult<BankAccountQuery, BankAccountQueryVariables>;
export const BidByIdDocument = gql`
    query BidById($bidId: Int!) {
  bidById(bidId: $bidId) {
    ...BidInfo
    files {
      ...FileInfo
    }
    brand {
      ...BrandInfo
    }
    user {
      ...UserInfo
    }
    ratingFeedbackValues {
      id
      value
      ratingOptionId
    }
    tender {
      ...TenderInfo
      wholesalers {
        ...WholesalerInfo
      }
      files {
        ...FileInfo
      }
      user {
        ...UserInfo
        registeredCompany {
          ...RegisteredCompanyInfo
        }
      }
      venue {
        ...VenueInfo
      }
      listingType {
        ...ListingTypeInfo
      }
      productCategory {
        ...ProductCategoryInfo
      }
    }
  }
}
    ${BidInfoFragmentDoc}
${FileInfoFragmentDoc}
${BrandInfoFragmentDoc}
${UserInfoFragmentDoc}
${TenderInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${RegisteredCompanyInfoFragmentDoc}
${VenueInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}`;

/**
 * __useBidByIdQuery__
 *
 * To run a query within a React component, call `useBidByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidByIdQuery({
 *   variables: {
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useBidByIdQuery(baseOptions: Apollo.QueryHookOptions<BidByIdQuery, BidByIdQueryVariables> & ({ variables: BidByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BidByIdQuery, BidByIdQueryVariables>(BidByIdDocument, options);
      }
export function useBidByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BidByIdQuery, BidByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BidByIdQuery, BidByIdQueryVariables>(BidByIdDocument, options);
        }
export function useBidByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BidByIdQuery, BidByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BidByIdQuery, BidByIdQueryVariables>(BidByIdDocument, options);
        }
export type BidByIdQueryHookResult = ReturnType<typeof useBidByIdQuery>;
export type BidByIdLazyQueryHookResult = ReturnType<typeof useBidByIdLazyQuery>;
export type BidByIdSuspenseQueryHookResult = ReturnType<typeof useBidByIdSuspenseQuery>;
export type BidByIdQueryResult = Apollo.QueryResult<BidByIdQuery, BidByIdQueryVariables>;
export const PreviousBidDocument = gql`
    query PreviousBid($brandId: Int!) {
  previousBid(brandId: $brandId) {
    ...BidInfo
  }
}
    ${BidInfoFragmentDoc}`;

/**
 * __usePreviousBidQuery__
 *
 * To run a query within a React component, call `usePreviousBidQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviousBidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviousBidQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function usePreviousBidQuery(baseOptions: Apollo.QueryHookOptions<PreviousBidQuery, PreviousBidQueryVariables> & ({ variables: PreviousBidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviousBidQuery, PreviousBidQueryVariables>(PreviousBidDocument, options);
      }
export function usePreviousBidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviousBidQuery, PreviousBidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviousBidQuery, PreviousBidQueryVariables>(PreviousBidDocument, options);
        }
export function usePreviousBidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviousBidQuery, PreviousBidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviousBidQuery, PreviousBidQueryVariables>(PreviousBidDocument, options);
        }
export type PreviousBidQueryHookResult = ReturnType<typeof usePreviousBidQuery>;
export type PreviousBidLazyQueryHookResult = ReturnType<typeof usePreviousBidLazyQuery>;
export type PreviousBidSuspenseQueryHookResult = ReturnType<typeof usePreviousBidSuspenseQuery>;
export type PreviousBidQueryResult = Apollo.QueryResult<PreviousBidQuery, PreviousBidQueryVariables>;
export const BidsDocument = gql`
    query Bids($input: BidsInput!) {
  bids(input: $input) {
    data {
      ...BidInfo
      files {
        ...FileInfo
      }
      brand {
        ...BrandInfo
      }
      ratingFeedbackValues {
        id
        value
        ratingOptionId
      }
      tender {
        ...TenderInfo
      }
    }
    pageInfo {
      ...OffsetPageInfo
    }
    totalCount
  }
}
    ${BidInfoFragmentDoc}
${FileInfoFragmentDoc}
${BrandInfoFragmentDoc}
${TenderInfoFragmentDoc}
${OffsetPageInfoFragmentDoc}`;

/**
 * __useBidsQuery__
 *
 * To run a query within a React component, call `useBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBidsQuery(baseOptions: Apollo.QueryHookOptions<BidsQuery, BidsQueryVariables> & ({ variables: BidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BidsQuery, BidsQueryVariables>(BidsDocument, options);
      }
export function useBidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BidsQuery, BidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BidsQuery, BidsQueryVariables>(BidsDocument, options);
        }
export function useBidsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BidsQuery, BidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BidsQuery, BidsQueryVariables>(BidsDocument, options);
        }
export type BidsQueryHookResult = ReturnType<typeof useBidsQuery>;
export type BidsLazyQueryHookResult = ReturnType<typeof useBidsLazyQuery>;
export type BidsSuspenseQueryHookResult = ReturnType<typeof useBidsSuspenseQuery>;
export type BidsQueryResult = Apollo.QueryResult<BidsQuery, BidsQueryVariables>;
export const BrandDashboardBidsDocument = gql`
    query BrandDashboardBids($input: BidsInput!) {
  bids(input: $input) {
    data {
      ...BidInfo
      brand {
        ...BrandInfo
      }
      user {
        ...UserInfo
      }
      files {
        ...FileInfo
      }
      wholesalers {
        ...WholesalerInfo
      }
      tender {
        ...TenderInfo
        user {
          ...UserInfo
        }
        wholesalers {
          ...WholesalerInfo
        }
        files {
          ...FileInfo
        }
        venue {
          ...VenueInfo
        }
        listingType {
          ...ListingTypeInfo
        }
        productCategory {
          ...ProductCategoryInfo
        }
      }
    }
    totalCount
    pageInfo {
      ...OffsetPageInfo
    }
  }
}
    ${BidInfoFragmentDoc}
${BrandInfoFragmentDoc}
${UserInfoFragmentDoc}
${FileInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${TenderInfoFragmentDoc}
${VenueInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${OffsetPageInfoFragmentDoc}`;

/**
 * __useBrandDashboardBidsQuery__
 *
 * To run a query within a React component, call `useBrandDashboardBidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandDashboardBidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandDashboardBidsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrandDashboardBidsQuery(baseOptions: Apollo.QueryHookOptions<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables> & ({ variables: BrandDashboardBidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables>(BrandDashboardBidsDocument, options);
      }
export function useBrandDashboardBidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables>(BrandDashboardBidsDocument, options);
        }
export function useBrandDashboardBidsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables>(BrandDashboardBidsDocument, options);
        }
export type BrandDashboardBidsQueryHookResult = ReturnType<typeof useBrandDashboardBidsQuery>;
export type BrandDashboardBidsLazyQueryHookResult = ReturnType<typeof useBrandDashboardBidsLazyQuery>;
export type BrandDashboardBidsSuspenseQueryHookResult = ReturnType<typeof useBrandDashboardBidsSuspenseQuery>;
export type BrandDashboardBidsQueryResult = Apollo.QueryResult<BrandDashboardBidsQuery, BrandDashboardBidsQueryVariables>;
export const WinningBidsByTenderIdDocument = gql`
    query WinningBidsByTenderId($tenderId: Int!) {
  winningBidsByTenderId(tenderId: $tenderId) {
    ...BidInfo
    brand {
      ...BrandInfo
    }
    user {
      ...UserInfo
    }
    ratingFeedbackValues {
      id
      value
      ratingOptionId
    }
    tender {
      ...TenderInfo
      user {
        ...UserInfo
      }
      wholesalers {
        ...WholesalerInfo
      }
      files {
        ...FileInfo
      }
      venue {
        ...VenueInfo
      }
      listingType {
        ...ListingTypeInfo
      }
      productCategory {
        ...ProductCategoryInfo
      }
    }
    files {
      ...FileInfo
    }
  }
}
    ${BidInfoFragmentDoc}
${BrandInfoFragmentDoc}
${UserInfoFragmentDoc}
${TenderInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${FileInfoFragmentDoc}
${VenueInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}`;

/**
 * __useWinningBidsByTenderIdQuery__
 *
 * To run a query within a React component, call `useWinningBidsByTenderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWinningBidsByTenderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWinningBidsByTenderIdQuery({
 *   variables: {
 *      tenderId: // value for 'tenderId'
 *   },
 * });
 */
export function useWinningBidsByTenderIdQuery(baseOptions: Apollo.QueryHookOptions<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables> & ({ variables: WinningBidsByTenderIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables>(WinningBidsByTenderIdDocument, options);
      }
export function useWinningBidsByTenderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables>(WinningBidsByTenderIdDocument, options);
        }
export function useWinningBidsByTenderIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables>(WinningBidsByTenderIdDocument, options);
        }
export type WinningBidsByTenderIdQueryHookResult = ReturnType<typeof useWinningBidsByTenderIdQuery>;
export type WinningBidsByTenderIdLazyQueryHookResult = ReturnType<typeof useWinningBidsByTenderIdLazyQuery>;
export type WinningBidsByTenderIdSuspenseQueryHookResult = ReturnType<typeof useWinningBidsByTenderIdSuspenseQuery>;
export type WinningBidsByTenderIdQueryResult = Apollo.QueryResult<WinningBidsByTenderIdQuery, WinningBidsByTenderIdQueryVariables>;
export const RatingOptionsDocument = gql`
    query ratingOptions {
  ratingOptions {
    id
    name
    type
    ratingFeedbackValues {
      id
      value
      ratingOptionId
    }
  }
}
    `;

/**
 * __useRatingOptionsQuery__
 *
 * To run a query within a React component, call `useRatingOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatingOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatingOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRatingOptionsQuery(baseOptions?: Apollo.QueryHookOptions<RatingOptionsQuery, RatingOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RatingOptionsQuery, RatingOptionsQueryVariables>(RatingOptionsDocument, options);
      }
export function useRatingOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RatingOptionsQuery, RatingOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RatingOptionsQuery, RatingOptionsQueryVariables>(RatingOptionsDocument, options);
        }
export function useRatingOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RatingOptionsQuery, RatingOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RatingOptionsQuery, RatingOptionsQueryVariables>(RatingOptionsDocument, options);
        }
export type RatingOptionsQueryHookResult = ReturnType<typeof useRatingOptionsQuery>;
export type RatingOptionsLazyQueryHookResult = ReturnType<typeof useRatingOptionsLazyQuery>;
export type RatingOptionsSuspenseQueryHookResult = ReturnType<typeof useRatingOptionsSuspenseQuery>;
export type RatingOptionsQueryResult = Apollo.QueryResult<RatingOptionsQuery, RatingOptionsQueryVariables>;
export const TotalSupportFromOneBrandToVenueDocument = gql`
    query totalSupportFromOneBrandToVenue($brandId: Int!, $venueId: Int!) {
  totalSupportFromBrandPerActiveVenue(brandId: $brandId, venueId: $venueId) {
    totalSupport
    totalTenders
  }
}
    `;

/**
 * __useTotalSupportFromOneBrandToVenueQuery__
 *
 * To run a query within a React component, call `useTotalSupportFromOneBrandToVenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalSupportFromOneBrandToVenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalSupportFromOneBrandToVenueQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useTotalSupportFromOneBrandToVenueQuery(baseOptions: Apollo.QueryHookOptions<TotalSupportFromOneBrandToVenueQuery, TotalSupportFromOneBrandToVenueQueryVariables> & ({ variables: TotalSupportFromOneBrandToVenueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalSupportFromOneBrandToVenueQuery, TotalSupportFromOneBrandToVenueQueryVariables>(TotalSupportFromOneBrandToVenueDocument, options);
      }
export function useTotalSupportFromOneBrandToVenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TotalSupportFromOneBrandToVenueQuery, TotalSupportFromOneBrandToVenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalSupportFromOneBrandToVenueQuery, TotalSupportFromOneBrandToVenueQueryVariables>(TotalSupportFromOneBrandToVenueDocument, options);
        }
export function useTotalSupportFromOneBrandToVenueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TotalSupportFromOneBrandToVenueQuery, TotalSupportFromOneBrandToVenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TotalSupportFromOneBrandToVenueQuery, TotalSupportFromOneBrandToVenueQueryVariables>(TotalSupportFromOneBrandToVenueDocument, options);
        }
export type TotalSupportFromOneBrandToVenueQueryHookResult = ReturnType<typeof useTotalSupportFromOneBrandToVenueQuery>;
export type TotalSupportFromOneBrandToVenueLazyQueryHookResult = ReturnType<typeof useTotalSupportFromOneBrandToVenueLazyQuery>;
export type TotalSupportFromOneBrandToVenueSuspenseQueryHookResult = ReturnType<typeof useTotalSupportFromOneBrandToVenueSuspenseQuery>;
export type TotalSupportFromOneBrandToVenueQueryResult = Apollo.QueryResult<TotalSupportFromOneBrandToVenueQuery, TotalSupportFromOneBrandToVenueQueryVariables>;
export const BidsFilterOptionsDocument = gql`
    query bidsFilterOptions($input: BidsFilterOptionsInput!) {
  bidsFilterOptions(input: $input) {
    label
    options {
      label
      value
    }
  }
}
    `;

/**
 * __useBidsFilterOptionsQuery__
 *
 * To run a query within a React component, call `useBidsFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidsFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidsFilterOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBidsFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<BidsFilterOptionsQuery, BidsFilterOptionsQueryVariables> & ({ variables: BidsFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BidsFilterOptionsQuery, BidsFilterOptionsQueryVariables>(BidsFilterOptionsDocument, options);
      }
export function useBidsFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BidsFilterOptionsQuery, BidsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BidsFilterOptionsQuery, BidsFilterOptionsQueryVariables>(BidsFilterOptionsDocument, options);
        }
export function useBidsFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BidsFilterOptionsQuery, BidsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BidsFilterOptionsQuery, BidsFilterOptionsQueryVariables>(BidsFilterOptionsDocument, options);
        }
export type BidsFilterOptionsQueryHookResult = ReturnType<typeof useBidsFilterOptionsQuery>;
export type BidsFilterOptionsLazyQueryHookResult = ReturnType<typeof useBidsFilterOptionsLazyQuery>;
export type BidsFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useBidsFilterOptionsSuspenseQuery>;
export type BidsFilterOptionsQueryResult = Apollo.QueryResult<BidsFilterOptionsQuery, BidsFilterOptionsQueryVariables>;
export const AvatarUrlDocument = gql`
    query avatarUrl($input: AvatarUrlInput!) {
  avatarUrl(input: $input)
}
    `;

/**
 * __useAvatarUrlQuery__
 *
 * To run a query within a React component, call `useAvatarUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvatarUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvatarUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAvatarUrlQuery(baseOptions: Apollo.QueryHookOptions<AvatarUrlQuery, AvatarUrlQueryVariables> & ({ variables: AvatarUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvatarUrlQuery, AvatarUrlQueryVariables>(AvatarUrlDocument, options);
      }
export function useAvatarUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvatarUrlQuery, AvatarUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvatarUrlQuery, AvatarUrlQueryVariables>(AvatarUrlDocument, options);
        }
export function useAvatarUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvatarUrlQuery, AvatarUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvatarUrlQuery, AvatarUrlQueryVariables>(AvatarUrlDocument, options);
        }
export type AvatarUrlQueryHookResult = ReturnType<typeof useAvatarUrlQuery>;
export type AvatarUrlLazyQueryHookResult = ReturnType<typeof useAvatarUrlLazyQuery>;
export type AvatarUrlSuspenseQueryHookResult = ReturnType<typeof useAvatarUrlSuspenseQuery>;
export type AvatarUrlQueryResult = Apollo.QueryResult<AvatarUrlQuery, AvatarUrlQueryVariables>;
export const RateBidDocument = gql`
    mutation RateBid($input: RateBidInput!) {
  rateBid(input: $input) {
    id
    rating
    ratingComment
    ratingFeedbackValues {
      id
    }
    isRatingOutdated
  }
}
    `;
export type RateBidMutationFn = Apollo.MutationFunction<RateBidMutation, RateBidMutationVariables>;

/**
 * __useRateBidMutation__
 *
 * To run a mutation, you first call `useRateBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateBidMutation, { data, loading, error }] = useRateBidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRateBidMutation(baseOptions?: Apollo.MutationHookOptions<RateBidMutation, RateBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RateBidMutation, RateBidMutationVariables>(RateBidDocument, options);
      }
export type RateBidMutationHookResult = ReturnType<typeof useRateBidMutation>;
export type RateBidMutationResult = Apollo.MutationResult<RateBidMutation>;
export type RateBidMutationOptions = Apollo.BaseMutationOptions<RateBidMutation, RateBidMutationVariables>;
export const DeleteBidByIdDocument = gql`
    mutation DeleteBidById($bidId: Int!) {
  deleteBidById(bidId: $bidId)
}
    `;
export type DeleteBidByIdMutationFn = Apollo.MutationFunction<DeleteBidByIdMutation, DeleteBidByIdMutationVariables>;

/**
 * __useDeleteBidByIdMutation__
 *
 * To run a mutation, you first call `useDeleteBidByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBidByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBidByIdMutation, { data, loading, error }] = useDeleteBidByIdMutation({
 *   variables: {
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useDeleteBidByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBidByIdMutation, DeleteBidByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBidByIdMutation, DeleteBidByIdMutationVariables>(DeleteBidByIdDocument, options);
      }
export type DeleteBidByIdMutationHookResult = ReturnType<typeof useDeleteBidByIdMutation>;
export type DeleteBidByIdMutationResult = Apollo.MutationResult<DeleteBidByIdMutation>;
export type DeleteBidByIdMutationOptions = Apollo.BaseMutationOptions<DeleteBidByIdMutation, DeleteBidByIdMutationVariables>;
export const AddBidDocument = gql`
    mutation AddBid($input: AddBidInput!) {
  addBid(input: $input) {
    ...BidInfo
    files {
      ...FileInfo
    }
  }
}
    ${BidInfoFragmentDoc}
${FileInfoFragmentDoc}`;
export type AddBidMutationFn = Apollo.MutationFunction<AddBidMutation, AddBidMutationVariables>;

/**
 * __useAddBidMutation__
 *
 * To run a mutation, you first call `useAddBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBidMutation, { data, loading, error }] = useAddBidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBidMutation(baseOptions?: Apollo.MutationHookOptions<AddBidMutation, AddBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBidMutation, AddBidMutationVariables>(AddBidDocument, options);
      }
export type AddBidMutationHookResult = ReturnType<typeof useAddBidMutation>;
export type AddBidMutationResult = Apollo.MutationResult<AddBidMutation>;
export type AddBidMutationOptions = Apollo.BaseMutationOptions<AddBidMutation, AddBidMutationVariables>;
export const EditBidDocument = gql`
    mutation EditBid($input: EditBidInput!) {
  editBid(input: $input) {
    ...BidInfo
    files {
      ...FileInfo
    }
  }
}
    ${BidInfoFragmentDoc}
${FileInfoFragmentDoc}`;
export type EditBidMutationFn = Apollo.MutationFunction<EditBidMutation, EditBidMutationVariables>;

/**
 * __useEditBidMutation__
 *
 * To run a mutation, you first call `useEditBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBidMutation, { data, loading, error }] = useEditBidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBidMutation(baseOptions?: Apollo.MutationHookOptions<EditBidMutation, EditBidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBidMutation, EditBidMutationVariables>(EditBidDocument, options);
      }
export type EditBidMutationHookResult = ReturnType<typeof useEditBidMutation>;
export type EditBidMutationResult = Apollo.MutationResult<EditBidMutation>;
export type EditBidMutationOptions = Apollo.BaseMutationOptions<EditBidMutation, EditBidMutationVariables>;
export const RequestSalesDemoBidsDocument = gql`
    mutation RequestSalesDemoBids($tenderId: Int!) {
  requestSalesDemoBids(tenderId: $tenderId) {
    ...BidInfo
  }
}
    ${BidInfoFragmentDoc}`;
export type RequestSalesDemoBidsMutationFn = Apollo.MutationFunction<RequestSalesDemoBidsMutation, RequestSalesDemoBidsMutationVariables>;

/**
 * __useRequestSalesDemoBidsMutation__
 *
 * To run a mutation, you first call `useRequestSalesDemoBidsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSalesDemoBidsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSalesDemoBidsMutation, { data, loading, error }] = useRequestSalesDemoBidsMutation({
 *   variables: {
 *      tenderId: // value for 'tenderId'
 *   },
 * });
 */
export function useRequestSalesDemoBidsMutation(baseOptions?: Apollo.MutationHookOptions<RequestSalesDemoBidsMutation, RequestSalesDemoBidsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestSalesDemoBidsMutation, RequestSalesDemoBidsMutationVariables>(RequestSalesDemoBidsDocument, options);
      }
export type RequestSalesDemoBidsMutationHookResult = ReturnType<typeof useRequestSalesDemoBidsMutation>;
export type RequestSalesDemoBidsMutationResult = Apollo.MutationResult<RequestSalesDemoBidsMutation>;
export type RequestSalesDemoBidsMutationOptions = Apollo.BaseMutationOptions<RequestSalesDemoBidsMutation, RequestSalesDemoBidsMutationVariables>;
export const SampleRequestDocument = gql`
    mutation SampleRequest($input: SampleRequestInput!) {
  sampleRequest(input: $input)
}
    `;
export type SampleRequestMutationFn = Apollo.MutationFunction<SampleRequestMutation, SampleRequestMutationVariables>;

/**
 * __useSampleRequestMutation__
 *
 * To run a mutation, you first call `useSampleRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSampleRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sampleRequestMutation, { data, loading, error }] = useSampleRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSampleRequestMutation(baseOptions?: Apollo.MutationHookOptions<SampleRequestMutation, SampleRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SampleRequestMutation, SampleRequestMutationVariables>(SampleRequestDocument, options);
      }
export type SampleRequestMutationHookResult = ReturnType<typeof useSampleRequestMutation>;
export type SampleRequestMutationResult = Apollo.MutationResult<SampleRequestMutation>;
export type SampleRequestMutationOptions = Apollo.BaseMutationOptions<SampleRequestMutation, SampleRequestMutationVariables>;
export const AddBidsToMultipleTendersDocument = gql`
    mutation AddBidsToMultipleTenders($input: AddBidsToMultipleTendersInput!) {
  addBidsToMultipleTenders(input: $input) {
    ...BidInfo
  }
}
    ${BidInfoFragmentDoc}`;
export type AddBidsToMultipleTendersMutationFn = Apollo.MutationFunction<AddBidsToMultipleTendersMutation, AddBidsToMultipleTendersMutationVariables>;

/**
 * __useAddBidsToMultipleTendersMutation__
 *
 * To run a mutation, you first call `useAddBidsToMultipleTendersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBidsToMultipleTendersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBidsToMultipleTendersMutation, { data, loading, error }] = useAddBidsToMultipleTendersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBidsToMultipleTendersMutation(baseOptions?: Apollo.MutationHookOptions<AddBidsToMultipleTendersMutation, AddBidsToMultipleTendersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBidsToMultipleTendersMutation, AddBidsToMultipleTendersMutationVariables>(AddBidsToMultipleTendersDocument, options);
      }
export type AddBidsToMultipleTendersMutationHookResult = ReturnType<typeof useAddBidsToMultipleTendersMutation>;
export type AddBidsToMultipleTendersMutationResult = Apollo.MutationResult<AddBidsToMultipleTendersMutation>;
export type AddBidsToMultipleTendersMutationOptions = Apollo.BaseMutationOptions<AddBidsToMultipleTendersMutation, AddBidsToMultipleTendersMutationVariables>;
export const EditBidSupportStatusDocument = gql`
    mutation EditBidSupportStatus($input: EditBidSupportStatusInput!) {
  editBidSupportStatus(input: $input) {
    ...BidInfo
  }
}
    ${BidInfoFragmentDoc}`;
export type EditBidSupportStatusMutationFn = Apollo.MutationFunction<EditBidSupportStatusMutation, EditBidSupportStatusMutationVariables>;

/**
 * __useEditBidSupportStatusMutation__
 *
 * To run a mutation, you first call `useEditBidSupportStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBidSupportStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBidSupportStatusMutation, { data, loading, error }] = useEditBidSupportStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBidSupportStatusMutation(baseOptions?: Apollo.MutationHookOptions<EditBidSupportStatusMutation, EditBidSupportStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBidSupportStatusMutation, EditBidSupportStatusMutationVariables>(EditBidSupportStatusDocument, options);
      }
export type EditBidSupportStatusMutationHookResult = ReturnType<typeof useEditBidSupportStatusMutation>;
export type EditBidSupportStatusMutationResult = Apollo.MutationResult<EditBidSupportStatusMutation>;
export type EditBidSupportStatusMutationOptions = Apollo.BaseMutationOptions<EditBidSupportStatusMutation, EditBidSupportStatusMutationVariables>;
export const AddBidComparisonAnalyticDocument = gql`
    mutation AddBidComparisonAnalytic($input: AddBidComparisonAnalyticInput!) {
  addBidComparisonAnalytic(input: $input)
}
    `;
export type AddBidComparisonAnalyticMutationFn = Apollo.MutationFunction<AddBidComparisonAnalyticMutation, AddBidComparisonAnalyticMutationVariables>;

/**
 * __useAddBidComparisonAnalyticMutation__
 *
 * To run a mutation, you first call `useAddBidComparisonAnalyticMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBidComparisonAnalyticMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBidComparisonAnalyticMutation, { data, loading, error }] = useAddBidComparisonAnalyticMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBidComparisonAnalyticMutation(baseOptions?: Apollo.MutationHookOptions<AddBidComparisonAnalyticMutation, AddBidComparisonAnalyticMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBidComparisonAnalyticMutation, AddBidComparisonAnalyticMutationVariables>(AddBidComparisonAnalyticDocument, options);
      }
export type AddBidComparisonAnalyticMutationHookResult = ReturnType<typeof useAddBidComparisonAnalyticMutation>;
export type AddBidComparisonAnalyticMutationResult = Apollo.MutationResult<AddBidComparisonAnalyticMutation>;
export type AddBidComparisonAnalyticMutationOptions = Apollo.BaseMutationOptions<AddBidComparisonAnalyticMutation, AddBidComparisonAnalyticMutationVariables>;
export const EditBrandDocument = gql`
    mutation EditBrand($input: EditBrandInput!) {
  editBrand(input: $input) {
    ...BrandInfo
  }
}
    ${BrandInfoFragmentDoc}`;
export type EditBrandMutationFn = Apollo.MutationFunction<EditBrandMutation, EditBrandMutationVariables>;

/**
 * __useEditBrandMutation__
 *
 * To run a mutation, you first call `useEditBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBrandMutation, { data, loading, error }] = useEditBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBrandMutation(baseOptions?: Apollo.MutationHookOptions<EditBrandMutation, EditBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBrandMutation, EditBrandMutationVariables>(EditBrandDocument, options);
      }
export type EditBrandMutationHookResult = ReturnType<typeof useEditBrandMutation>;
export type EditBrandMutationResult = Apollo.MutationResult<EditBrandMutation>;
export type EditBrandMutationOptions = Apollo.BaseMutationOptions<EditBrandMutation, EditBrandMutationVariables>;
export const SupportCalculationDocument = gql`
    mutation SupportCalculation($input: SupportCalculatorInput!) {
  supportCalculator(input: $input)
}
    `;
export type SupportCalculationMutationFn = Apollo.MutationFunction<SupportCalculationMutation, SupportCalculationMutationVariables>;

/**
 * __useSupportCalculationMutation__
 *
 * To run a mutation, you first call `useSupportCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupportCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supportCalculationMutation, { data, loading, error }] = useSupportCalculationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupportCalculationMutation(baseOptions?: Apollo.MutationHookOptions<SupportCalculationMutation, SupportCalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupportCalculationMutation, SupportCalculationMutationVariables>(SupportCalculationDocument, options);
      }
export type SupportCalculationMutationHookResult = ReturnType<typeof useSupportCalculationMutation>;
export type SupportCalculationMutationResult = Apollo.MutationResult<SupportCalculationMutation>;
export type SupportCalculationMutationOptions = Apollo.BaseMutationOptions<SupportCalculationMutation, SupportCalculationMutationVariables>;
export const GetDataFromCompanyVatDocument = gql`
    query GetDataFromCompanyVat($input: GetCompanyVatDetailsInput!) {
  getCompanyVatDetails(input: $input) {
    vatNumber
    vatCompanyName
    vatCountryCode
    vatConsultationNumber
    vatProcessingDate
  }
}
    `;

/**
 * __useGetDataFromCompanyVatQuery__
 *
 * To run a query within a React component, call `useGetDataFromCompanyVatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataFromCompanyVatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataFromCompanyVatQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDataFromCompanyVatQuery(baseOptions: Apollo.QueryHookOptions<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables> & ({ variables: GetDataFromCompanyVatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables>(GetDataFromCompanyVatDocument, options);
      }
export function useGetDataFromCompanyVatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables>(GetDataFromCompanyVatDocument, options);
        }
export function useGetDataFromCompanyVatSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables>(GetDataFromCompanyVatDocument, options);
        }
export type GetDataFromCompanyVatQueryHookResult = ReturnType<typeof useGetDataFromCompanyVatQuery>;
export type GetDataFromCompanyVatLazyQueryHookResult = ReturnType<typeof useGetDataFromCompanyVatLazyQuery>;
export type GetDataFromCompanyVatSuspenseQueryHookResult = ReturnType<typeof useGetDataFromCompanyVatSuspenseQuery>;
export type GetDataFromCompanyVatQueryResult = Apollo.QueryResult<GetDataFromCompanyVatQuery, GetDataFromCompanyVatQueryVariables>;
export const GetDataFromAwrsDetailsDocument = gql`
    query GetDataFromAwrsDetails($input: GetAwrsDetailsInput!) {
  getAwrsDetails(input: $input) {
    awrsNumber
    awrsStatus
    awrsCompanyName
    awrsPlaceBusiness
    awrsRegistrationDate
    awrsDeregistrationDate
  }
}
    `;

/**
 * __useGetDataFromAwrsDetailsQuery__
 *
 * To run a query within a React component, call `useGetDataFromAwrsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataFromAwrsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataFromAwrsDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDataFromAwrsDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetDataFromAwrsDetailsQuery, GetDataFromAwrsDetailsQueryVariables> & ({ variables: GetDataFromAwrsDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataFromAwrsDetailsQuery, GetDataFromAwrsDetailsQueryVariables>(GetDataFromAwrsDetailsDocument, options);
      }
export function useGetDataFromAwrsDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataFromAwrsDetailsQuery, GetDataFromAwrsDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataFromAwrsDetailsQuery, GetDataFromAwrsDetailsQueryVariables>(GetDataFromAwrsDetailsDocument, options);
        }
export function useGetDataFromAwrsDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDataFromAwrsDetailsQuery, GetDataFromAwrsDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataFromAwrsDetailsQuery, GetDataFromAwrsDetailsQueryVariables>(GetDataFromAwrsDetailsDocument, options);
        }
export type GetDataFromAwrsDetailsQueryHookResult = ReturnType<typeof useGetDataFromAwrsDetailsQuery>;
export type GetDataFromAwrsDetailsLazyQueryHookResult = ReturnType<typeof useGetDataFromAwrsDetailsLazyQuery>;
export type GetDataFromAwrsDetailsSuspenseQueryHookResult = ReturnType<typeof useGetDataFromAwrsDetailsSuspenseQuery>;
export type GetDataFromAwrsDetailsQueryResult = Apollo.QueryResult<GetDataFromAwrsDetailsQuery, GetDataFromAwrsDetailsQueryVariables>;
export const BrandDashboardMetricsByBrandIdDocument = gql`
    query BrandDashboardMetricsByBrandId($brandId: Int!) {
  brandDashboardMetricsByBrandId(brandId: $brandId) {
    type
    label
    value
  }
}
    `;

/**
 * __useBrandDashboardMetricsByBrandIdQuery__
 *
 * To run a query within a React component, call `useBrandDashboardMetricsByBrandIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandDashboardMetricsByBrandIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandDashboardMetricsByBrandIdQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useBrandDashboardMetricsByBrandIdQuery(baseOptions: Apollo.QueryHookOptions<BrandDashboardMetricsByBrandIdQuery, BrandDashboardMetricsByBrandIdQueryVariables> & ({ variables: BrandDashboardMetricsByBrandIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandDashboardMetricsByBrandIdQuery, BrandDashboardMetricsByBrandIdQueryVariables>(BrandDashboardMetricsByBrandIdDocument, options);
      }
export function useBrandDashboardMetricsByBrandIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandDashboardMetricsByBrandIdQuery, BrandDashboardMetricsByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandDashboardMetricsByBrandIdQuery, BrandDashboardMetricsByBrandIdQueryVariables>(BrandDashboardMetricsByBrandIdDocument, options);
        }
export function useBrandDashboardMetricsByBrandIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandDashboardMetricsByBrandIdQuery, BrandDashboardMetricsByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandDashboardMetricsByBrandIdQuery, BrandDashboardMetricsByBrandIdQueryVariables>(BrandDashboardMetricsByBrandIdDocument, options);
        }
export type BrandDashboardMetricsByBrandIdQueryHookResult = ReturnType<typeof useBrandDashboardMetricsByBrandIdQuery>;
export type BrandDashboardMetricsByBrandIdLazyQueryHookResult = ReturnType<typeof useBrandDashboardMetricsByBrandIdLazyQuery>;
export type BrandDashboardMetricsByBrandIdSuspenseQueryHookResult = ReturnType<typeof useBrandDashboardMetricsByBrandIdSuspenseQuery>;
export type BrandDashboardMetricsByBrandIdQueryResult = Apollo.QueryResult<BrandDashboardMetricsByBrandIdQuery, BrandDashboardMetricsByBrandIdQueryVariables>;
export const BrandSettingsByBrandIdDocument = gql`
    query BrandSettingsByBrandId($brandId: Int!) {
  brandSettingsByBrandId(brandId: $brandId) {
    ...BrandSettingsInfo
  }
}
    ${BrandSettingsInfoFragmentDoc}`;

/**
 * __useBrandSettingsByBrandIdQuery__
 *
 * To run a query within a React component, call `useBrandSettingsByBrandIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandSettingsByBrandIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandSettingsByBrandIdQuery({
 *   variables: {
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useBrandSettingsByBrandIdQuery(baseOptions: Apollo.QueryHookOptions<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables> & ({ variables: BrandSettingsByBrandIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables>(BrandSettingsByBrandIdDocument, options);
      }
export function useBrandSettingsByBrandIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables>(BrandSettingsByBrandIdDocument, options);
        }
export function useBrandSettingsByBrandIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables>(BrandSettingsByBrandIdDocument, options);
        }
export type BrandSettingsByBrandIdQueryHookResult = ReturnType<typeof useBrandSettingsByBrandIdQuery>;
export type BrandSettingsByBrandIdLazyQueryHookResult = ReturnType<typeof useBrandSettingsByBrandIdLazyQuery>;
export type BrandSettingsByBrandIdSuspenseQueryHookResult = ReturnType<typeof useBrandSettingsByBrandIdSuspenseQuery>;
export type BrandSettingsByBrandIdQueryResult = Apollo.QueryResult<BrandSettingsByBrandIdQuery, BrandSettingsByBrandIdQueryVariables>;
export const EditBrandSettingsDocument = gql`
    mutation EditBrandSettings($input: EditBrandSettingsInput!) {
  editBrandSettings(input: $input) {
    ...BrandSettingsInfo
  }
}
    ${BrandSettingsInfoFragmentDoc}`;
export type EditBrandSettingsMutationFn = Apollo.MutationFunction<EditBrandSettingsMutation, EditBrandSettingsMutationVariables>;

/**
 * __useEditBrandSettingsMutation__
 *
 * To run a mutation, you first call `useEditBrandSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBrandSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBrandSettingsMutation, { data, loading, error }] = useEditBrandSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBrandSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditBrandSettingsMutation, EditBrandSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditBrandSettingsMutation, EditBrandSettingsMutationVariables>(EditBrandSettingsDocument, options);
      }
export type EditBrandSettingsMutationHookResult = ReturnType<typeof useEditBrandSettingsMutation>;
export type EditBrandSettingsMutationResult = Apollo.MutationResult<EditBrandSettingsMutation>;
export type EditBrandSettingsMutationOptions = Apollo.BaseMutationOptions<EditBrandSettingsMutation, EditBrandSettingsMutationVariables>;
export const RequestEmailDocument = gql`
    mutation RequestEmail($input: RequestEmailInput!) {
  requestEmail(input: $input)
}
    `;
export type RequestEmailMutationFn = Apollo.MutationFunction<RequestEmailMutation, RequestEmailMutationVariables>;

/**
 * __useRequestEmailMutation__
 *
 * To run a mutation, you first call `useRequestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEmailMutation, { data, loading, error }] = useRequestEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestEmailMutation(baseOptions?: Apollo.MutationHookOptions<RequestEmailMutation, RequestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestEmailMutation, RequestEmailMutationVariables>(RequestEmailDocument, options);
      }
export type RequestEmailMutationHookResult = ReturnType<typeof useRequestEmailMutation>;
export type RequestEmailMutationResult = Apollo.MutationResult<RequestEmailMutation>;
export type RequestEmailMutationOptions = Apollo.BaseMutationOptions<RequestEmailMutation, RequestEmailMutationVariables>;
export const GenerateUploadUrlsDocument = gql`
    mutation GenerateUploadUrls($input: [String!]!) {
  generateUploadUrls(fileNames: $input) {
    filename
    bucketKey
    uploadUrl
  }
}
    `;
export type GenerateUploadUrlsMutationFn = Apollo.MutationFunction<GenerateUploadUrlsMutation, GenerateUploadUrlsMutationVariables>;

/**
 * __useGenerateUploadUrlsMutation__
 *
 * To run a mutation, you first call `useGenerateUploadUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadUrlsMutation, { data, loading, error }] = useGenerateUploadUrlsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateUploadUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadUrlsMutation, GenerateUploadUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadUrlsMutation, GenerateUploadUrlsMutationVariables>(GenerateUploadUrlsDocument, options);
      }
export type GenerateUploadUrlsMutationHookResult = ReturnType<typeof useGenerateUploadUrlsMutation>;
export type GenerateUploadUrlsMutationResult = Apollo.MutationResult<GenerateUploadUrlsMutation>;
export type GenerateUploadUrlsMutationOptions = Apollo.BaseMutationOptions<GenerateUploadUrlsMutation, GenerateUploadUrlsMutationVariables>;
export const ListingTypesDocument = gql`
    query ListingTypes {
  listingTypes {
    ...ListingTypeInfo
  }
}
    ${ListingTypeInfoFragmentDoc}`;

/**
 * __useListingTypesQuery__
 *
 * To run a query within a React component, call `useListingTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListingTypesQuery(baseOptions?: Apollo.QueryHookOptions<ListingTypesQuery, ListingTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListingTypesQuery, ListingTypesQueryVariables>(ListingTypesDocument, options);
      }
export function useListingTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListingTypesQuery, ListingTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListingTypesQuery, ListingTypesQueryVariables>(ListingTypesDocument, options);
        }
export function useListingTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListingTypesQuery, ListingTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListingTypesQuery, ListingTypesQueryVariables>(ListingTypesDocument, options);
        }
export type ListingTypesQueryHookResult = ReturnType<typeof useListingTypesQuery>;
export type ListingTypesLazyQueryHookResult = ReturnType<typeof useListingTypesLazyQuery>;
export type ListingTypesSuspenseQueryHookResult = ReturnType<typeof useListingTypesSuspenseQuery>;
export type ListingTypesQueryResult = Apollo.QueryResult<ListingTypesQuery, ListingTypesQueryVariables>;
export const GetLiveStatsDocument = gql`
    query GetLiveStats {
  getLiveStats {
    activeTenders
    activeBidGrossMerchandiseValue
  }
}
    `;

/**
 * __useGetLiveStatsQuery__
 *
 * To run a query within a React component, call `useGetLiveStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLiveStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetLiveStatsQuery, GetLiveStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiveStatsQuery, GetLiveStatsQueryVariables>(GetLiveStatsDocument, options);
      }
export function useGetLiveStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiveStatsQuery, GetLiveStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiveStatsQuery, GetLiveStatsQueryVariables>(GetLiveStatsDocument, options);
        }
export function useGetLiveStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLiveStatsQuery, GetLiveStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLiveStatsQuery, GetLiveStatsQueryVariables>(GetLiveStatsDocument, options);
        }
export type GetLiveStatsQueryHookResult = ReturnType<typeof useGetLiveStatsQuery>;
export type GetLiveStatsLazyQueryHookResult = ReturnType<typeof useGetLiveStatsLazyQuery>;
export type GetLiveStatsSuspenseQueryHookResult = ReturnType<typeof useGetLiveStatsSuspenseQuery>;
export type GetLiveStatsQueryResult = Apollo.QueryResult<GetLiveStatsQuery, GetLiveStatsQueryVariables>;
export const MessagesByBidIdDocument = gql`
    query MessagesByBidId($bidId: Int!) {
  messagesByBidId(bidId: $bidId) {
    ...MessageInfo
    venue {
      ...VenueInfo
    }
    brand {
      ...BrandInfo
    }
  }
}
    ${MessageInfoFragmentDoc}
${VenueInfoFragmentDoc}
${BrandInfoFragmentDoc}`;

/**
 * __useMessagesByBidIdQuery__
 *
 * To run a query within a React component, call `useMessagesByBidIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesByBidIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesByBidIdQuery({
 *   variables: {
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useMessagesByBidIdQuery(baseOptions: Apollo.QueryHookOptions<MessagesByBidIdQuery, MessagesByBidIdQueryVariables> & ({ variables: MessagesByBidIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesByBidIdQuery, MessagesByBidIdQueryVariables>(MessagesByBidIdDocument, options);
      }
export function useMessagesByBidIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesByBidIdQuery, MessagesByBidIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesByBidIdQuery, MessagesByBidIdQueryVariables>(MessagesByBidIdDocument, options);
        }
export function useMessagesByBidIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MessagesByBidIdQuery, MessagesByBidIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MessagesByBidIdQuery, MessagesByBidIdQueryVariables>(MessagesByBidIdDocument, options);
        }
export type MessagesByBidIdQueryHookResult = ReturnType<typeof useMessagesByBidIdQuery>;
export type MessagesByBidIdLazyQueryHookResult = ReturnType<typeof useMessagesByBidIdLazyQuery>;
export type MessagesByBidIdSuspenseQueryHookResult = ReturnType<typeof useMessagesByBidIdSuspenseQuery>;
export type MessagesByBidIdQueryResult = Apollo.QueryResult<MessagesByBidIdQuery, MessagesByBidIdQueryVariables>;
export const AddMessageDocument = gql`
    mutation AddMessage($input: AddMessageInput!) {
  addMessage(input: $input) {
    ...MessageInfo
  }
}
    ${MessageInfoFragmentDoc}`;
export type AddMessageMutationFn = Apollo.MutationFunction<AddMessageMutation, AddMessageMutationVariables>;

/**
 * __useAddMessageMutation__
 *
 * To run a mutation, you first call `useAddMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMessageMutation, { data, loading, error }] = useAddMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMessageMutation(baseOptions?: Apollo.MutationHookOptions<AddMessageMutation, AddMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMessageMutation, AddMessageMutationVariables>(AddMessageDocument, options);
      }
export type AddMessageMutationHookResult = ReturnType<typeof useAddMessageMutation>;
export type AddMessageMutationResult = Apollo.MutationResult<AddMessageMutation>;
export type AddMessageMutationOptions = Apollo.BaseMutationOptions<AddMessageMutation, AddMessageMutationVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($id: Int!) {
  markNotificationAsRead(id: $id) {
    ...NotificationInfo
  }
}
    ${NotificationInfoFragmentDoc}`;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation MarkAllNotificationsAsRead($input: MarkAllNotificationsAsReadInput!) {
  markAllNotificationsAsRead(input: $input) {
    ...NotificationInfo
  }
}
    ${NotificationInfoFragmentDoc}`;
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
      }
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const CursorNotificationsDocument = gql`
    query CursorNotifications($input: CursorNotificationsInput!) {
  cursorNotifications(input: $input) {
    edges {
      node {
        ...NotificationInfo
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
    unreadTotalCount
  }
}
    ${NotificationInfoFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useCursorNotificationsQuery__
 *
 * To run a query within a React component, call `useCursorNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCursorNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCursorNotificationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCursorNotificationsQuery(baseOptions: Apollo.QueryHookOptions<CursorNotificationsQuery, CursorNotificationsQueryVariables> & ({ variables: CursorNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CursorNotificationsQuery, CursorNotificationsQueryVariables>(CursorNotificationsDocument, options);
      }
export function useCursorNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CursorNotificationsQuery, CursorNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CursorNotificationsQuery, CursorNotificationsQueryVariables>(CursorNotificationsDocument, options);
        }
export function useCursorNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CursorNotificationsQuery, CursorNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CursorNotificationsQuery, CursorNotificationsQueryVariables>(CursorNotificationsDocument, options);
        }
export type CursorNotificationsQueryHookResult = ReturnType<typeof useCursorNotificationsQuery>;
export type CursorNotificationsLazyQueryHookResult = ReturnType<typeof useCursorNotificationsLazyQuery>;
export type CursorNotificationsSuspenseQueryHookResult = ReturnType<typeof useCursorNotificationsSuspenseQuery>;
export type CursorNotificationsQueryResult = Apollo.QueryResult<CursorNotificationsQuery, CursorNotificationsQueryVariables>;
export const OffsetNotificationsDocument = gql`
    query OffsetNotifications($input: OffsetNotificationsInput!) {
  offsetNotifications(input: $input) {
    data {
      ...NotificationInfo
    }
    pageInfo {
      ...OffsetPageInfo
    }
    totalCount
    unreadTotalCount
  }
}
    ${NotificationInfoFragmentDoc}
${OffsetPageInfoFragmentDoc}`;

/**
 * __useOffsetNotificationsQuery__
 *
 * To run a query within a React component, call `useOffsetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffsetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffsetNotificationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOffsetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<OffsetNotificationsQuery, OffsetNotificationsQueryVariables> & ({ variables: OffsetNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffsetNotificationsQuery, OffsetNotificationsQueryVariables>(OffsetNotificationsDocument, options);
      }
export function useOffsetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffsetNotificationsQuery, OffsetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffsetNotificationsQuery, OffsetNotificationsQueryVariables>(OffsetNotificationsDocument, options);
        }
export function useOffsetNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OffsetNotificationsQuery, OffsetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OffsetNotificationsQuery, OffsetNotificationsQueryVariables>(OffsetNotificationsDocument, options);
        }
export type OffsetNotificationsQueryHookResult = ReturnType<typeof useOffsetNotificationsQuery>;
export type OffsetNotificationsLazyQueryHookResult = ReturnType<typeof useOffsetNotificationsLazyQuery>;
export type OffsetNotificationsSuspenseQueryHookResult = ReturnType<typeof useOffsetNotificationsSuspenseQuery>;
export type OffsetNotificationsQueryResult = Apollo.QueryResult<OffsetNotificationsQuery, OffsetNotificationsQueryVariables>;
export const ProductCategoriesDocument = gql`
    query ProductCategories {
  productCategories {
    ...ProductCategoryInfo
  }
}
    ${ProductCategoryInfoFragmentDoc}`;

/**
 * __useProductCategoriesQuery__
 *
 * To run a query within a React component, call `useProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesDocument, options);
      }
export function useProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesDocument, options);
        }
export function useProductCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesDocument, options);
        }
export type ProductCategoriesQueryHookResult = ReturnType<typeof useProductCategoriesQuery>;
export type ProductCategoriesLazyQueryHookResult = ReturnType<typeof useProductCategoriesLazyQuery>;
export type ProductCategoriesSuspenseQueryHookResult = ReturnType<typeof useProductCategoriesSuspenseQuery>;
export type ProductCategoriesQueryResult = Apollo.QueryResult<ProductCategoriesQuery, ProductCategoriesQueryVariables>;
export const ProductCategorySubscriptionsDocument = gql`
    query ProductCategorySubscriptions {
  productCategorySubscriptions {
    ...ProductCategorySubscriptionItem
  }
}
    ${ProductCategorySubscriptionItemFragmentDoc}`;

/**
 * __useProductCategorySubscriptionsQuery__
 *
 * To run a query within a React component, call `useProductCategorySubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategorySubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategorySubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductCategorySubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<ProductCategorySubscriptionsQuery, ProductCategorySubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCategorySubscriptionsQuery, ProductCategorySubscriptionsQueryVariables>(ProductCategorySubscriptionsDocument, options);
      }
export function useProductCategorySubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategorySubscriptionsQuery, ProductCategorySubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCategorySubscriptionsQuery, ProductCategorySubscriptionsQueryVariables>(ProductCategorySubscriptionsDocument, options);
        }
export function useProductCategorySubscriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductCategorySubscriptionsQuery, ProductCategorySubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCategorySubscriptionsQuery, ProductCategorySubscriptionsQueryVariables>(ProductCategorySubscriptionsDocument, options);
        }
export type ProductCategorySubscriptionsQueryHookResult = ReturnType<typeof useProductCategorySubscriptionsQuery>;
export type ProductCategorySubscriptionsLazyQueryHookResult = ReturnType<typeof useProductCategorySubscriptionsLazyQuery>;
export type ProductCategorySubscriptionsSuspenseQueryHookResult = ReturnType<typeof useProductCategorySubscriptionsSuspenseQuery>;
export type ProductCategorySubscriptionsQueryResult = Apollo.QueryResult<ProductCategorySubscriptionsQuery, ProductCategorySubscriptionsQueryVariables>;
export const ProductTemplatesByBrandIdDocument = gql`
    query ProductTemplatesByBrandId($input: ProductTemplatesByBrandIdInput!) {
  productTemplatesByBrandId(input: $input) {
    ...ProductTemplateInfo
  }
}
    ${ProductTemplateInfoFragmentDoc}`;

/**
 * __useProductTemplatesByBrandIdQuery__
 *
 * To run a query within a React component, call `useProductTemplatesByBrandIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTemplatesByBrandIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTemplatesByBrandIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductTemplatesByBrandIdQuery(baseOptions: Apollo.QueryHookOptions<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables> & ({ variables: ProductTemplatesByBrandIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables>(ProductTemplatesByBrandIdDocument, options);
      }
export function useProductTemplatesByBrandIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables>(ProductTemplatesByBrandIdDocument, options);
        }
export function useProductTemplatesByBrandIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables>(ProductTemplatesByBrandIdDocument, options);
        }
export type ProductTemplatesByBrandIdQueryHookResult = ReturnType<typeof useProductTemplatesByBrandIdQuery>;
export type ProductTemplatesByBrandIdLazyQueryHookResult = ReturnType<typeof useProductTemplatesByBrandIdLazyQuery>;
export type ProductTemplatesByBrandIdSuspenseQueryHookResult = ReturnType<typeof useProductTemplatesByBrandIdSuspenseQuery>;
export type ProductTemplatesByBrandIdQueryResult = Apollo.QueryResult<ProductTemplatesByBrandIdQuery, ProductTemplatesByBrandIdQueryVariables>;
export const DeleteProductTemplateByIdDocument = gql`
    mutation DeleteProductTemplateById($input: DeleteProductTemplateInput!) {
  deleteProductTemplateById(input: $input)
}
    `;
export type DeleteProductTemplateByIdMutationFn = Apollo.MutationFunction<DeleteProductTemplateByIdMutation, DeleteProductTemplateByIdMutationVariables>;

/**
 * __useDeleteProductTemplateByIdMutation__
 *
 * To run a mutation, you first call `useDeleteProductTemplateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductTemplateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductTemplateByIdMutation, { data, loading, error }] = useDeleteProductTemplateByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductTemplateByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductTemplateByIdMutation, DeleteProductTemplateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductTemplateByIdMutation, DeleteProductTemplateByIdMutationVariables>(DeleteProductTemplateByIdDocument, options);
      }
export type DeleteProductTemplateByIdMutationHookResult = ReturnType<typeof useDeleteProductTemplateByIdMutation>;
export type DeleteProductTemplateByIdMutationResult = Apollo.MutationResult<DeleteProductTemplateByIdMutation>;
export type DeleteProductTemplateByIdMutationOptions = Apollo.BaseMutationOptions<DeleteProductTemplateByIdMutation, DeleteProductTemplateByIdMutationVariables>;
export const AddProductTemplateDocument = gql`
    mutation AddProductTemplate($input: AddProductTemplateInput!) {
  addProductTemplate(input: $input) {
    ...ProductTemplateInfo
  }
}
    ${ProductTemplateInfoFragmentDoc}`;
export type AddProductTemplateMutationFn = Apollo.MutationFunction<AddProductTemplateMutation, AddProductTemplateMutationVariables>;

/**
 * __useAddProductTemplateMutation__
 *
 * To run a mutation, you first call `useAddProductTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductTemplateMutation, { data, loading, error }] = useAddProductTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductTemplateMutation(baseOptions?: Apollo.MutationHookOptions<AddProductTemplateMutation, AddProductTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductTemplateMutation, AddProductTemplateMutationVariables>(AddProductTemplateDocument, options);
      }
export type AddProductTemplateMutationHookResult = ReturnType<typeof useAddProductTemplateMutation>;
export type AddProductTemplateMutationResult = Apollo.MutationResult<AddProductTemplateMutation>;
export type AddProductTemplateMutationOptions = Apollo.BaseMutationOptions<AddProductTemplateMutation, AddProductTemplateMutationVariables>;
export const EditProductTemplateDocument = gql`
    mutation EditProductTemplate($input: EditProductTemplateInput!) {
  editProductTemplate(input: $input) {
    ...ProductTemplateInfo
  }
}
    ${ProductTemplateInfoFragmentDoc}`;
export type EditProductTemplateMutationFn = Apollo.MutationFunction<EditProductTemplateMutation, EditProductTemplateMutationVariables>;

/**
 * __useEditProductTemplateMutation__
 *
 * To run a mutation, you first call `useEditProductTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProductTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProductTemplateMutation, { data, loading, error }] = useEditProductTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProductTemplateMutation(baseOptions?: Apollo.MutationHookOptions<EditProductTemplateMutation, EditProductTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProductTemplateMutation, EditProductTemplateMutationVariables>(EditProductTemplateDocument, options);
      }
export type EditProductTemplateMutationHookResult = ReturnType<typeof useEditProductTemplateMutation>;
export type EditProductTemplateMutationResult = Apollo.MutationResult<EditProductTemplateMutation>;
export type EditProductTemplateMutationOptions = Apollo.BaseMutationOptions<EditProductTemplateMutation, EditProductTemplateMutationVariables>;
export const ProductUnitDocument = gql`
    query ProductUnit {
  productUnits
}
    `;

/**
 * __useProductUnitQuery__
 *
 * To run a query within a React component, call `useProductUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductUnitQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductUnitQuery(baseOptions?: Apollo.QueryHookOptions<ProductUnitQuery, ProductUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductUnitQuery, ProductUnitQueryVariables>(ProductUnitDocument, options);
      }
export function useProductUnitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductUnitQuery, ProductUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductUnitQuery, ProductUnitQueryVariables>(ProductUnitDocument, options);
        }
export function useProductUnitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductUnitQuery, ProductUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductUnitQuery, ProductUnitQueryVariables>(ProductUnitDocument, options);
        }
export type ProductUnitQueryHookResult = ReturnType<typeof useProductUnitQuery>;
export type ProductUnitLazyQueryHookResult = ReturnType<typeof useProductUnitLazyQuery>;
export type ProductUnitSuspenseQueryHookResult = ReturnType<typeof useProductUnitSuspenseQuery>;
export type ProductUnitQueryResult = Apollo.QueryResult<ProductUnitQuery, ProductUnitQueryVariables>;
export const ProductPackagingDocument = gql`
    query ProductPackaging {
  productPackaging
}
    `;

/**
 * __useProductPackagingQuery__
 *
 * To run a query within a React component, call `useProductPackagingQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPackagingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPackagingQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductPackagingQuery(baseOptions?: Apollo.QueryHookOptions<ProductPackagingQuery, ProductPackagingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPackagingQuery, ProductPackagingQueryVariables>(ProductPackagingDocument, options);
      }
export function useProductPackagingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPackagingQuery, ProductPackagingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPackagingQuery, ProductPackagingQueryVariables>(ProductPackagingDocument, options);
        }
export function useProductPackagingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProductPackagingQuery, ProductPackagingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPackagingQuery, ProductPackagingQueryVariables>(ProductPackagingDocument, options);
        }
export type ProductPackagingQueryHookResult = ReturnType<typeof useProductPackagingQuery>;
export type ProductPackagingLazyQueryHookResult = ReturnType<typeof useProductPackagingLazyQuery>;
export type ProductPackagingSuspenseQueryHookResult = ReturnType<typeof useProductPackagingSuspenseQuery>;
export type ProductPackagingQueryResult = Apollo.QueryResult<ProductPackagingQuery, ProductPackagingQueryVariables>;
export const PromoDealsDocument = gql`
    query PromoDeals($input: PromoDealsInput!) {
  promoDeals(input: $input) {
    data {
      ...PromoDealInfo
    }
    totalCount
    pageInfo {
      currentPage
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
}
    ${PromoDealInfoFragmentDoc}`;

/**
 * __usePromoDealsQuery__
 *
 * To run a query within a React component, call `usePromoDealsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePromoDealsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePromoDealsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePromoDealsQuery(baseOptions: Apollo.QueryHookOptions<PromoDealsQuery, PromoDealsQueryVariables> & ({ variables: PromoDealsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PromoDealsQuery, PromoDealsQueryVariables>(PromoDealsDocument, options);
      }
export function usePromoDealsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PromoDealsQuery, PromoDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PromoDealsQuery, PromoDealsQueryVariables>(PromoDealsDocument, options);
        }
export function usePromoDealsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PromoDealsQuery, PromoDealsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PromoDealsQuery, PromoDealsQueryVariables>(PromoDealsDocument, options);
        }
export type PromoDealsQueryHookResult = ReturnType<typeof usePromoDealsQuery>;
export type PromoDealsLazyQueryHookResult = ReturnType<typeof usePromoDealsLazyQuery>;
export type PromoDealsSuspenseQueryHookResult = ReturnType<typeof usePromoDealsSuspenseQuery>;
export type PromoDealsQueryResult = Apollo.QueryResult<PromoDealsQuery, PromoDealsQueryVariables>;
export const GetDataFromCompanyNumberDocument = gql`
    query GetDataFromCompanyNumber($input: GetDataFromCompanyNumberInput!) {
  getDataFromCompanyNumber(input: $input) {
    ...RegisteredCompanyWithoutIdInfo
  }
}
    ${RegisteredCompanyWithoutIdInfoFragmentDoc}`;

/**
 * __useGetDataFromCompanyNumberQuery__
 *
 * To run a query within a React component, call `useGetDataFromCompanyNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataFromCompanyNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataFromCompanyNumberQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDataFromCompanyNumberQuery(baseOptions: Apollo.QueryHookOptions<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables> & ({ variables: GetDataFromCompanyNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables>(GetDataFromCompanyNumberDocument, options);
      }
export function useGetDataFromCompanyNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables>(GetDataFromCompanyNumberDocument, options);
        }
export function useGetDataFromCompanyNumberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables>(GetDataFromCompanyNumberDocument, options);
        }
export type GetDataFromCompanyNumberQueryHookResult = ReturnType<typeof useGetDataFromCompanyNumberQuery>;
export type GetDataFromCompanyNumberLazyQueryHookResult = ReturnType<typeof useGetDataFromCompanyNumberLazyQuery>;
export type GetDataFromCompanyNumberSuspenseQueryHookResult = ReturnType<typeof useGetDataFromCompanyNumberSuspenseQuery>;
export type GetDataFromCompanyNumberQueryResult = Apollo.QueryResult<GetDataFromCompanyNumberQuery, GetDataFromCompanyNumberQueryVariables>;
export const CreateStripeCheckoutDocument = gql`
    mutation CreateStripeCheckout($input: CreateStripeCheckoutInput!) {
  createStripeCheckout(input: $input)
}
    `;
export type CreateStripeCheckoutMutationFn = Apollo.MutationFunction<CreateStripeCheckoutMutation, CreateStripeCheckoutMutationVariables>;

/**
 * __useCreateStripeCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateStripeCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeCheckoutMutation, { data, loading, error }] = useCreateStripeCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStripeCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeCheckoutMutation, CreateStripeCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeCheckoutMutation, CreateStripeCheckoutMutationVariables>(CreateStripeCheckoutDocument, options);
      }
export type CreateStripeCheckoutMutationHookResult = ReturnType<typeof useCreateStripeCheckoutMutation>;
export type CreateStripeCheckoutMutationResult = Apollo.MutationResult<CreateStripeCheckoutMutation>;
export type CreateStripeCheckoutMutationOptions = Apollo.BaseMutationOptions<CreateStripeCheckoutMutation, CreateStripeCheckoutMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation UpdateSubscription($input: UpdateSubscriptionInput!) {
  updateSubscription(input: $input)
}
    `;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const SubscriptionDocument = gql`
    query subscription($stripeSubscriptionId: String!) {
  subscription(stripeSubscriptionId: $stripeSubscriptionId) {
    ...SubscriptionInfo
  }
}
    ${SubscriptionInfoFragmentDoc}`;

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *      stripeSubscriptionId: // value for 'stripeSubscriptionId'
 *   },
 * });
 */
export function useSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables> & ({ variables: SubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
      }
export function useSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
        }
export function useSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
        }
export type SubscriptionQueryHookResult = ReturnType<typeof useSubscriptionQuery>;
export type SubscriptionLazyQueryHookResult = ReturnType<typeof useSubscriptionLazyQuery>;
export type SubscriptionSuspenseQueryHookResult = ReturnType<typeof useSubscriptionSuspenseQuery>;
export type SubscriptionQueryResult = Apollo.QueryResult<SubscriptionQuery, SubscriptionQueryVariables>;
export const SubscriptionsDocument = gql`
    query subscriptions($stripeSubscriptionId: String!) {
  subscriptions(stripeSubscriptionId: $stripeSubscriptionId) {
    ...StripeProductCategorySubscriptionItem
  }
}
    ${StripeProductCategorySubscriptionItemFragmentDoc}`;

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *      stripeSubscriptionId: // value for 'stripeSubscriptionId'
 *   },
 * });
 */
export function useSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables> & ({ variables: SubscriptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
      }
export function useSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
export function useSubscriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
export type SubscriptionsQueryHookResult = ReturnType<typeof useSubscriptionsQuery>;
export type SubscriptionsLazyQueryHookResult = ReturnType<typeof useSubscriptionsLazyQuery>;
export type SubscriptionsSuspenseQueryHookResult = ReturnType<typeof useSubscriptionsSuspenseQuery>;
export type SubscriptionsQueryResult = Apollo.QueryResult<SubscriptionsQuery, SubscriptionsQueryVariables>;
export const NonSubscribedProductCategoriesDocument = gql`
    query nonSubscribedProductCategories($stripeSubscriptionId: String!) {
  nonSubscribedProductCategories(stripeSubscriptionId: $stripeSubscriptionId) {
    ...NonSubscribedProductCategoryInfo
  }
}
    ${NonSubscribedProductCategoryInfoFragmentDoc}`;

/**
 * __useNonSubscribedProductCategoriesQuery__
 *
 * To run a query within a React component, call `useNonSubscribedProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonSubscribedProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonSubscribedProductCategoriesQuery({
 *   variables: {
 *      stripeSubscriptionId: // value for 'stripeSubscriptionId'
 *   },
 * });
 */
export function useNonSubscribedProductCategoriesQuery(baseOptions: Apollo.QueryHookOptions<NonSubscribedProductCategoriesQuery, NonSubscribedProductCategoriesQueryVariables> & ({ variables: NonSubscribedProductCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonSubscribedProductCategoriesQuery, NonSubscribedProductCategoriesQueryVariables>(NonSubscribedProductCategoriesDocument, options);
      }
export function useNonSubscribedProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonSubscribedProductCategoriesQuery, NonSubscribedProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonSubscribedProductCategoriesQuery, NonSubscribedProductCategoriesQueryVariables>(NonSubscribedProductCategoriesDocument, options);
        }
export function useNonSubscribedProductCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NonSubscribedProductCategoriesQuery, NonSubscribedProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonSubscribedProductCategoriesQuery, NonSubscribedProductCategoriesQueryVariables>(NonSubscribedProductCategoriesDocument, options);
        }
export type NonSubscribedProductCategoriesQueryHookResult = ReturnType<typeof useNonSubscribedProductCategoriesQuery>;
export type NonSubscribedProductCategoriesLazyQueryHookResult = ReturnType<typeof useNonSubscribedProductCategoriesLazyQuery>;
export type NonSubscribedProductCategoriesSuspenseQueryHookResult = ReturnType<typeof useNonSubscribedProductCategoriesSuspenseQuery>;
export type NonSubscribedProductCategoriesQueryResult = Apollo.QueryResult<NonSubscribedProductCategoriesQuery, NonSubscribedProductCategoriesQueryVariables>;
export const InvoicesDocument = gql`
    query Invoices($stripeCustomerId: String!) {
  invoices(stripeCustomerId: $stripeCustomerId) {
    ...InvoiceInfo
  }
}
    ${InvoiceInfoFragmentDoc}`;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      stripeCustomerId: // value for 'stripeCustomerId'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables> & ({ variables: InvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export function useInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesSuspenseQueryHookResult = ReturnType<typeof useInvoicesSuspenseQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;
export const SuccessFeeInvoiceListDocument = gql`
    query SuccessFeeInvoiceList($userId: Int!) {
  successFeeInvoiceList(userId: $userId) {
    ...SuccessFeeInvoiceListItemInfo
  }
}
    ${SuccessFeeInvoiceListItemInfoFragmentDoc}`;

/**
 * __useSuccessFeeInvoiceListQuery__
 *
 * To run a query within a React component, call `useSuccessFeeInvoiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuccessFeeInvoiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuccessFeeInvoiceListQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSuccessFeeInvoiceListQuery(baseOptions: Apollo.QueryHookOptions<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables> & ({ variables: SuccessFeeInvoiceListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables>(SuccessFeeInvoiceListDocument, options);
      }
export function useSuccessFeeInvoiceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables>(SuccessFeeInvoiceListDocument, options);
        }
export function useSuccessFeeInvoiceListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables>(SuccessFeeInvoiceListDocument, options);
        }
export type SuccessFeeInvoiceListQueryHookResult = ReturnType<typeof useSuccessFeeInvoiceListQuery>;
export type SuccessFeeInvoiceListLazyQueryHookResult = ReturnType<typeof useSuccessFeeInvoiceListLazyQuery>;
export type SuccessFeeInvoiceListSuspenseQueryHookResult = ReturnType<typeof useSuccessFeeInvoiceListSuspenseQuery>;
export type SuccessFeeInvoiceListQueryResult = Apollo.QueryResult<SuccessFeeInvoiceListQuery, SuccessFeeInvoiceListQueryVariables>;
export const SuccessFeeInvoiceByIdDocument = gql`
    query SuccessFeeInvoiceById($invoiceId: String!) {
  successFeeInvoiceById(invoiceId: $invoiceId) {
    ...SuccessFeeInvoiceInfo
  }
}
    ${SuccessFeeInvoiceInfoFragmentDoc}`;

/**
 * __useSuccessFeeInvoiceByIdQuery__
 *
 * To run a query within a React component, call `useSuccessFeeInvoiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuccessFeeInvoiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuccessFeeInvoiceByIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useSuccessFeeInvoiceByIdQuery(baseOptions: Apollo.QueryHookOptions<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables> & ({ variables: SuccessFeeInvoiceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables>(SuccessFeeInvoiceByIdDocument, options);
      }
export function useSuccessFeeInvoiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables>(SuccessFeeInvoiceByIdDocument, options);
        }
export function useSuccessFeeInvoiceByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables>(SuccessFeeInvoiceByIdDocument, options);
        }
export type SuccessFeeInvoiceByIdQueryHookResult = ReturnType<typeof useSuccessFeeInvoiceByIdQuery>;
export type SuccessFeeInvoiceByIdLazyQueryHookResult = ReturnType<typeof useSuccessFeeInvoiceByIdLazyQuery>;
export type SuccessFeeInvoiceByIdSuspenseQueryHookResult = ReturnType<typeof useSuccessFeeInvoiceByIdSuspenseQuery>;
export type SuccessFeeInvoiceByIdQueryResult = Apollo.QueryResult<SuccessFeeInvoiceByIdQuery, SuccessFeeInvoiceByIdQueryVariables>;
export const BespokeTokenCheckDocument = gql`
    query BespokeTokenCheck($token: String!) {
  bespokeTokenCheck(token: $token) {
    ...BespokeCheckDataInfo
  }
}
    ${BespokeCheckDataInfoFragmentDoc}`;

/**
 * __useBespokeTokenCheckQuery__
 *
 * To run a query within a React component, call `useBespokeTokenCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useBespokeTokenCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBespokeTokenCheckQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useBespokeTokenCheckQuery(baseOptions: Apollo.QueryHookOptions<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables> & ({ variables: BespokeTokenCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables>(BespokeTokenCheckDocument, options);
      }
export function useBespokeTokenCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables>(BespokeTokenCheckDocument, options);
        }
export function useBespokeTokenCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables>(BespokeTokenCheckDocument, options);
        }
export type BespokeTokenCheckQueryHookResult = ReturnType<typeof useBespokeTokenCheckQuery>;
export type BespokeTokenCheckLazyQueryHookResult = ReturnType<typeof useBespokeTokenCheckLazyQuery>;
export type BespokeTokenCheckSuspenseQueryHookResult = ReturnType<typeof useBespokeTokenCheckSuspenseQuery>;
export type BespokeTokenCheckQueryResult = Apollo.QueryResult<BespokeTokenCheckQuery, BespokeTokenCheckQueryVariables>;
export const UpgradeToBespokeDocument = gql`
    mutation UpgradeToBespoke($token: String!) {
  upgradeToBespoke(token: $token) {
    ...UpgradeToBespokeDataInfo
  }
}
    ${UpgradeToBespokeDataInfoFragmentDoc}`;
export type UpgradeToBespokeMutationFn = Apollo.MutationFunction<UpgradeToBespokeMutation, UpgradeToBespokeMutationVariables>;

/**
 * __useUpgradeToBespokeMutation__
 *
 * To run a mutation, you first call `useUpgradeToBespokeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeToBespokeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeToBespokeMutation, { data, loading, error }] = useUpgradeToBespokeMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUpgradeToBespokeMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeToBespokeMutation, UpgradeToBespokeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeToBespokeMutation, UpgradeToBespokeMutationVariables>(UpgradeToBespokeDocument, options);
      }
export type UpgradeToBespokeMutationHookResult = ReturnType<typeof useUpgradeToBespokeMutation>;
export type UpgradeToBespokeMutationResult = Apollo.MutationResult<UpgradeToBespokeMutation>;
export type UpgradeToBespokeMutationOptions = Apollo.BaseMutationOptions<UpgradeToBespokeMutation, UpgradeToBespokeMutationVariables>;
export const CreateSubscriptionCheckoutDocument = gql`
    mutation CreateSubscriptionCheckout($input: CreateStripeCheckoutNewInput!) {
  createStripeCheckoutNew(input: $input)
}
    `;
export type CreateSubscriptionCheckoutMutationFn = Apollo.MutationFunction<CreateSubscriptionCheckoutMutation, CreateSubscriptionCheckoutMutationVariables>;

/**
 * __useCreateSubscriptionCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionCheckoutMutation, { data, loading, error }] = useCreateSubscriptionCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionCheckoutMutation, CreateSubscriptionCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionCheckoutMutation, CreateSubscriptionCheckoutMutationVariables>(CreateSubscriptionCheckoutDocument, options);
      }
export type CreateSubscriptionCheckoutMutationHookResult = ReturnType<typeof useCreateSubscriptionCheckoutMutation>;
export type CreateSubscriptionCheckoutMutationResult = Apollo.MutationResult<CreateSubscriptionCheckoutMutation>;
export type CreateSubscriptionCheckoutMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionCheckoutMutation, CreateSubscriptionCheckoutMutationVariables>;
export const RemoveProductCategorySubscriptionDocument = gql`
    mutation RemoveProductCategorySubscription($input: RemoveProductCategorySubscriptionInput!) {
  removeProductCategorySubscription(input: $input)
}
    `;
export type RemoveProductCategorySubscriptionMutationFn = Apollo.MutationFunction<RemoveProductCategorySubscriptionMutation, RemoveProductCategorySubscriptionMutationVariables>;

/**
 * __useRemoveProductCategorySubscriptionMutation__
 *
 * To run a mutation, you first call `useRemoveProductCategorySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProductCategorySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProductCategorySubscriptionMutation, { data, loading, error }] = useRemoveProductCategorySubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProductCategorySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProductCategorySubscriptionMutation, RemoveProductCategorySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProductCategorySubscriptionMutation, RemoveProductCategorySubscriptionMutationVariables>(RemoveProductCategorySubscriptionDocument, options);
      }
export type RemoveProductCategorySubscriptionMutationHookResult = ReturnType<typeof useRemoveProductCategorySubscriptionMutation>;
export type RemoveProductCategorySubscriptionMutationResult = Apollo.MutationResult<RemoveProductCategorySubscriptionMutation>;
export type RemoveProductCategorySubscriptionMutationOptions = Apollo.BaseMutationOptions<RemoveProductCategorySubscriptionMutation, RemoveProductCategorySubscriptionMutationVariables>;
export const UpgradeProductCategorySubscriptionDocument = gql`
    mutation UpgradeProductCategorySubscription($input: UpgradeProductCategorySubscriptionInput!) {
  upgradeProductCategorySubscription(input: $input)
}
    `;
export type UpgradeProductCategorySubscriptionMutationFn = Apollo.MutationFunction<UpgradeProductCategorySubscriptionMutation, UpgradeProductCategorySubscriptionMutationVariables>;

/**
 * __useUpgradeProductCategorySubscriptionMutation__
 *
 * To run a mutation, you first call `useUpgradeProductCategorySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeProductCategorySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeProductCategorySubscriptionMutation, { data, loading, error }] = useUpgradeProductCategorySubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpgradeProductCategorySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeProductCategorySubscriptionMutation, UpgradeProductCategorySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeProductCategorySubscriptionMutation, UpgradeProductCategorySubscriptionMutationVariables>(UpgradeProductCategorySubscriptionDocument, options);
      }
export type UpgradeProductCategorySubscriptionMutationHookResult = ReturnType<typeof useUpgradeProductCategorySubscriptionMutation>;
export type UpgradeProductCategorySubscriptionMutationResult = Apollo.MutationResult<UpgradeProductCategorySubscriptionMutation>;
export type UpgradeProductCategorySubscriptionMutationOptions = Apollo.BaseMutationOptions<UpgradeProductCategorySubscriptionMutation, UpgradeProductCategorySubscriptionMutationVariables>;
export const AddProductCategorySubscriptionDocument = gql`
    mutation AddProductCategorySubscription($input: AddProductCategorySubscriptionInput!) {
  addProductCategorySubscription(input: $input)
}
    `;
export type AddProductCategorySubscriptionMutationFn = Apollo.MutationFunction<AddProductCategorySubscriptionMutation, AddProductCategorySubscriptionMutationVariables>;

/**
 * __useAddProductCategorySubscriptionMutation__
 *
 * To run a mutation, you first call `useAddProductCategorySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductCategorySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductCategorySubscriptionMutation, { data, loading, error }] = useAddProductCategorySubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductCategorySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<AddProductCategorySubscriptionMutation, AddProductCategorySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductCategorySubscriptionMutation, AddProductCategorySubscriptionMutationVariables>(AddProductCategorySubscriptionDocument, options);
      }
export type AddProductCategorySubscriptionMutationHookResult = ReturnType<typeof useAddProductCategorySubscriptionMutation>;
export type AddProductCategorySubscriptionMutationResult = Apollo.MutationResult<AddProductCategorySubscriptionMutation>;
export type AddProductCategorySubscriptionMutationOptions = Apollo.BaseMutationOptions<AddProductCategorySubscriptionMutation, AddProductCategorySubscriptionMutationVariables>;
export const TenderByIdDocument = gql`
    query TenderById($tenderId: Int!) {
  tenderById(tenderId: $tenderId) {
    ...TenderInfo
    venue {
      ...VenueInfo
    }
    listingTypeId
    productCategoryId
    productCategory {
      ...ProductCategoryInfo
    }
    listingType {
      ...ListingTypeInfo
    }
    wholesalers {
      ...WholesalerInfo
    }
    totalReceivedBids
    files {
      ...FileInfo
    }
    user {
      ...UserInfo
    }
  }
}
    ${TenderInfoFragmentDoc}
${VenueInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${FileInfoFragmentDoc}
${UserInfoFragmentDoc}`;

/**
 * __useTenderByIdQuery__
 *
 * To run a query within a React component, call `useTenderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenderByIdQuery({
 *   variables: {
 *      tenderId: // value for 'tenderId'
 *   },
 * });
 */
export function useTenderByIdQuery(baseOptions: Apollo.QueryHookOptions<TenderByIdQuery, TenderByIdQueryVariables> & ({ variables: TenderByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenderByIdQuery, TenderByIdQueryVariables>(TenderByIdDocument, options);
      }
export function useTenderByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenderByIdQuery, TenderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenderByIdQuery, TenderByIdQueryVariables>(TenderByIdDocument, options);
        }
export function useTenderByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenderByIdQuery, TenderByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenderByIdQuery, TenderByIdQueryVariables>(TenderByIdDocument, options);
        }
export type TenderByIdQueryHookResult = ReturnType<typeof useTenderByIdQuery>;
export type TenderByIdLazyQueryHookResult = ReturnType<typeof useTenderByIdLazyQuery>;
export type TenderByIdSuspenseQueryHookResult = ReturnType<typeof useTenderByIdSuspenseQuery>;
export type TenderByIdQueryResult = Apollo.QueryResult<TenderByIdQuery, TenderByIdQueryVariables>;
export const TenderTemplateByTenderIdDocument = gql`
    query TenderTemplateByTenderId($tenderId: Int!) {
  tenderById(tenderId: $tenderId) {
    venueId
    listingTypeId
    productCategoryId
    tenderDetails
    estimatedVolume
    volumeUnits
    volumeDetails
    supportsFreeStock
    supportsListingFee
    supportsPosBudget
    supportsRetroDiscount
    supportDetails
    listingTypeId
    userId
    productCategoryId
    packagingType
    unitType
    productCategory {
      ...ProductCategoryInfo
    }
    listingType {
      ...ListingTypeInfo
    }
    wholesalers {
      ...WholesalerInfo
    }
    region
  }
}
    ${ProductCategoryInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${WholesalerInfoFragmentDoc}`;

/**
 * __useTenderTemplateByTenderIdQuery__
 *
 * To run a query within a React component, call `useTenderTemplateByTenderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenderTemplateByTenderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenderTemplateByTenderIdQuery({
 *   variables: {
 *      tenderId: // value for 'tenderId'
 *   },
 * });
 */
export function useTenderTemplateByTenderIdQuery(baseOptions: Apollo.QueryHookOptions<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables> & ({ variables: TenderTemplateByTenderIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables>(TenderTemplateByTenderIdDocument, options);
      }
export function useTenderTemplateByTenderIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables>(TenderTemplateByTenderIdDocument, options);
        }
export function useTenderTemplateByTenderIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables>(TenderTemplateByTenderIdDocument, options);
        }
export type TenderTemplateByTenderIdQueryHookResult = ReturnType<typeof useTenderTemplateByTenderIdQuery>;
export type TenderTemplateByTenderIdLazyQueryHookResult = ReturnType<typeof useTenderTemplateByTenderIdLazyQuery>;
export type TenderTemplateByTenderIdSuspenseQueryHookResult = ReturnType<typeof useTenderTemplateByTenderIdSuspenseQuery>;
export type TenderTemplateByTenderIdQueryResult = Apollo.QueryResult<TenderTemplateByTenderIdQuery, TenderTemplateByTenderIdQueryVariables>;
export const VenueDashboardTendersDocument = gql`
    query VenueDashboardTenders($input: VenueDashboardTendersInput!) {
  venueDashboardTenders(input: $input) {
    data {
      __typename
      ... on Tender {
        id
        status
        venue {
          ...VenueInfo
        }
        listingType {
          ...ListingTypeInfo
        }
        productCategory {
          ...ProductCategoryInfo
        }
        tenderStartsAtUtc
        tenderEndsAtUtc
        listingStartsAtUtc
        listingEndsAtUtc
        name
        estimatedVolume
        volumeUnits
        totalReceivedBids
        receivedSupportStatus
        packagingType
        unitType
        isDirectSupplyCompatible
        region
      }
    }
    totalCount
    pageInfo {
      ...OffsetPageInfo
    }
    data {
      ... on TenderDraft {
        id
        listingType {
          ...ListingTypeInfo
        }
        productCategory {
          ...ProductCategoryInfo
        }
        tenderStartsAtUtc
        tenderEndsAtUtc
        listingStartsAtUtc
        listingEndsAtUtc
        name
        estimatedVolume
        volumeUnits
        draftPackagingType: packagingType
        draftUnitType: unitType
        createdAtUtc
      }
    }
    totalCount
    pageInfo {
      ...OffsetPageInfo
    }
  }
}
    ${VenueInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${OffsetPageInfoFragmentDoc}`;

/**
 * __useVenueDashboardTendersQuery__
 *
 * To run a query within a React component, call `useVenueDashboardTendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueDashboardTendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueDashboardTendersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVenueDashboardTendersQuery(baseOptions: Apollo.QueryHookOptions<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables> & ({ variables: VenueDashboardTendersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables>(VenueDashboardTendersDocument, options);
      }
export function useVenueDashboardTendersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables>(VenueDashboardTendersDocument, options);
        }
export function useVenueDashboardTendersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables>(VenueDashboardTendersDocument, options);
        }
export type VenueDashboardTendersQueryHookResult = ReturnType<typeof useVenueDashboardTendersQuery>;
export type VenueDashboardTendersLazyQueryHookResult = ReturnType<typeof useVenueDashboardTendersLazyQuery>;
export type VenueDashboardTendersSuspenseQueryHookResult = ReturnType<typeof useVenueDashboardTendersSuspenseQuery>;
export type VenueDashboardTendersQueryResult = Apollo.QueryResult<VenueDashboardTendersQuery, VenueDashboardTendersQueryVariables>;
export const AddTenderDocument = gql`
    mutation AddTender($input: AddTenderInput!) {
  addTender(input: $input) {
    ...TenderInfo
    files {
      ...FileInfo
    }
  }
}
    ${TenderInfoFragmentDoc}
${FileInfoFragmentDoc}`;
export type AddTenderMutationFn = Apollo.MutationFunction<AddTenderMutation, AddTenderMutationVariables>;

/**
 * __useAddTenderMutation__
 *
 * To run a mutation, you first call `useAddTenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTenderMutation, { data, loading, error }] = useAddTenderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTenderMutation(baseOptions?: Apollo.MutationHookOptions<AddTenderMutation, AddTenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTenderMutation, AddTenderMutationVariables>(AddTenderDocument, options);
      }
export type AddTenderMutationHookResult = ReturnType<typeof useAddTenderMutation>;
export type AddTenderMutationResult = Apollo.MutationResult<AddTenderMutation>;
export type AddTenderMutationOptions = Apollo.BaseMutationOptions<AddTenderMutation, AddTenderMutationVariables>;
export const EditTenderDocument = gql`
    mutation EditTender($input: EditTenderInput!) {
  editTender(input: $input) {
    ...TenderInfo
    files {
      ...FileInfo
    }
  }
}
    ${TenderInfoFragmentDoc}
${FileInfoFragmentDoc}`;
export type EditTenderMutationFn = Apollo.MutationFunction<EditTenderMutation, EditTenderMutationVariables>;

/**
 * __useEditTenderMutation__
 *
 * To run a mutation, you first call `useEditTenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTenderMutation, { data, loading, error }] = useEditTenderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTenderMutation(baseOptions?: Apollo.MutationHookOptions<EditTenderMutation, EditTenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTenderMutation, EditTenderMutationVariables>(EditTenderDocument, options);
      }
export type EditTenderMutationHookResult = ReturnType<typeof useEditTenderMutation>;
export type EditTenderMutationResult = Apollo.MutationResult<EditTenderMutation>;
export type EditTenderMutationOptions = Apollo.BaseMutationOptions<EditTenderMutation, EditTenderMutationVariables>;
export const TenderListDocument = gql`
    query TenderList($input: TendersInput!) {
  tenderList(input: $input) {
    data {
      id
      venue {
        ...VenueInfo
      }
      listingType {
        ...ListingTypeInfo
      }
      productCategory {
        ...ProductCategoryInfo
      }
      files {
        ...FileInfo
      }
      tenderStartsAtUtc
      tenderEndsAtUtc
      listingStartsAtUtc
      listingEndsAtUtc
      name
      estimatedVolume
      volumeUnits
      totalReceivedBids
      status
      userId
      venueId
      productCategoryId
      listingTypeId
      receivedSupportStatus
      packagingType
      unitType
      isDirectSupplyCompatible
      region
      isPrivate
    }
    totalCount
    pageInfo {
      ...OffsetPageInfo
    }
  }
}
    ${VenueInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${FileInfoFragmentDoc}
${OffsetPageInfoFragmentDoc}`;

/**
 * __useTenderListQuery__
 *
 * To run a query within a React component, call `useTenderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenderListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTenderListQuery(baseOptions: Apollo.QueryHookOptions<TenderListQuery, TenderListQueryVariables> & ({ variables: TenderListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenderListQuery, TenderListQueryVariables>(TenderListDocument, options);
      }
export function useTenderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenderListQuery, TenderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenderListQuery, TenderListQueryVariables>(TenderListDocument, options);
        }
export function useTenderListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenderListQuery, TenderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenderListQuery, TenderListQueryVariables>(TenderListDocument, options);
        }
export type TenderListQueryHookResult = ReturnType<typeof useTenderListQuery>;
export type TenderListLazyQueryHookResult = ReturnType<typeof useTenderListLazyQuery>;
export type TenderListSuspenseQueryHookResult = ReturnType<typeof useTenderListSuspenseQuery>;
export type TenderListQueryResult = Apollo.QueryResult<TenderListQuery, TenderListQueryVariables>;
export const TenderListFilterOptionsDocument = gql`
    query TenderListFilterOptions {
  tenderListFilterOptions {
    label
    options {
      label
      value
    }
  }
}
    `;

/**
 * __useTenderListFilterOptionsQuery__
 *
 * To run a query within a React component, call `useTenderListFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenderListFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenderListFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenderListFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>(TenderListFilterOptionsDocument, options);
      }
export function useTenderListFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>(TenderListFilterOptionsDocument, options);
        }
export function useTenderListFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>(TenderListFilterOptionsDocument, options);
        }
export type TenderListFilterOptionsQueryHookResult = ReturnType<typeof useTenderListFilterOptionsQuery>;
export type TenderListFilterOptionsLazyQueryHookResult = ReturnType<typeof useTenderListFilterOptionsLazyQuery>;
export type TenderListFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useTenderListFilterOptionsSuspenseQuery>;
export type TenderListFilterOptionsQueryResult = Apollo.QueryResult<TenderListFilterOptionsQuery, TenderListFilterOptionsQueryVariables>;
export const DeleteTenderByIdDocument = gql`
    mutation DeleteTenderById($tenderId: Int!) {
  deleteTenderById(tenderId: $tenderId)
}
    `;
export type DeleteTenderByIdMutationFn = Apollo.MutationFunction<DeleteTenderByIdMutation, DeleteTenderByIdMutationVariables>;

/**
 * __useDeleteTenderByIdMutation__
 *
 * To run a mutation, you first call `useDeleteTenderByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenderByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenderByIdMutation, { data, loading, error }] = useDeleteTenderByIdMutation({
 *   variables: {
 *      tenderId: // value for 'tenderId'
 *   },
 * });
 */
export function useDeleteTenderByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenderByIdMutation, DeleteTenderByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenderByIdMutation, DeleteTenderByIdMutationVariables>(DeleteTenderByIdDocument, options);
      }
export type DeleteTenderByIdMutationHookResult = ReturnType<typeof useDeleteTenderByIdMutation>;
export type DeleteTenderByIdMutationResult = Apollo.MutationResult<DeleteTenderByIdMutation>;
export type DeleteTenderByIdMutationOptions = Apollo.BaseMutationOptions<DeleteTenderByIdMutation, DeleteTenderByIdMutationVariables>;
export const ChooseWinnerDocument = gql`
    mutation ChooseWinner($input: ChooseWinnerInput!) {
  chooseWinner(input: $input) {
    ...TenderInfo
  }
}
    ${TenderInfoFragmentDoc}`;
export type ChooseWinnerMutationFn = Apollo.MutationFunction<ChooseWinnerMutation, ChooseWinnerMutationVariables>;

/**
 * __useChooseWinnerMutation__
 *
 * To run a mutation, you first call `useChooseWinnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseWinnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseWinnerMutation, { data, loading, error }] = useChooseWinnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChooseWinnerMutation(baseOptions?: Apollo.MutationHookOptions<ChooseWinnerMutation, ChooseWinnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChooseWinnerMutation, ChooseWinnerMutationVariables>(ChooseWinnerDocument, options);
      }
export type ChooseWinnerMutationHookResult = ReturnType<typeof useChooseWinnerMutation>;
export type ChooseWinnerMutationResult = Apollo.MutationResult<ChooseWinnerMutation>;
export type ChooseWinnerMutationOptions = Apollo.BaseMutationOptions<ChooseWinnerMutation, ChooseWinnerMutationVariables>;
export const MultipleBidsTendersDocument = gql`
    query MultipleBidsTenders($input: TendersInput!) {
  tenderList(input: $input) {
    data {
      id
      name
      venue {
        ...VenueInfo
      }
      files {
        ...FileInfo
      }
      listingTypeId
      listingType {
        ...ListingTypeInfo
      }
      productCategoryId
      productCategory {
        ...ProductCategoryInfo
      }
      wholesalers {
        ...WholesalerInfo
      }
      supportsFreeStock
      supportsListingFee
      supportsPosBudget
      supportsRetroDiscount
      supportDetails
      tenderDetails
      volumeDetails
      estimatedVolume
      volumeUnits
      listingEndsAtUtc
      listingStartsAtUtc
      tenderStartsAtUtc
      tenderEndsAtUtc
      hasBrandsBid
      status
      venueId
      totalReceivedBids
      packagingType
      unitType
      isDirectSupplyCompatible
      region
      isPrivate
    }
    totalCount
    pageInfo {
      ...OffsetPageInfo
    }
  }
}
    ${VenueInfoFragmentDoc}
${FileInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${OffsetPageInfoFragmentDoc}`;

/**
 * __useMultipleBidsTendersQuery__
 *
 * To run a query within a React component, call `useMultipleBidsTendersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultipleBidsTendersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultipleBidsTendersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMultipleBidsTendersQuery(baseOptions: Apollo.QueryHookOptions<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables> & ({ variables: MultipleBidsTendersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables>(MultipleBidsTendersDocument, options);
      }
export function useMultipleBidsTendersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables>(MultipleBidsTendersDocument, options);
        }
export function useMultipleBidsTendersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables>(MultipleBidsTendersDocument, options);
        }
export type MultipleBidsTendersQueryHookResult = ReturnType<typeof useMultipleBidsTendersQuery>;
export type MultipleBidsTendersLazyQueryHookResult = ReturnType<typeof useMultipleBidsTendersLazyQuery>;
export type MultipleBidsTendersSuspenseQueryHookResult = ReturnType<typeof useMultipleBidsTendersSuspenseQuery>;
export type MultipleBidsTendersQueryResult = Apollo.QueryResult<MultipleBidsTendersQuery, MultipleBidsTendersQueryVariables>;
export const TopTendersBidsCountMinBoundaryDocument = gql`
    query TopTendersBidsCountMinBoundary {
  topTendersBidsCountMinBoundary
}
    `;

/**
 * __useTopTendersBidsCountMinBoundaryQuery__
 *
 * To run a query within a React component, call `useTopTendersBidsCountMinBoundaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopTendersBidsCountMinBoundaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopTendersBidsCountMinBoundaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopTendersBidsCountMinBoundaryQuery(baseOptions?: Apollo.QueryHookOptions<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>(TopTendersBidsCountMinBoundaryDocument, options);
      }
export function useTopTendersBidsCountMinBoundaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>(TopTendersBidsCountMinBoundaryDocument, options);
        }
export function useTopTendersBidsCountMinBoundarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>(TopTendersBidsCountMinBoundaryDocument, options);
        }
export type TopTendersBidsCountMinBoundaryQueryHookResult = ReturnType<typeof useTopTendersBidsCountMinBoundaryQuery>;
export type TopTendersBidsCountMinBoundaryLazyQueryHookResult = ReturnType<typeof useTopTendersBidsCountMinBoundaryLazyQuery>;
export type TopTendersBidsCountMinBoundarySuspenseQueryHookResult = ReturnType<typeof useTopTendersBidsCountMinBoundarySuspenseQuery>;
export type TopTendersBidsCountMinBoundaryQueryResult = Apollo.QueryResult<TopTendersBidsCountMinBoundaryQuery, TopTendersBidsCountMinBoundaryQueryVariables>;
export const TenderDraftByIdDocument = gql`
    query TenderDraftById($tenderDraftId: Int!) {
  tenderDraftById(tenderDraftId: $tenderDraftId) {
    ...TenderDraftInfo
    venue {
      ...VenueInfo
    }
    user {
      ...UserInfo
    }
    listingTypeId
    productCategoryId
    productCategory {
      ...ProductCategoryInfo
    }
    listingType {
      ...ListingTypeInfo
    }
    wholesalers {
      ...WholesalerInfo
    }
    files {
      ...FileInfo
    }
  }
}
    ${TenderDraftInfoFragmentDoc}
${VenueInfoFragmentDoc}
${UserInfoFragmentDoc}
${ProductCategoryInfoFragmentDoc}
${ListingTypeInfoFragmentDoc}
${WholesalerInfoFragmentDoc}
${FileInfoFragmentDoc}`;

/**
 * __useTenderDraftByIdQuery__
 *
 * To run a query within a React component, call `useTenderDraftByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenderDraftByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenderDraftByIdQuery({
 *   variables: {
 *      tenderDraftId: // value for 'tenderDraftId'
 *   },
 * });
 */
export function useTenderDraftByIdQuery(baseOptions: Apollo.QueryHookOptions<TenderDraftByIdQuery, TenderDraftByIdQueryVariables> & ({ variables: TenderDraftByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenderDraftByIdQuery, TenderDraftByIdQueryVariables>(TenderDraftByIdDocument, options);
      }
export function useTenderDraftByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenderDraftByIdQuery, TenderDraftByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenderDraftByIdQuery, TenderDraftByIdQueryVariables>(TenderDraftByIdDocument, options);
        }
export function useTenderDraftByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenderDraftByIdQuery, TenderDraftByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenderDraftByIdQuery, TenderDraftByIdQueryVariables>(TenderDraftByIdDocument, options);
        }
export type TenderDraftByIdQueryHookResult = ReturnType<typeof useTenderDraftByIdQuery>;
export type TenderDraftByIdLazyQueryHookResult = ReturnType<typeof useTenderDraftByIdLazyQuery>;
export type TenderDraftByIdSuspenseQueryHookResult = ReturnType<typeof useTenderDraftByIdSuspenseQuery>;
export type TenderDraftByIdQueryResult = Apollo.QueryResult<TenderDraftByIdQuery, TenderDraftByIdQueryVariables>;
export const EditTenderDraftDocument = gql`
    mutation EditTenderDraft($input: EditTenderDraftInput!) {
  editTenderDraft(input: $input) {
    ...TenderDraftInfo
    files {
      ...FileInfo
    }
  }
}
    ${TenderDraftInfoFragmentDoc}
${FileInfoFragmentDoc}`;
export type EditTenderDraftMutationFn = Apollo.MutationFunction<EditTenderDraftMutation, EditTenderDraftMutationVariables>;

/**
 * __useEditTenderDraftMutation__
 *
 * To run a mutation, you first call `useEditTenderDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTenderDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTenderDraftMutation, { data, loading, error }] = useEditTenderDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTenderDraftMutation(baseOptions?: Apollo.MutationHookOptions<EditTenderDraftMutation, EditTenderDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTenderDraftMutation, EditTenderDraftMutationVariables>(EditTenderDraftDocument, options);
      }
export type EditTenderDraftMutationHookResult = ReturnType<typeof useEditTenderDraftMutation>;
export type EditTenderDraftMutationResult = Apollo.MutationResult<EditTenderDraftMutation>;
export type EditTenderDraftMutationOptions = Apollo.BaseMutationOptions<EditTenderDraftMutation, EditTenderDraftMutationVariables>;
export const AddTenderDraftDocument = gql`
    mutation AddTenderDraft($input: AddTenderDraftInput!) {
  addTenderDraft(input: $input) {
    ...TenderDraftInfo
    files {
      ...FileInfo
    }
  }
}
    ${TenderDraftInfoFragmentDoc}
${FileInfoFragmentDoc}`;
export type AddTenderDraftMutationFn = Apollo.MutationFunction<AddTenderDraftMutation, AddTenderDraftMutationVariables>;

/**
 * __useAddTenderDraftMutation__
 *
 * To run a mutation, you first call `useAddTenderDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTenderDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTenderDraftMutation, { data, loading, error }] = useAddTenderDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTenderDraftMutation(baseOptions?: Apollo.MutationHookOptions<AddTenderDraftMutation, AddTenderDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTenderDraftMutation, AddTenderDraftMutationVariables>(AddTenderDraftDocument, options);
      }
export type AddTenderDraftMutationHookResult = ReturnType<typeof useAddTenderDraftMutation>;
export type AddTenderDraftMutationResult = Apollo.MutationResult<AddTenderDraftMutation>;
export type AddTenderDraftMutationOptions = Apollo.BaseMutationOptions<AddTenderDraftMutation, AddTenderDraftMutationVariables>;
export const DeleteTenderDraftByIdDocument = gql`
    mutation DeleteTenderDraftById($tenderDraftId: Int!) {
  deleteTenderDraftById(tenderDraftId: $tenderDraftId)
}
    `;
export type DeleteTenderDraftByIdMutationFn = Apollo.MutationFunction<DeleteTenderDraftByIdMutation, DeleteTenderDraftByIdMutationVariables>;

/**
 * __useDeleteTenderDraftByIdMutation__
 *
 * To run a mutation, you first call `useDeleteTenderDraftByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenderDraftByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenderDraftByIdMutation, { data, loading, error }] = useDeleteTenderDraftByIdMutation({
 *   variables: {
 *      tenderDraftId: // value for 'tenderDraftId'
 *   },
 * });
 */
export function useDeleteTenderDraftByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenderDraftByIdMutation, DeleteTenderDraftByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenderDraftByIdMutation, DeleteTenderDraftByIdMutationVariables>(DeleteTenderDraftByIdDocument, options);
      }
export type DeleteTenderDraftByIdMutationHookResult = ReturnType<typeof useDeleteTenderDraftByIdMutation>;
export type DeleteTenderDraftByIdMutationResult = Apollo.MutationResult<DeleteTenderDraftByIdMutation>;
export type DeleteTenderDraftByIdMutationOptions = Apollo.BaseMutationOptions<DeleteTenderDraftByIdMutation, DeleteTenderDraftByIdMutationVariables>;
export const EditTenderPreferenceDocument = gql`
    mutation EditTenderPreference($input: EditTenderPreferenceInput!) {
  editTenderPreference(input: $input) {
    ...TenderPreferenceInfo
  }
}
    ${TenderPreferenceInfoFragmentDoc}`;
export type EditTenderPreferenceMutationFn = Apollo.MutationFunction<EditTenderPreferenceMutation, EditTenderPreferenceMutationVariables>;

/**
 * __useEditTenderPreferenceMutation__
 *
 * To run a mutation, you first call `useEditTenderPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTenderPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTenderPreferenceMutation, { data, loading, error }] = useEditTenderPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTenderPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<EditTenderPreferenceMutation, EditTenderPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTenderPreferenceMutation, EditTenderPreferenceMutationVariables>(EditTenderPreferenceDocument, options);
      }
export type EditTenderPreferenceMutationHookResult = ReturnType<typeof useEditTenderPreferenceMutation>;
export type EditTenderPreferenceMutationResult = Apollo.MutationResult<EditTenderPreferenceMutation>;
export type EditTenderPreferenceMutationOptions = Apollo.BaseMutationOptions<EditTenderPreferenceMutation, EditTenderPreferenceMutationVariables>;
export const TenderPreferenceByVenueIdDocument = gql`
    query TenderPreferenceByVenueId($venueId: Int!) {
  tenderPreferenceByVenueId(venueId: $venueId) {
    ...TenderPreferenceInfo
  }
}
    ${TenderPreferenceInfoFragmentDoc}`;

/**
 * __useTenderPreferenceByVenueIdQuery__
 *
 * To run a query within a React component, call `useTenderPreferenceByVenueIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenderPreferenceByVenueIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenderPreferenceByVenueIdQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useTenderPreferenceByVenueIdQuery(baseOptions: Apollo.QueryHookOptions<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables> & ({ variables: TenderPreferenceByVenueIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables>(TenderPreferenceByVenueIdDocument, options);
      }
export function useTenderPreferenceByVenueIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables>(TenderPreferenceByVenueIdDocument, options);
        }
export function useTenderPreferenceByVenueIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables>(TenderPreferenceByVenueIdDocument, options);
        }
export type TenderPreferenceByVenueIdQueryHookResult = ReturnType<typeof useTenderPreferenceByVenueIdQuery>;
export type TenderPreferenceByVenueIdLazyQueryHookResult = ReturnType<typeof useTenderPreferenceByVenueIdLazyQuery>;
export type TenderPreferenceByVenueIdSuspenseQueryHookResult = ReturnType<typeof useTenderPreferenceByVenueIdSuspenseQuery>;
export type TenderPreferenceByVenueIdQueryResult = Apollo.QueryResult<TenderPreferenceByVenueIdQuery, TenderPreferenceByVenueIdQueryVariables>;
export const UserMeDocument = gql`
    query UserMe($input: UserMeInput) {
  userMe(input: $input) {
    ...UserInfo
    firstFourVenues {
      ...VenueInfo
    }
    brands {
      ...BrandInfoWithHasActiveSubscriptionField
    }
    activeVenue {
      ...VenueInfo
    }
  }
}
    ${UserInfoFragmentDoc}
${VenueInfoFragmentDoc}
${BrandInfoWithHasActiveSubscriptionFieldFragmentDoc}`;

/**
 * __useUserMeQuery__
 *
 * To run a query within a React component, call `useUserMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserMeQuery(baseOptions?: Apollo.QueryHookOptions<UserMeQuery, UserMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserMeQuery, UserMeQueryVariables>(UserMeDocument, options);
      }
export function useUserMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserMeQuery, UserMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserMeQuery, UserMeQueryVariables>(UserMeDocument, options);
        }
export function useUserMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserMeQuery, UserMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserMeQuery, UserMeQueryVariables>(UserMeDocument, options);
        }
export type UserMeQueryHookResult = ReturnType<typeof useUserMeQuery>;
export type UserMeLazyQueryHookResult = ReturnType<typeof useUserMeLazyQuery>;
export type UserMeSuspenseQueryHookResult = ReturnType<typeof useUserMeSuspenseQuery>;
export type UserMeQueryResult = Apollo.QueryResult<UserMeQuery, UserMeQueryVariables>;
export const UserExistsDocument = gql`
    query UserExists($input: UserExistsInput!) {
  userExists(input: $input)
}
    `;

/**
 * __useUserExistsQuery__
 *
 * To run a query within a React component, call `useUserExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserExistsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserExistsQuery(baseOptions: Apollo.QueryHookOptions<UserExistsQuery, UserExistsQueryVariables> & ({ variables: UserExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
      }
export function useUserExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserExistsQuery, UserExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
        }
export function useUserExistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserExistsQuery, UserExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserExistsQuery, UserExistsQueryVariables>(UserExistsDocument, options);
        }
export type UserExistsQueryHookResult = ReturnType<typeof useUserExistsQuery>;
export type UserExistsLazyQueryHookResult = ReturnType<typeof useUserExistsLazyQuery>;
export type UserExistsSuspenseQueryHookResult = ReturnType<typeof useUserExistsSuspenseQuery>;
export type UserExistsQueryResult = Apollo.QueryResult<UserExistsQuery, UserExistsQueryVariables>;
export const SignUpDocument = gql`
    mutation SignUp($input: SignUpInput!) {
  signUp(input: $input)
}
    `;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const SalesDemoSignUpDocument = gql`
    mutation SalesDemoSignUp($input: SignUpInput!) {
  salesDemoSignUp(input: $input)
}
    `;
export type SalesDemoSignUpMutationFn = Apollo.MutationFunction<SalesDemoSignUpMutation, SalesDemoSignUpMutationVariables>;

/**
 * __useSalesDemoSignUpMutation__
 *
 * To run a mutation, you first call `useSalesDemoSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesDemoSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesDemoSignUpMutation, { data, loading, error }] = useSalesDemoSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalesDemoSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SalesDemoSignUpMutation, SalesDemoSignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesDemoSignUpMutation, SalesDemoSignUpMutationVariables>(SalesDemoSignUpDocument, options);
      }
export type SalesDemoSignUpMutationHookResult = ReturnType<typeof useSalesDemoSignUpMutation>;
export type SalesDemoSignUpMutationResult = Apollo.MutationResult<SalesDemoSignUpMutation>;
export type SalesDemoSignUpMutationOptions = Apollo.BaseMutationOptions<SalesDemoSignUpMutation, SalesDemoSignUpMutationVariables>;
export const ChangeEmailDocument = gql`
    mutation ChangeEmail($input: ChangeEmailInput!) {
  changeEmail(input: $input) {
    ...UserInfo
  }
}
    ${UserInfoFragmentDoc}`;
export type ChangeEmailMutationFn = Apollo.MutationFunction<ChangeEmailMutation, ChangeEmailMutationVariables>;

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailMutation, { data, loading, error }] = useChangeEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEmailMutation, ChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEmailMutation, ChangeEmailMutationVariables>(ChangeEmailDocument, options);
      }
export type ChangeEmailMutationHookResult = ReturnType<typeof useChangeEmailMutation>;
export type ChangeEmailMutationResult = Apollo.MutationResult<ChangeEmailMutation>;
export type ChangeEmailMutationOptions = Apollo.BaseMutationOptions<ChangeEmailMutation, ChangeEmailMutationVariables>;
export const UpdateCompanyBillingDataDocument = gql`
    mutation UpdateCompanyBillingData($input: UpdateCompanyBillingDataInput!) {
  updateCompanyBillingData(input: $input) {
    ...UserInfo
  }
}
    ${UserInfoFragmentDoc}`;
export type UpdateCompanyBillingDataMutationFn = Apollo.MutationFunction<UpdateCompanyBillingDataMutation, UpdateCompanyBillingDataMutationVariables>;

/**
 * __useUpdateCompanyBillingDataMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyBillingDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyBillingDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyBillingDataMutation, { data, loading, error }] = useUpdateCompanyBillingDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyBillingDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyBillingDataMutation, UpdateCompanyBillingDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyBillingDataMutation, UpdateCompanyBillingDataMutationVariables>(UpdateCompanyBillingDataDocument, options);
      }
export type UpdateCompanyBillingDataMutationHookResult = ReturnType<typeof useUpdateCompanyBillingDataMutation>;
export type UpdateCompanyBillingDataMutationResult = Apollo.MutationResult<UpdateCompanyBillingDataMutation>;
export type UpdateCompanyBillingDataMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyBillingDataMutation, UpdateCompanyBillingDataMutationVariables>;
export const RequestChangeEmailDocument = gql`
    mutation RequestChangeEmail($emailToChange: String!) {
  requestChangeEmail(emailToChange: $emailToChange)
}
    `;
export type RequestChangeEmailMutationFn = Apollo.MutationFunction<RequestChangeEmailMutation, RequestChangeEmailMutationVariables>;

/**
 * __useRequestChangeEmailMutation__
 *
 * To run a mutation, you first call `useRequestChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestChangeEmailMutation, { data, loading, error }] = useRequestChangeEmailMutation({
 *   variables: {
 *      emailToChange: // value for 'emailToChange'
 *   },
 * });
 */
export function useRequestChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<RequestChangeEmailMutation, RequestChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestChangeEmailMutation, RequestChangeEmailMutationVariables>(RequestChangeEmailDocument, options);
      }
export type RequestChangeEmailMutationHookResult = ReturnType<typeof useRequestChangeEmailMutation>;
export type RequestChangeEmailMutationResult = Apollo.MutationResult<RequestChangeEmailMutation>;
export type RequestChangeEmailMutationOptions = Apollo.BaseMutationOptions<RequestChangeEmailMutation, RequestChangeEmailMutationVariables>;
export const ConfirmChangeEmailDocument = gql`
    mutation ConfirmChangeEmail($changeEmailToken: String!) {
  confirmChangeEmail(changeEmailToken: $changeEmailToken)
}
    `;
export type ConfirmChangeEmailMutationFn = Apollo.MutationFunction<ConfirmChangeEmailMutation, ConfirmChangeEmailMutationVariables>;

/**
 * __useConfirmChangeEmailMutation__
 *
 * To run a mutation, you first call `useConfirmChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmChangeEmailMutation, { data, loading, error }] = useConfirmChangeEmailMutation({
 *   variables: {
 *      changeEmailToken: // value for 'changeEmailToken'
 *   },
 * });
 */
export function useConfirmChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmChangeEmailMutation, ConfirmChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmChangeEmailMutation, ConfirmChangeEmailMutationVariables>(ConfirmChangeEmailDocument, options);
      }
export type ConfirmChangeEmailMutationHookResult = ReturnType<typeof useConfirmChangeEmailMutation>;
export type ConfirmChangeEmailMutationResult = Apollo.MutationResult<ConfirmChangeEmailMutation>;
export type ConfirmChangeEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmChangeEmailMutation, ConfirmChangeEmailMutationVariables>;
export const AddUserActionLogDocument = gql`
    mutation AddUserActionLog($input: UserActionLogInput!) {
  addUserActionLog(input: $input) {
    ...UserActionLogInfo
  }
}
    ${UserActionLogInfoFragmentDoc}`;
export type AddUserActionLogMutationFn = Apollo.MutationFunction<AddUserActionLogMutation, AddUserActionLogMutationVariables>;

/**
 * __useAddUserActionLogMutation__
 *
 * To run a mutation, you first call `useAddUserActionLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserActionLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserActionLogMutation, { data, loading, error }] = useAddUserActionLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserActionLogMutation(baseOptions?: Apollo.MutationHookOptions<AddUserActionLogMutation, AddUserActionLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserActionLogMutation, AddUserActionLogMutationVariables>(AddUserActionLogDocument, options);
      }
export type AddUserActionLogMutationHookResult = ReturnType<typeof useAddUserActionLogMutation>;
export type AddUserActionLogMutationResult = Apollo.MutationResult<AddUserActionLogMutation>;
export type AddUserActionLogMutationOptions = Apollo.BaseMutationOptions<AddUserActionLogMutation, AddUserActionLogMutationVariables>;
export const UserVenuesByNameDocument = gql`
    query UserVenuesByName($venueName: String!) {
  userVenuesByName(venueName: $venueName) {
    ...VenueInfo
  }
}
    ${VenueInfoFragmentDoc}`;

/**
 * __useUserVenuesByNameQuery__
 *
 * To run a query within a React component, call `useUserVenuesByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserVenuesByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserVenuesByNameQuery({
 *   variables: {
 *      venueName: // value for 'venueName'
 *   },
 * });
 */
export function useUserVenuesByNameQuery(baseOptions: Apollo.QueryHookOptions<UserVenuesByNameQuery, UserVenuesByNameQueryVariables> & ({ variables: UserVenuesByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserVenuesByNameQuery, UserVenuesByNameQueryVariables>(UserVenuesByNameDocument, options);
      }
export function useUserVenuesByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserVenuesByNameQuery, UserVenuesByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserVenuesByNameQuery, UserVenuesByNameQueryVariables>(UserVenuesByNameDocument, options);
        }
export function useUserVenuesByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserVenuesByNameQuery, UserVenuesByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserVenuesByNameQuery, UserVenuesByNameQueryVariables>(UserVenuesByNameDocument, options);
        }
export type UserVenuesByNameQueryHookResult = ReturnType<typeof useUserVenuesByNameQuery>;
export type UserVenuesByNameLazyQueryHookResult = ReturnType<typeof useUserVenuesByNameLazyQuery>;
export type UserVenuesByNameSuspenseQueryHookResult = ReturnType<typeof useUserVenuesByNameSuspenseQuery>;
export type UserVenuesByNameQueryResult = Apollo.QueryResult<UserVenuesByNameQuery, UserVenuesByNameQueryVariables>;
export const EditVenueDocument = gql`
    mutation EditVenue($input: EditVenueInput!) {
  editVenue(input: $input) {
    ...VenueInfo
  }
}
    ${VenueInfoFragmentDoc}`;
export type EditVenueMutationFn = Apollo.MutationFunction<EditVenueMutation, EditVenueMutationVariables>;

/**
 * __useEditVenueMutation__
 *
 * To run a mutation, you first call `useEditVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVenueMutation, { data, loading, error }] = useEditVenueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditVenueMutation(baseOptions?: Apollo.MutationHookOptions<EditVenueMutation, EditVenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVenueMutation, EditVenueMutationVariables>(EditVenueDocument, options);
      }
export type EditVenueMutationHookResult = ReturnType<typeof useEditVenueMutation>;
export type EditVenueMutationResult = Apollo.MutationResult<EditVenueMutation>;
export type EditVenueMutationOptions = Apollo.BaseMutationOptions<EditVenueMutation, EditVenueMutationVariables>;
export const UserVenuesDocument = gql`
    query UserVenues($input: UserVenuesInput!) {
  userVenues(input: $input) {
    edges {
      node {
        ...VenueInfo
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${VenueInfoFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useUserVenuesQuery__
 *
 * To run a query within a React component, call `useUserVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserVenuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserVenuesQuery(baseOptions: Apollo.QueryHookOptions<UserVenuesQuery, UserVenuesQueryVariables> & ({ variables: UserVenuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserVenuesQuery, UserVenuesQueryVariables>(UserVenuesDocument, options);
      }
export function useUserVenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserVenuesQuery, UserVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserVenuesQuery, UserVenuesQueryVariables>(UserVenuesDocument, options);
        }
export function useUserVenuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserVenuesQuery, UserVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserVenuesQuery, UserVenuesQueryVariables>(UserVenuesDocument, options);
        }
export type UserVenuesQueryHookResult = ReturnType<typeof useUserVenuesQuery>;
export type UserVenuesLazyQueryHookResult = ReturnType<typeof useUserVenuesLazyQuery>;
export type UserVenuesSuspenseQueryHookResult = ReturnType<typeof useUserVenuesSuspenseQuery>;
export type UserVenuesQueryResult = Apollo.QueryResult<UserVenuesQuery, UserVenuesQueryVariables>;
export const SearchVenuesDocument = gql`
    query SearchVenues($input: SearchVenuesInput!) {
  searchVenues(input: $input) {
    ...VenueInfo
  }
}
    ${VenueInfoFragmentDoc}`;

/**
 * __useSearchVenuesQuery__
 *
 * To run a query within a React component, call `useSearchVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVenuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchVenuesQuery(baseOptions: Apollo.QueryHookOptions<SearchVenuesQuery, SearchVenuesQueryVariables> & ({ variables: SearchVenuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchVenuesQuery, SearchVenuesQueryVariables>(SearchVenuesDocument, options);
      }
export function useSearchVenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchVenuesQuery, SearchVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchVenuesQuery, SearchVenuesQueryVariables>(SearchVenuesDocument, options);
        }
export function useSearchVenuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchVenuesQuery, SearchVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchVenuesQuery, SearchVenuesQueryVariables>(SearchVenuesDocument, options);
        }
export type SearchVenuesQueryHookResult = ReturnType<typeof useSearchVenuesQuery>;
export type SearchVenuesLazyQueryHookResult = ReturnType<typeof useSearchVenuesLazyQuery>;
export type SearchVenuesSuspenseQueryHookResult = ReturnType<typeof useSearchVenuesSuspenseQuery>;
export type SearchVenuesQueryResult = Apollo.QueryResult<SearchVenuesQuery, SearchVenuesQueryVariables>;
export const VenueByIdDocument = gql`
    query VenueById($venueId: Int!) {
  venueById(venueId: $venueId) {
    ...VenueInfo
  }
}
    ${VenueInfoFragmentDoc}`;

/**
 * __useVenueByIdQuery__
 *
 * To run a query within a React component, call `useVenueByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueByIdQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueByIdQuery(baseOptions: Apollo.QueryHookOptions<VenueByIdQuery, VenueByIdQueryVariables> & ({ variables: VenueByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueByIdQuery, VenueByIdQueryVariables>(VenueByIdDocument, options);
      }
export function useVenueByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueByIdQuery, VenueByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueByIdQuery, VenueByIdQueryVariables>(VenueByIdDocument, options);
        }
export function useVenueByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueByIdQuery, VenueByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueByIdQuery, VenueByIdQueryVariables>(VenueByIdDocument, options);
        }
export type VenueByIdQueryHookResult = ReturnType<typeof useVenueByIdQuery>;
export type VenueByIdLazyQueryHookResult = ReturnType<typeof useVenueByIdLazyQuery>;
export type VenueByIdSuspenseQueryHookResult = ReturnType<typeof useVenueByIdSuspenseQuery>;
export type VenueByIdQueryResult = Apollo.QueryResult<VenueByIdQuery, VenueByIdQueryVariables>;
export const VenueDashboardMetricsByVenueIdDocument = gql`
    query VenueDashboardMetricsByVenueId($venueId: Int!) {
  venueDashboardMetricsByVenueId(venueId: $venueId) {
    type
    label
    value
  }
}
    `;

/**
 * __useVenueDashboardMetricsByVenueIdQuery__
 *
 * To run a query within a React component, call `useVenueDashboardMetricsByVenueIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueDashboardMetricsByVenueIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueDashboardMetricsByVenueIdQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueDashboardMetricsByVenueIdQuery(baseOptions: Apollo.QueryHookOptions<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables> & ({ variables: VenueDashboardMetricsByVenueIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables>(VenueDashboardMetricsByVenueIdDocument, options);
      }
export function useVenueDashboardMetricsByVenueIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables>(VenueDashboardMetricsByVenueIdDocument, options);
        }
export function useVenueDashboardMetricsByVenueIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables>(VenueDashboardMetricsByVenueIdDocument, options);
        }
export type VenueDashboardMetricsByVenueIdQueryHookResult = ReturnType<typeof useVenueDashboardMetricsByVenueIdQuery>;
export type VenueDashboardMetricsByVenueIdLazyQueryHookResult = ReturnType<typeof useVenueDashboardMetricsByVenueIdLazyQuery>;
export type VenueDashboardMetricsByVenueIdSuspenseQueryHookResult = ReturnType<typeof useVenueDashboardMetricsByVenueIdSuspenseQuery>;
export type VenueDashboardMetricsByVenueIdQueryResult = Apollo.QueryResult<VenueDashboardMetricsByVenueIdQuery, VenueDashboardMetricsByVenueIdQueryVariables>;
export const VenueCategoriesDocument = gql`
    query VenueCategories($region: Region!) {
  venueCategories(region: $region)
}
    `;

/**
 * __useVenueCategoriesQuery__
 *
 * To run a query within a React component, call `useVenueCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueCategoriesQuery({
 *   variables: {
 *      region: // value for 'region'
 *   },
 * });
 */
export function useVenueCategoriesQuery(baseOptions: Apollo.QueryHookOptions<VenueCategoriesQuery, VenueCategoriesQueryVariables> & ({ variables: VenueCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueCategoriesQuery, VenueCategoriesQueryVariables>(VenueCategoriesDocument, options);
      }
export function useVenueCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueCategoriesQuery, VenueCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueCategoriesQuery, VenueCategoriesQueryVariables>(VenueCategoriesDocument, options);
        }
export function useVenueCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueCategoriesQuery, VenueCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueCategoriesQuery, VenueCategoriesQueryVariables>(VenueCategoriesDocument, options);
        }
export type VenueCategoriesQueryHookResult = ReturnType<typeof useVenueCategoriesQuery>;
export type VenueCategoriesLazyQueryHookResult = ReturnType<typeof useVenueCategoriesLazyQuery>;
export type VenueCategoriesSuspenseQueryHookResult = ReturnType<typeof useVenueCategoriesSuspenseQuery>;
export type VenueCategoriesQueryResult = Apollo.QueryResult<VenueCategoriesQuery, VenueCategoriesQueryVariables>;
export const VenueSettingsByIdDocument = gql`
    query VenueSettingsById($venueId: Int!) {
  venueSettingsByVenueId(venueId: $venueId) {
    ...VenueSettingsInfo
  }
}
    ${VenueSettingsInfoFragmentDoc}`;

/**
 * __useVenueSettingsByIdQuery__
 *
 * To run a query within a React component, call `useVenueSettingsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVenueSettingsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVenueSettingsByIdQuery({
 *   variables: {
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useVenueSettingsByIdQuery(baseOptions: Apollo.QueryHookOptions<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables> & ({ variables: VenueSettingsByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables>(VenueSettingsByIdDocument, options);
      }
export function useVenueSettingsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables>(VenueSettingsByIdDocument, options);
        }
export function useVenueSettingsByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables>(VenueSettingsByIdDocument, options);
        }
export type VenueSettingsByIdQueryHookResult = ReturnType<typeof useVenueSettingsByIdQuery>;
export type VenueSettingsByIdLazyQueryHookResult = ReturnType<typeof useVenueSettingsByIdLazyQuery>;
export type VenueSettingsByIdSuspenseQueryHookResult = ReturnType<typeof useVenueSettingsByIdSuspenseQuery>;
export type VenueSettingsByIdQueryResult = Apollo.QueryResult<VenueSettingsByIdQuery, VenueSettingsByIdQueryVariables>;
export const EditVenueSettingsDocument = gql`
    mutation EditVenueSettings($input: EditVenueSettingsInput!) {
  editVenueSettings(input: $input) {
    ...VenueSettingsInfo
  }
}
    ${VenueSettingsInfoFragmentDoc}`;
export type EditVenueSettingsMutationFn = Apollo.MutationFunction<EditVenueSettingsMutation, EditVenueSettingsMutationVariables>;

/**
 * __useEditVenueSettingsMutation__
 *
 * To run a mutation, you first call `useEditVenueSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVenueSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVenueSettingsMutation, { data, loading, error }] = useEditVenueSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditVenueSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditVenueSettingsMutation, EditVenueSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVenueSettingsMutation, EditVenueSettingsMutationVariables>(EditVenueSettingsDocument, options);
      }
export type EditVenueSettingsMutationHookResult = ReturnType<typeof useEditVenueSettingsMutation>;
export type EditVenueSettingsMutationResult = Apollo.MutationResult<EditVenueSettingsMutation>;
export type EditVenueSettingsMutationOptions = Apollo.BaseMutationOptions<EditVenueSettingsMutation, EditVenueSettingsMutationVariables>;
export const SearchWholesalersDocument = gql`
    query SearchWholesalers($input: WholesalerSearchInput!) {
  searchWholesalers(input: $input) {
    edges {
      node {
        ...WholesalerInfo
      }
      cursor
    }
    pageInfo {
      ...CursorPageInfo
    }
    totalCount
  }
}
    ${WholesalerInfoFragmentDoc}
${CursorPageInfoFragmentDoc}`;

/**
 * __useSearchWholesalersQuery__
 *
 * To run a query within a React component, call `useSearchWholesalersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWholesalersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWholesalersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchWholesalersQuery(baseOptions: Apollo.QueryHookOptions<SearchWholesalersQuery, SearchWholesalersQueryVariables> & ({ variables: SearchWholesalersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchWholesalersQuery, SearchWholesalersQueryVariables>(SearchWholesalersDocument, options);
      }
export function useSearchWholesalersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchWholesalersQuery, SearchWholesalersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchWholesalersQuery, SearchWholesalersQueryVariables>(SearchWholesalersDocument, options);
        }
export function useSearchWholesalersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchWholesalersQuery, SearchWholesalersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchWholesalersQuery, SearchWholesalersQueryVariables>(SearchWholesalersDocument, options);
        }
export type SearchWholesalersQueryHookResult = ReturnType<typeof useSearchWholesalersQuery>;
export type SearchWholesalersLazyQueryHookResult = ReturnType<typeof useSearchWholesalersLazyQuery>;
export type SearchWholesalersSuspenseQueryHookResult = ReturnType<typeof useSearchWholesalersSuspenseQuery>;
export type SearchWholesalersQueryResult = Apollo.QueryResult<SearchWholesalersQuery, SearchWholesalersQueryVariables>;